var console = window.console || {
    log : function() {
    },
    info : function() {
    },
    warn : function() {
    },
    error : function() {
    }
};

// 바로구매 장바구니에서 프로모션 자세히보기레이어의 장바구니 버튼을 눌렀을때 응답 카트번호 저장
var cartNosForDirectCart = "";
var beautyLoginCnt = sessionStorage.getItem("lCnt");
var optionScrollTop = 0;
var giftPlusItemYn = "";
var recoCart = "N";
var callOrg = "";
var giftTrackCode = "";
var recoRcCode = "";
//3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건
var rcvStr = ''; //전달받는 처리 유형
var rcvObj = ''; //전달받는 속성 Object

// 오특 타이머 Interval
var todaySpecialInterval = 0;
var newGoodsTodaySpecialInterval = 0;
var goodsTodaySpecialInterval = 0;
var mainTodaySpecialInterval = 0;
var commonTimerInterval = 0;

// 공통 타이머
var commonTimer = {
    hours : '00',
    minutes : '00',
    seconds : '00'
};

var STORAGE_KEY = {
    SESSION: {
        CALL_BRAZE_MAIN_YN: "callBrazeMainYn",
        WCARE_ENTER_YN: "wcareEnterYn",
        LIVE_NUDGE_SKIP_YN: "liveNudgeSkip"
    },
    LOCAL: {
        IS_ACCESSED_FOR_BRAZE_POPUP: 'iafbp'
    }
}

// [CJOYCOMD-1722] 검증용 임시: logout.do 발화원 진단 — 최종 사람 손(터치/클릭) 감지기. 운영 반영 전 제거 대상
// 수집 정보는 tagName + id/첫 클래스 요약(30자 제한)만 — 텍스트/입력값 수집 절대 금지(개인정보 차단)
try {
    var __oyDiagRecordTouch = function(event) {
        try {
            var diagTarget = event.target;
            var diagSummary = (diagTarget && diagTarget.tagName) ? diagTarget.tagName : 'unknown';
            if (diagTarget && diagTarget.id) {
                diagSummary += '#' + diagTarget.id;
            } else if (diagTarget && diagTarget.classList && diagTarget.classList.length > 0) {
                diagSummary += '.' + diagTarget.classList[0];
            }
            window.__oyLastTouch = { t: Date.now(), s: diagSummary.substring(0, 30) };
        } catch (ignore) {}
    };
    document.addEventListener('touchstart', __oyDiagRecordTouch, true);
    document.addEventListener('click', __oyDiagRecordTouch, true);
    // 헬퍼: 최종 터치로부터의 경과 ms + 터치 대상 요약 반환 (터치 기록 없으면 na_na). encodeURIComponent는 사용처에서 수행
    window.__oyDiagLc = function() {
        try {
            if (!window.__oyLastTouch) {
                return 'na_na';
            }
            return (Date.now() - window.__oyLastTouch.t) + '_' + window.__oyLastTouch.s;
        } catch (ignore) {
            return 'err_err';
        }
    };
} catch (ignore) {}




$.namespace = function() {
    var a = arguments, o = null, i, j, d;
    for (i = 0; i < a.length; i = i + 1) {
        d = a[i].split(".");
        o = window;
        for (j = 0; j < d.length; j = j + 1) {
            o[d[j]] = o[d[j]] || {};
            o = o[d[j]];
        }
    }
    return o;
}

$.namespace("common");
common = {
    scrollPos : 0,

    getPageName() {
        if(document.title.indexOf(" | 올리브영") !== -1) {
            return document.title.replace(" | 올리브영", "").replaceAll(" ","");
        } else {
            return "홈";
        }
    },

    cannotAccess : function() {
        alert('접근할 수 없습니다. 권한이 부족합니다.');
    },
    safetyDecodeUriComponent: function (str) {
        try {
            return decodeURIComponent(str);
        } catch (err) {
            return str;
        }
    },
    /**
     * 앰플리튜드 이벤트 트래킹
     * @param eventName {string} 이벤트 이름
     * @param amplitudeTrackingInfo {{entry_source: string, click_source: string, profile_name?: string, review_rank?: string, filter_type?: string, follow_type?: string, product_number?: string, product_name?: string, collection_name?: string, collection_number?: string}?} 이벤트 정보
     */
    reqAmplitude: function(eventName, amplitudeTrackingInfo) {
        try {
            var reqAmplitudeParam = null;
            if(amplitudeTrackingInfo) {
                reqAmplitudeParam = amplitudeTrackingInfo;
            } else {
                reqAmplitudeParam = getEventParameterObject();
            }
            if($.isEmptyObject(reqAmplitudeParam) || !eventName) {
                return;
            }
            callLogEvent(eventName, reqAmplitudeParam);
        } catch(e) {
            void 0;
        }
    },
    getCookie(name) {
        var nameOfCookie = name + "=";
        var x = 0;
        while (x <= document.cookie.length) {
            var y = (x + nameOfCookie.length);
            if (document.cookie.substring(x, y) == nameOfCookie) {
                if ((endOfCookie = document.cookie.indexOf(";", y)) == -1)
                    endOfCookie = document.cookie.length;
                return unescape(document.cookie.substring(y, endOfCookie));
            }
            x = document.cookie.indexOf(" ", x) + 1;
            if (x == 0)
                break;
        }
        return "";
    },
    validateFieldNotEmpty : function(id, message) {
        var loginId = $(id).val();
        if ($.trim(loginId) == '') {
            alert(message);
            return false;
        }

        return true;
    },
    convertSystemToJtmpl : function(str) {
        if (str) {
            str = str.replace(/\n/gi, "<br/>");
            str = str.replace(/ /gi, "&nbsp;");
            return str;
        }
    },
    splitToEnterKey : function(str) {
        if (str) {
            var patt = /\n/g;

            if (patt.test(str)) {
                str = str.split(/\r|\n/)[0];
            }
            return str;
        }
    },

    memJoinEvtNo : function() {

        var evtNo = "";
        var url= _baseUrl + "event/getAgreeTermEventInfoAjax.do";

        $.ajax({
            type: "POST",
            url: url,
            data: null,
            dataType : 'json',
            success: function(data) {
                if(data.result){
                    evtNo = data.evtNo;
                }
            }
        });

        return evtNo;
    },

    sessionClear : function() {
        var url = _baseUrl + "login/sessionClear.do";
        common.Ajax.getAjaxObj("POST", url, "");
        void 0;
    },

    loginChkForEvt : function(){
        var url= _baseUrl + "login/loginCheckJson.do";
        var loginResult = false;

        $.ajax({
            type: "POST",
            url: url,
            data: null,
            dataType : 'json',
            async: false,
            cache: false,
            success: function(data) {

                if(!data.result && data.url!=null){
                    window.location.href = _secureUrl + data.url + "?redirectUrl=" + encodeURIComponent(location.href);
                }

                loginResult = data.result;
            },
            error : function(a, b, c) {
                void 0;
                void 0;
                void 0;
            }
        });

        return loginResult;
    },

    isLoginForEvt : function(){
        var url= _baseUrl + "login/loginCheckJson.do";
        var loginResult = false;

        $.ajax({
            type: "POST",
            url: url,
            data: null,
            dataType : 'json',
            async: false,
            cache: false,
            success: function(data) {
                loginResult = data.result;
                sessionStorage.setItem("checkLoginStatus", data.result);
            },
            error : function() {
                loginResult = false;
                sessionStorage.removeItem("checkLoginStatus");
            }
        });

        return loginResult;
    },

    loginChk : function(){

        /* 3273769 로그인체크 중복 제거 추가 진행 요청
         * "login/loginCheckJson.do" 중복 호출을 막기 위한 SessionStorage내, checkLoginStatus등록
         * 만약 checkLoginStatus내에 값이 존재할 경우, 값을 반환한다.
         * false일 경우에는 checkLoginStatus값을 제거한다.
         */
    	var url= _baseUrl + "login/loginCheckJson.do";
    	var loginResult = false;
        var checkLoginStatus = sessionStorage.getItem("checkLoginStatus");
        if(checkLoginStatus == null || checkLoginStatus == "undefined"){


	        $.ajax({
	            type: "POST",
	            url: url,
	            data: null,
	            dataType : 'json',
	            async: false,
	            cache: false,
	            success: function(data) {

	                if(!data.result && data.url!=null){
	                    window.location.href = _secureUrl + data.url + "?redirectUrl=" + encodeURIComponent(location.href);
	                }

	                loginResult = data.result;
	            },
	            error : function(a, b, c) {
	                void 0;
	                void 0;
	                void 0;
	            }
	        });
        }else{
        	loginResult = JSON.parse(sessionStorage.getItem("checkLoginStatus"));
        	if(loginResult == false || loginResult == "false"){
        		window.location.href = _secureUrl + "login/loginForm.do" + "?redirectUrl=" + encodeURIComponent(location.href);
        	}
        }
        return loginResult;
    },


    isLogin : function(__callbackForBraze){

        /* 3212592 12월올영세일_온라인몰 특이현상 점검 및 개선 요청의 件
         * "login/loginCheckJson.do" 중복 호출을 막기 위한 SessionStorage내, checkLoginStatus등록
         * 만약 checkLoginStatus내에 값이 존재할 경우, 값을 반환한다.
         * false일 경우에는 checkLoginStatus값을 제거한다.
         */

    	  var url= _baseUrl + "login/loginCheckJson.do";
        var loginResult = false;

        var checkLoginStatus = sessionStorage.getItem("checkLoginStatus");
        if(checkLoginStatus == null || checkLoginStatus == "undefined"){

            $.ajax({
                type: "GET",
                url: url,
                data: null,
                dataType : 'json',
                async: false,
                cache: false,
                timeout: 3000,
                success: function(data) {
                    loginResult = data.result;
                    sessionStorage.setItem("checkLoginStatus", data.result);

                    if(!loginResult) {
                        return;
                    }
                    if(__callbackForBraze !== undefined) {
                        __callbackForBraze();
                    }
                },
                error : function() {
                    loginResult = false;
                    sessionStorage.removeItem("checkLoginStatus");
                }
            });
        }else{
        	loginResult = JSON.parse(sessionStorage.getItem("checkLoginStatus"));

        	if(loginResult != false ){
        		if(sessionStorage.getItem("byIsNotLoginFirPurBan") == "done"){
        			//비로그인 -> 로그인와서 처음 행위
        			sessionStorage.removeItem("firstPurchaseBanInfo");
        			sessionStorage.removeItem("byIsNotLoginFirPurBan");
        		}
        	}
        }
        return loginResult;
    },

    isBeautyLoginCnt : function(){
        /* 3273769 로그인체크 중복 제거 추가 진행 요청
         * "login/loginCheckJson.do" 중복 호출을 막기 위한 SessionStorage내, checkLoginStatus등록
         * 만약 checkLoginStatus내에 값이 존재할 경우, 값을 반환한다.
         * false일 경우에는 checkLoginStatus값을 제거한다.
         */
        var checkLoginStatus = sessionStorage.getItem("checkLoginStatus");

        var url= _baseUrl + "login/loginCheckJson.do";
        var loginResult = false;

        if(checkLoginStatus == null || checkLoginStatus == "undefined"){

        	$.ajax({
        		type: "POST",
        		url: url,
        		data: null,
        		dataType : 'json',
        		async: false,
        		cache: false,
        		success: function(data) {
        			beautyLoginCnt++;
        		},
        		error : function() {
        			beautyLoginCnt = 0;
        		}
        	});
        }else{
        	loginResult = JSON.parse(sessionStorage.getItem("checkLoginStatus"));
        	if(loginResult == true){//로그인 여부 확인
        		beautyLoginCnt++;
        	}else{
        		beautyLoginCnt = 0;
        	}
        }

        return beautyLoginCnt;
    },

    fileChk : function(file) {
        var maxSize = 5 * 1024 * 1024; // 5MB
        // var maxSize = 0 ;
        var fileFilter = /.(jpg|gif|png|jpeg)$/i;
        var fileType = "";
        var fileSize = 0;

        if (file != null && file != undefined) {
            for (i = 0; i < file.size(); i++) {
                if (file[i].value != "") {
                    fileType = file[i].files[0].name.slice(file[i].files[0].name.lastIndexOf("."));
                    fileSize = file[i].files[0].size;

                    /*
                     * console.log("파일["+i+"]>>"+file);
                     * console.log("파일Type["+i+"]>>"+fileType);
                     */

                    if (!fileType.match(fileFilter)) {
                        alert("등록할 수 없는 파일 형식입니다.");
                        return false;
                    }

                    if (fileSize > maxSize) {
                        alert("5MB미만의 이미지 파일만 첨부할 수 있습니다.");
                        return false;
                    }
                } else {
                    void 0;
                    return false;
                }
            }
            return true;
        }
    },
    getNowScroll : function() {
        var de = document.documentElement;
        var b = document.body;
        var now = {};
        now.X = document.all ? (!de.scrollLeft ? b.scrollLeft : de.scrollLeft)
                : (window.pageXOffset ? window.pageXOffset : window.scrollX);
        now.Y = document.all ? (!de.scrollTop ? b.scrollTop : de.scrollTop) : (window.pageYOffset ? window.pageYOffset
                : window.scrollY);
        return now;
    },
    isEmpty : function(obj) {
        if (Array.isArray(obj)) {
            return !obj.length;
        }
        else if (typeof obj === 'object') {
            return !obj || !Object.keys(obj).length;
        }
        else if (typeof obj === 'string') {
            return !obj || obj === 'undefined' || obj === 'null';
        }
        else if (typeof obj === 'number') {
            return false;
        }
        return !obj;
    },
    /**
     * Validation 처리를 위한 Object
     */
    Validator : {
        /**
         * common.Validator.isNumber()
         *
         * 해당 필드 값이 숫자인지 여부를 검사 함.
         *
         * 사용 예) common.Validator.isNumber("#elId", "값을 확인 하세요."); 일때 다음의 동작 실행
         * if($("#elId").val() != 숫자) { alert("값을 확인 하세요."); $("#elId").focus(); }
         *
         *
         *
         * @param jqPath :
         *            Element의 Jquery Path
         * @param message :
         *            입력값 오류일때 표시할 Message 값
         *
         * @return true(정상) or false(오류)
         *
         *
         */
        isNumber : function(jqPath, message) {
            var obj = $(jqPath);
            var value = obj.val();
            var isNumber = value.isNumber();
            if (!(isNumber)) {
                alert(message);
                obj.focus();
            }
            return isNumber;
        }
    },
    /**
     * timeStamp 데이타를 날짜 포맷으로 변환
     */
    formatDate : function(timeStamp, format) {
        var newDate = new Date();
        newDate.setTime(timeStamp);
        var formatDate = newDate.format(format);

        return formatDate;
    },
    checkTxtParticle : function(txt, exist, notExist) {
    	if(common.isEmpty(txt)) {
    		return "";
    	}

    	var lastChar = txt.charCodeAt(txt.length - 1);

    	return (lastChar - 0xAC00) % 28 > 0 ? exist : notExist;
    },
    loadingLayerIntervalId : 0,

    showLoadingLayer : function() {
        if ($("#mLoading").length > 0) {
            return;
        }

        // var loadingHtml = "<div id=\"mLoading\"><span class=\"loading_ico\" style=\"background-image: url('" + _imgUrl + "comm/loading.gif')\">로딩중</span></div>";
        var loadingHtml = "<div id=\"mLoading\"><span class=\"loading_ico\">로딩중</span></div>";
        $("body").append(loadingHtml);

        setTimeout(function() {
            common.hideLoadingLayer();
        }, 15000);
    },

    hideLoadingLayer : function() {
        // if (common.app.appInfo != undefined && common.app.appInfo.isapp) {
        // setTimeout(function() {
        // //앱인 경우 앱에서 띄우도록 함
        // common.app.callShowLoadingBar("N");
        // }, 500);
        // return;
        // }

        if ($("#mLoading").length < 1) {
            return;
        }

        setTimeout(function() {
            clearInterval(common.loadingLayerIntervalId);
            $("#mLoading").remove();
        }, 300);
    },
    // showLoadingLayer : function(isOpacity) {
    //
    // // if (common.app.appInfo != undefined && common.app.appInfo.isapp) {
    // // //앱인 경우 앱에서 띄우도록 함
    // // common.app.callShowLoadingBar("Y");
    // // return;
    // // }
    //
    // if ($("#mLoading").length > 0) {
    // return;
    // }
    //
    // var style = "";
    // if (isOpacity == false) {
    // style = " style=\"opacity:0;\"";
    // }
    //
    // var loadingHtml = "<div id=\"mLoading\"><span class=\"loading_ico\"><img
    // src=\"" + _imgUrl + "comm/loading_64x64.gif\"/></span><div class=\"dim\""
    // + style + "></div></div>";
    // $("body").append(loadingHtml);
    //
    //
    // },
    //
    // hideLoadingLayer : function() {
    // // if (common.app.appInfo != undefined && common.app.appInfo.isapp) {
    // // setTimeout(function() {
    // // //앱인 경우 앱에서 띄우도록 함
    // // common.app.callShowLoadingBar("N");
    // // }, 500);
    // // return;
    // // }
    //
    // if ($("#mLoading").length < 1) {
    // return;
    // }
    //
    // setTimeout(function() {
    // $("#mLoading").remove();
    // }, 500);
    // },

    popupCallback : '',

    popFullOpen : function(title, _popCallback) {
        $(window).scrollTop(0.0); // 추가부분

        $('#pop-full-title').html(title);
        $('body').css({
            'background-color' : '#fff'
        }); /* 2016-12-12 퍼블리싱 수정 반영 */
        $('#pop-full-wrap').show();
        $('#mWrapper').hide();

        this.popupCallback = _popCallback;
    },

    popFullClose : function() {
        $('body').css({
            'background-color' : '#eee'
        }); /* 2016-12-12 퍼블리싱 수정 반영 */
        $('.popFullWrap').hide();
        $('.popFullWrap').removeClass('outline');// 쿠폰 하이라이트 제거
        $('#mWrapper').show();

        window.scroll(0, common.scrollPos);

        // 웹 접근성 popfocus 삭제( 2017-05-11 )
        $("a[data-focus~=on]").focus(); // 표시해둔 곳으로 초점 이동
        $("button[data-focus~=on]").focus(); // 표시해둔 곳으로 초점 이동
        window.setTimeout(function() {
            $("a[data-focus~=on]").removeAttr("data-focus");
            $("button[data-focus~=on]").removeAttr("data-focus");
            var lyLocalScroll = localStorage.getItem('lyScrollSet');
            if (lyLocalScroll != null) {
                $(document).scrollTop(lyLocalScroll);
                localStorage.removeItem('lyScrollSet');
            }
        }, 100); //

        if (this.popupCallback == '' || typeof this.popupCallback != 'function')
            return;

        this.popupCallback();
    },

    popLayerOpen : function(IdName) {

        sessionStorage.setItem("scrollY_popLayer", common.getNowScroll().Y);
        void 0;

        var winH = $(window).height() / 2;
        var popLayer = ('#' + IdName);
        $(popLayer).find('.popCont').css({
            'max-height' : winH
        });

        var popPos = $(popLayer).height() / 2;
        var popWid = $(popLayer).width() / 2;


        $(popLayer).css({
            'left' : '50%',
            'margin-left' : -(popWid),
            'top' : '50%',
            'margin-top' : -(popPos)
        }).show()/*.parents('body').css({
            'overflow' : 'hidden'
        });*/
        $('.dim').show();

        $('.dim').bind('click', function() {
            common.popLayerClose(IdName);
        });
        // 가세로 변경
        if (IdName !== 'PresentPopup') {
            $(window).resize(function () {
                winH = $(window).height() / 2;
                $(popLayer).find('.popCont').css({
                    'max-height': winH
                });
                popPos = $(popLayer).height() / 2;
                popWid = $(popLayer).width() / 2;
                $(popLayer).css({
                    'left': '50%',
                    'margin-left': -(popWid),
                    'top': '50%',
                    'margin-top': -(popPos)
                })
            });
        }
        // sns 별도처리
        if (IdName == 'SNSLAYER') {
            $(popLayer).css({
                'left' : '0',
                'margin-left' : '0'
            })
        }
        ;

        $("body").css("overflow", "inherit!important");

        // 앱 호출
        common.app.callMenu("Y", 100);
    },

    /* 0001063: MO_상품 상세 페이지 > 레이어창 팝업시 화면 밀림 현상 */
    popLayerOpen2 : function(IdName) {

        sessionStorage.setItem("scrollY_popLayer", common.getNowScroll().Y);
        void 0;

        if($('#toprvPoph').length > 0){
        	winH = $(window).height() / 2;
        }else{
        	var winH = $(window).height()-100;
        }//탑리뷰어 레이어 높이 조정 2020.07.09

        //var winH = $(window).height() / 2;
        //var winH = $(window).height()-100; //레이어 팝업 높이 계산 수정 2020.06.24

        var popLayer = ('#' + IdName);
        var popInHd = $(popLayer).find('.popHeader').innerHeight();
        var winH_type = $(window).height() - (popInHd + 40);
        var popContCls = $(popLayer).find('.popCont');

        if (popContCls.hasClass('type_h') == true) {
            $(popLayer).find('.popCont').css({
                'max-height' : winH_type
            });
        } else {
            $(popLayer).find('.popCont').css({
                'max-height' : winH
            });
        }

        var popPos = $(popLayer).height() / 2;
        var popWid = $(popLayer).width() / 2;
        // $(popLayer).css({'left':'50%' , 'margin-left':-(popWid) , 'top':'50%'
        // , 'margin-top':-(popPos)}).show().parents('body').css({'overflow' :
        // 'hidden'});
        $(popLayer).css({
            'left' : '50%',
            'margin-left' : -(popWid),
            'top' : '50%',
            'margin-top' : -(popPos)
        }).show();
        $('.dim').show();

        if(IdName == 'prdOptionPopup'){ //큐레이션 장바구니 영역은 팝업 종료시 별도의 함수 호출을 통해 종료 처리
        	$('.dim').bind('click', function() {
        		common.popLayerClose('prdOptionPopup');
        		return false;
        	});
        }else{
        	$('.dim').bind('click', function() {
        		common.popLayerClose(IdName);
        	});
        }
        // 가세로 변경
        $(window).resize(function() {
            winH = $(window).height() / 2;
            var popInHd = $(popLayer).find('.popHeader').innerHeight();
            var winH_type = $(window).height() - (popInHd + 40);
            var popContCls = $(popLayer).find('.popCont');

            if (popContCls.hasClass('type_h') == true) {
                $(popLayer).find('.popCont').css({
                    'max-height' : winH_type
                });
            } else {
                $(popLayer).find('.popCont').css({
                    'max-height' : winH
                });
            }
            popPos = $(popLayer).height() / 2;
            popWid = $(popLayer).width() / 2;
            $(popLayer).css({
                'left' : '50%',
                'margin-left' : -(popWid),
                'top' : '50%',
                'margin-top' : -(popPos)
            })
        });
        // sns 별도처리
        if (IdName == 'SNSLAYER') {
            $(popLayer).css({
                'left' : '0',
                'margin-left' : '0'
            })
        }
        ;

        // $("body").css("overflow", "hidden");

        // 앱 호출
        common.app.callMenu("Y", 100);
    },

    // 레이어 팝업을 전체화면으로 호출하기위한 함수
    // common.popFullOpen() 이라는 기능이 있으나 여기서는 해당기능으로 전체화면 팝업을 호출한상태에서 다시한번 레이어 팝업을 호출하여
    // 해당기능 사용이 불가한 경우를 해결하기위해 원본인 common.popLayerOpen()을 일부 수정하였다.
    // 관련 SR-3675468(오늘드림 배송지 등록 - 우편번호찾기 팝업 내 검색창 수정 요청件)
    popLayerOpenFullScreen : function(IdName) {

        sessionStorage.setItem("scrollY_popLayer", common.getNowScroll().Y);
        void 0;

        var popLayer = ('#' + IdName);

        // 작은 레이어 팝업용의 CSS설정을 강제로 전체화면용 CSS로 변경한다.
        $(popLayer).find(".popLayerArea").css({
            padding: 0
        });
        $(popLayer).find(".popContainer").css({
            padding: 0
        });
        $(popLayer).find(".popInner").css({
            display: "flex",
            "flex-flow": "column",
            height: "100vh"
        });

        $(popLayer).show();

        // 앱 호출
        common.app.callMenu("Y", 100);
    },

    prdOptPopLayerOpen : function(IdName, pageId) {

    	var winH = $(window).height()-100; //수정함
	    var popLayer = ('#'+IdName);
		$(popLayer).find('.popCont').css({'max-height': winH});

		var popPos = $(popLayer).height()/2;
		var popWid = $(popLayer).width()/2;

        $(popLayer).css({'left':'50%', 'margin-left':-(popWid), 'top':'50%', 'margin-top':-(popPos)}).show();

		$('.dim').show();

		$('.dim').bind('click', function(){
			common.popLayerClose(IdName);
		});


		$(window).resize(function(){
			winH = $(window).height()/2;
		   $(popLayer).find('.popCont').css({'max-height': winH});
			popPos =$(popLayer).height()/2;
			popWid = $(popLayer).width()/2;
			$(popLayer).css({'left':'50%' , 'margin-left':-(popWid) , 'top':'50%' , 'margin-top':-(popPos)})
		});


		//sns 별도처리
		if(IdName =='SNSLAYER'){
		   $(popLayer).css({'left':'0' , 'margin-left': '0'})
		}
    },

    popLayerClose : function(IdName) {
        // 선물하기 옵션변경 팝업인 경우 분기 처리
        if($('#' + IdName).hasClass("popupLayerWrapGift")){
            common.popLayerClosePresentOption(IdName);
        }
        var popLayer = $('#' + IdName);

        if(IdName === 'filterLayer') {
            var html = $('html');
            popLayer.css({'z-index': 20});
            html.removeAttr('style');;
        }
        // $(popLayer).hide().parents('body').css({'overflow' : 'visible'});
        popLayer.hide();
        //$("body").css("overflow", "visible");
        $("body").removeAttr('style');

        try {
            var varNowScrollY = parseInt(sessionStorage.getItem("scrollY_popLayer"));

            if ((varNowScrollY > 0)) {
                $(window).scrollTop(varNowScrollY);
                sessionStorage.removeItem("scrollY_popLayer");
            }
        } catch (e) {
        }

        // [3640931] 주문서 > 보유쿠폰 dim 영역 터치 시 dim 해제 결함
        if(!$('#userCpPop').is(':visible')){
        	$('.dim').hide();
        }

        // 웹 접근성 popfocus 삭제 ( 2017-05-11 )
        $("a[data-focus~=on]").focus(); // 표시해둔 곳으로 초점 이동
        $("button[data-focus~=on]:last").focus(); // 표시해둔 곳으로 초점 이동
        window.setTimeout(function() {
            $("a[data-focus~=on]").removeAttr("data-focus");
            $("button[data-focus~=on]").removeAttr("data-focus");
        }, 100); //

        // 앱 호출
        setTimeout(function() {
            common.app.callMenu("N");

            // 바이오 로그인 팝업 닫은 경우 앱에 푸시 수신 동의 팝업 오픈 요청
            setTimeout(function() {
                if (IdName == 'touchLogin') {
                    common.app.callBioLoginAgrCallBack();
                }
            }, 400);
        }, 100);

        // 옵션 팝업창 닫을 시 이전 선택한 옵션 초기화
        if (IdName == 'prdOptionPopup') {
            $("#"+IdName+" input[name='goodsNo'").val('');
            $("#"+IdName+" input[name='itemNo'").val('');
        }

    },

    popLayerClosePresentOption : function(IdName){
        var popLayer = ('#' + IdName);
        //$(popLayer).hide().parents('body').css({'overflow-y' : 'auto'});
        common.unlockBody();
        $(popLayer).hide();
        $('.dim').hide();

        // 선물하기인 경우 클래스 삭제 필요
        $(popLayer).removeClass("popupLayerWrapGift");
    },

    popLayerRecoOffset : function() {
    	/*var winH = $(window).height() / 2;
        var popLayer = ('#cardBenefitInfo');*/

        var wHeight = $(window).height();
        var popLayer = $("#cardBenefitInfo");
        var popinner = popLayer.find('.popCont');
        var popHeight = $(popLayer).height();
        var popPos = popHeight/2;
        var popWid = $(popLayer).width()/2;
        if(popHeight>=wHeight){
            var inHeight = wHeight - 50;
            popinner.css({'max-height': inHeight});
            var popPos = $(popLayer).height()/2;
        }
        /*var popPos = $(popLayer).height() / 2;
        var popWid = $(popLayer).width() / 2;*/
        $(popLayer).css({
            'left' : '50%',
            'margin-left' : -(popWid),
            'top' : '50%',
            'margin-top' : -(popPos)
        });
    },

    popLayerOpenNoReSize : function(IdName) {

        sessionStorage.setItem("scrollY_popLayer", common.getNowScroll().Y);
        void 0;

        var winH = $(window).height() / 2;
        var popLayer = ('#' + IdName);

        var popPos = $(popLayer).height() / 2;
        var popWid = $(popLayer).width() / 2;
        $(popLayer).css({
            'left' : '50%',
            'margin-left' : -(popWid),
            'top' : '50%',
            'margin-top' : -(popPos)
        }).show().parents('body').css({
            'overflow' : 'hidden'
        });
        $('.dim').show();

        $('.dim').bind('click', function() {
            common.popLayerClose(IdName);
        });
        // 가세로 변경
        $(window).resize(function() {
            winH = $(window).height() / 2;
            popPos = $(popLayer).height() / 2;
            popWid = $(popLayer).width() / 2;
            $(popLayer).css({
                'left' : '50%',
                'margin-left' : -(popWid),
                'top' : '50%',
                'margin-top' : -(popPos)
            })
        });
        // sns 별도처리
        if (IdName == 'SNSLAYER') {
            $(popLayer).css({
                'left' : '0',
                'margin-left' : '0'
            })
        }
        ;

        $("body").css("overflow", "hidden");

        // 앱 호출
        common.app.callMenu("Y", 100);
    },

    popLayerOpenPresentOption : function(IdName){
        var winH = $(window).height()/2;
        var popLayer = ('#' + IdName);
        var popWid = $(popLayer).width()/2;
        var popPos = $(popLayer).height()/2;

        // 선물하기인 경우 클래스 추가 필요
        $(popLayer).addClass("popupLayerWrapGift");

        common.lockBody();

        $(popLayer).css('opacity', '0').show();

        setTimeout(function(){
            popPos = $(popLayer).height()/2;
            $(popLayer).css({'left':'50%' , 'margin-left':-(popWid) , 'top':'50%' , 'margin-top':-(popPos), 'opacity' : '1'});
        }, 50);

        var heightSetting = function(){
            var winH = $(window).height()/2;
            $(popLayer).find('.popCont').removeAttr('style');
            var popLayerH = $(popLayer).find(".popCont").outerHeight();

            if (window.innerWidth > window.innerHeight) {
                $(popLayer).find('.popCont').css({'max-height': winH, 'height' : 'auto'});
            } else {
                $(popLayer).find('.popCont').css({'max-height': '', 'height' : popLayerH});
            }
        }

        heightSetting();

        $(popLayer).find('.select_box a').on('click', function(){
            winH = $(window).height()/2;
            heightSetting();
            popPos =$(popLayer).height()/2;
            popWid = $(popLayer).width()/2;
            $(popLayer).css({'left':'50%' , 'margin-left':-(popWid) , 'top':'50%' , 'margin-top':-(popPos)})
        })

        $('.dim').show();
        $('.dim').bind('click', function(){
            common.popLayerClose(IdName);
        });

        $(window).resize(function(){
            winH = $(window).height()/2;
            heightSetting();
            popPos =$(popLayer).height()/2;
            popWid = $(popLayer).width()/2;
            $(popLayer).css({'left':'50%' , 'margin-left':-(popWid) , 'top':'50%' , 'margin-top':-(popPos)})
        });
    },

    popLayerCloseOption : function(IdName){
    	/*
        var popLayer = ('#' + IdName);
        $(popLayer).find(".choice").html('상품을 선택해주세요.');
     	$("#"+IdName+" input[name='goodsNo'").val('');
     	$("#"+IdName+" input[name='itemNo'").val('');
        common.unlockBody();
        $(popLayer).hide();
        $('.dim').hide();
        */

    	// 옵션 팝업창 닫을 시 이전 선택한 옵션 초기화
    	if (IdName == 'prdOptionPopup') {
            $("#"+IdName+" input[name='goodsNo'").val('');
            $("#"+IdName+" input[name='itemNo'").val('');
        }

		var popLayer = $(".popLayerWrap").not("#prdSdLayer"); // 상품상세 - 장바구니 담기 후 큐레이션 레이어 제외
		$(popLayer).hide().parents('body').css({'overflow' : 'visible'});

		$("body").removeAttr('style');

		$('.dim').hide();

		common.cart.trackingInfo.setTrackingCd(''); // 그냥 닫을 경우 트래킹 코드 초기화
    },

    lockBody : function() {
        var $docEl = $('html, body');
        var $wrap = $('#mWrapper');

        if(window.pageYOffset) {
            optionScrollTop = window.pageYOffset;

            $wrap.css({
                position: 'fixed',
                top: - (optionScrollTop)
            });
        }

        $docEl.css({
            height: "100%",
            overflow: "hidden"
        });
    },

    unlockBody : function() {
        var $docEl = $('html, body');
        var $wrap = $('#mWrapper');

        $docEl.css({
            height: "",
            overflow: ""
        });

        $wrap.css({
            position: '',
            top: ''
        });

        window.scrollTo(0, optionScrollTop);
        window.setTimeout(function () {
            optionScrollTop = null;
        }, 0);
    },

    popFocus : function() {
        if (window.location.pathname.split('/').pop() == 'getCart.do') mcart.base.curationDlexPop();
        // 초기 실행시 data-focus 삭제
        $("a[data-focus~=on]").removeAttr("data-focus");
        $("button[data-focus~=on]").removeAttr("data-focus");

        $("a, button").click(function() {
            var el = $(this);
            el.attr('data-focus', 'on'); // 레이어 팝업이 닫힐 때를 위한 표시 - 웹접근성

            /* modalPopup팝업 위치조정 */
            window.setTimeout(function() {

                if ($("#pop-full-wrap").css("display") == 'block') {
                    var target = $("#pop-full-wrap");
                } else if ($("#LAYERPOP01").css("display") == 'block') {
                    var target = $("#LAYERPOP01");
                } else if ($("#SNSLAYER").css("display") == 'block') {
                    var target = $("#SNSLAYER");
                } else if ($("#allMenu").hasClass("show")) {
                    var target = $("#allMenu");
                } else if ($("#fulsizePop").css("display") == 'block') {
                    var target = $("#fulsizePop");
                } else {
                }

                if (target != undefined) {

                    var win_height = $(window).height();
                    var pop_height = target.height();
                    var top_value = $(window).scrollTop() + (win_height - pop_height) / 2;

                    target.attr("tabindex", "0");
                    target.focus();
                }
            }, 500);// ajax 팝업을 고려한 딜레이 추가
            /* [end]: modalPopup팝업 위치조정 */
        });

    },

    /** 현재 스크롤 위치 저장 * */
    setScrollPos : function(scrollPos) {
        common.scrollPos = $(document).scrollTop();
    },
    /** 레이어팝업 클릭 시, 스크롤 위치값 localstorage 저장 * */
    setScrollPos2 : function() {
        var scrollT = $(document).scrollTop();
        localStorage.setItem('lyScrollSet', scrollT);
    },
    /** 히스토리 백 버튼 Bind * */
    historyBackBind : function() {
        $("#backBtn").click(function() {
            history.back();
        });
    },

    isLoginPageChk : function(url) {
        if (history.state == null) {
            history.replaceState({
                status : "login"
            }, null, null);
            history.pushState({
                status : "loginCheck"
            }, null, null);
        }
        $(window).bind("popstate", function() {
            if (history.state != null && history.state.status == "login") {
                // if(!common.isEmpty(url)){
                // console.log("url존재:"+url);
                // location.href= url;
                // }else{
                // console.log("url없음:"+url);
                location.href = _baseUrl + "main/main.do";
                // }
            }
        });
    },

    setLazyLoad : function(type) {

        if (type == undefined || type == "seq") {
            // lazyload - 이미지스크롤이벤트
            // $(document).find("img.seq-lazyload").lazyload({
            // //effect : "fadeIn",
            // event : "sequential"
            // });

            // 로딩 된 이미지에 중복으로 lazyload를 바인드하지 않도록 하기 위해 클래스명 변경
            // $(document).find("img.seq-lazyload").removeClass("seq-lazyload").addClass("completed-seq-lazyload");

            lazyloadSeq.load("img.seq-lazyload", "seq-lazyload");
        }

        if (type == undefined || type == "scr") {
            lazyloadSeq.load("img.scroll-lazyload", "scroll-lazyload");

            // // lazyload - 이미지스크롤이벤트
            // $(document).find("img.scroll-lazyload").lazyload({
            // effect : "fadeIn",
            // threshold : 1000
            // });
            //
            // //로딩 된 이미지에 중복으로 lazyload를 바인드하지 않도록 하기 위해 클래스명 변경
            // $(document).find("img.scroll-lazyload").removeClass("scroll-lazyload").addClass("completed-scroll-lazyload");
        }

        $(document).resize();

    },

    // 재입고 알림 팝업 오픈
    openStockAlimPop : function(goodsNo, itemNo) {
        if (common.loginChk()) {
            var url = _baseUrl + "goods/getAlertStockAjax.do";
            var data = {
                goodsNo : goodsNo,
                itemNo : itemNo
            };
            common.Ajax.sendRequest("POST", url, data, common._callBackAlearStockForm);
        }
    },

    // 재입고 알림 콜백
    _callBackAlearStockForm : function(res) {
        $("#pop-full-wrap").html(res);
        common.popFullOpen("재입고알림 신청", "");

        // 재입고 팝업 닫기 버튼 클릭 시 이미지 기술서 pinchZoom Init
        /*$(".btnClose").click(function() {
            $(".controlHolder").empty();
            $("div#timpHtml").find("div#TEMP_HTML").attr("style", "");
            $("div#test00").html($("div#timpHtml").html().replace("TEMP_HTML", "markerTest"));
            $("#markerTest").pinchzoomer();
        });*/

    },

    // 오프라인 재입고 알림 팝업 오픈 오늘드림 고도화 2019-12-30
    openStockOffStoreAlimPop : function(goodsNo, itemNo, strNo) {
        if (common.loginChk()) {
            var url = _baseUrl + "goods/regAlertStockOffStoreJson.do";
            var data = {
                goodsNo : goodsNo,
                itemNo : itemNo,
                strNo : strNo
            };
            common.Ajax.sendRequest("POST", url, data, common._callBackAlearOffStoreStockForm);
        }
    },

    // 오프라인 재입고 알림 콜백 오늘드림 고도화  2019-12-30
    _callBackAlearOffStoreStockForm : function(res) {
        alert(res);
    },

    // 행사안내 팝업 오픈
    openEvtInfoPop : function(promNo, promKndCd, promCond, goodsNo, itemNo) {

//        var quickYn = $(":input:radio[name=qDelive]:checked").val();
//        if (typeof (quickYn) == "undefined") {
//            quickYn = $("#quickYn").val();
//        }

    	var quickYn = "N";
    	if($("input[name=qDelive]").attr("type") == "radio"){
    		quickYn = $(":input:radio[name=qDelive]:checked").val();
    	} else if($("input[name=qDelive]").attr("type") == "checkbox"){
    		quickYn = $("input[name=qDelive]").is(":checked") ? "Y" : "N";
    	} else {
    		quickYn = $("#quickYn").val();
    	}

        var url = _baseUrl + "cart/getGoodsPromEvtInfoAjax.do";
        var data = {
            promNo : promNo,
            promKndCd : promKndCd,
            promCond : promCond,
            goodsNo : goodsNo,
            itemNo : itemNo,
            quickYn : quickYn
        };
        if (promCond == '1+1' || promCond == 'A+B' || promCond == 'GIFT') {
            common.Ajax.sendRequest("POST", url, data, common._callBackSimpleGoodsEvtInfo);
        } else {
            common.Ajax.sendRequest("POST", url, data, common._callBackGoodsEvtInfo);
        }
    },

    // 행사안내 콜백 ( 1+1 이 아닐 경우 )
    _callBackGoodsEvtInfo : function(res) {
        $("#pop-full-wrap").html(res);
        common.popFullOpen("행사안내", "");
    },

    // 행사안내 콜백 ( 1+1 일 경우 )
    _callBackSimpleGoodsEvtInfo : function(res) {
        $("#layerPop").html(res);
        common.popLayerOpen("LAYERPOP01");
    },

    isMainHome : function() {
        try {
            if (location.href.endWith("/main/main.do#0")) {
                return true;
            }

            return false;
        } catch (e) {
            return false;
        }
    },

    bindGtmTrkparam : function () {
        var params = common.cart.urlParams();
        var gtmTrackingParma = ( params.gateCd || "" ) + "/" + ( params.trackingCd || "" );

        return gtmTrackingParma;
    },

    bindGoodsGtmInfo : function(filterSelectorStr, gtmList) {
        var classNm = filterSelectorStr == undefined ? "" : filterSelectorStr + " ";

        $(classNm + ".goodsList").on("click", function(e) {
            e.preventDefault();
            var _data_goodsno = $(this).attr("data-ref-goodsNo");
            var _item_index = $(classNm + '.goodsList').index((this));

            _item_index = (_item_index % 2 ===0) ? (_item_index / 2) + 1 : (_item_index + 1) / 2;

            gtm.goods.callGoodsGtmInfo(_data_goodsno, null, 'ee-productClick', gtmList, _item_index);
        });
    },

    bindGoodsGtmImpression : function(filterSelectorStr, gtmList) {
        var classNm = filterSelectorStr == undefined ? "" : filterSelectorStr + " ";

        var gtmGoodsNoArr = new Array();
        var gtmItemNoArr = new Array();

        $(classNm + ".prod-info .goodsList").each(function(index) {
            var _data_goodsno = $(this).attr("data-ref-goodsNo");
            var _data_itemno = $(this).attr("data-ref-itemno") || '001';

            gtmGoodsNoArr.push(_data_goodsno);
            gtmItemNoArr.push(_data_itemno);
        });

        //gtm.goods.callGoodsGtmInfo(gtmGoodsNoArr, gtmItemNoArr, 'ee-productImpression', gtmList);
    },

    bindGoodsListLink : function(filterSelectorStr) {
        var classNm = filterSelectorStr == undefined ? "" : filterSelectorStr + " ";
        $(classNm + ".goodsList").each(function (e) {
            var trackingCd = common.cart.urlParams().trackingCd;
            if (!!trackingCd) $(this).attr("name", trackingCd);
        });
        $(classNm + ".goodsList").unbind("click");
        $(classNm + ".goodsList").bind("click", function(e) {
            e.preventDefault();

            var trackingCd = $(this).attr("name");
            var gateCd = $(this).data('gateCd');
            // if (-1 < location.href.indexOf('/m/main/main.do') &&
            //     (-1 < trackingCd.indexOf('New') || -1 < trackingCd.indexOf('Best') || -1 < trackingCd.indexOf('Today')
            //         || (-1 < trackingCd.indexOf('Planshop') && (location.hash == '#4' || location.hash == '4'))
            //     )
            // ) {
            //     trackingCd += '&gateCd=Main';
            // }

            if(classNm.includes('#recentgoods')) {
                gtm.goods.callGoodsGtmInfo($(this).attr("data-ref-goodsNo"), null, 'ee-productClick', '공통_통합검색_최근본상품', $(this).attr("data-index"));
            }

            // 판매종료 여부체크
            var allSoldOutChk = $(this).find(".img").children("span").hasClass("allsoldOut");
            if (allSoldOutChk == false) {
            	if(trackingCd != null && trackingCd != undefined && trackingCd != "null"){

                    // 엠플리튜드 로직 추가 2023.05.30 added by jw.lee
                    var callPage = common.cart.urlParams().callPage;
                    if(callPage) {
                        var t_page = common.cart.urlParams().t_page;
                        var t_click = common.cart.urlParams().t_click;
                        var t_number = common.cart.urlParams().t_number;
                        categoryShop.detail.setAmplitudeEvent({
                            callPage: callPage,
                            t_page: t_page,
                            t_click: t_click,
                            t_number: t_number
                        });
                    }

            		common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"), trackingCd, null, gateCd);
            	}else{
            		common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"), null, null, gateCd);
            	}
            }
        });

        // 추천/인기 기획전 UI 개선으로 class 추가 - [3336021] (메인 페이지 개편) 기획전 개선 건(CHY)
        $(classNm + ".newGoodsList").unbind("click");

        $(classNm + ".newGoodsList").bind("click", function(e) {
        	e.preventDefault();

        	common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"), $(this).attr("name"));
        });

        // [3383769] (메인 페이지 개편) 올알랭 신규 건 (CSH)
        $(classNm + ".allalainGoodsList").unbind("click");

        $(classNm + ".allalainGoodsList").bind("click", function(e) {
        	e.preventDefault();

        	// [3389141] (영역별 매출분석) 오특, 검색, 베스트, 메인 추가(CHY)
        	var trackingCd = $(this).attr("name");
        	common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"), trackingCd);
        });
        // [3383769] END

        $(classNm + ".item").not(".item.brand").unbind("click");

        $(classNm + ".item").not(".item.brand").bind("click", function(e) {
            e.preventDefault();

            // 판매종료 여부체크
            var allSoldOutChk = $(this).find(".img").children("span").hasClass("allsoldOut");

            if (allSoldOutChk == false) {
                common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"), $(this).attr("name"));
            }
        });

        $(classNm + ".goodsListLogin").bind("click", function(e) {
            e.preventDefault();
            // 로그인 성인체크 로그인성인
            common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"));
        });

        $(classNm + ".goodsListAuth").bind("click", function(e) {
            e.preventDefault();
            // 로그인 성인체크
            common.link.moveGoodsDetail($(this).attr("data-ref-goodsNo"), $(this).attr("data-ref-dispCatNo"));
        });
    },

    /* 2018.12.18 바코드 스캔 추가 */
    bindGoodsListBarcodeLink : function(filterSelectorStr) {
        var classNm = filterSelectorStr == undefined ? "" : filterSelectorStr + " ";

        $(classNm + ".goodsList").unbind("click");

        $(classNm + ".goodsList").bind("click", function(e) {
            e.preventDefault();

            // 판매종료 여부체크
            var allSoldOutChk = $(this).find(".img").children("span").hasClass("allsoldOut");

            if (allSoldOutChk == false) {
                common.link.moveGoodsDetailBarcode($(this).attr("data-ref-itemNo"));
            }
        });

        $(classNm + ".goodsListLogin").bind("click", function(e) {
            e.preventDefault();
            // 로그인 성인체크 로그인성인
            common.link.moveGoodsDetailBarcode($(this).attr("data-ref-itemNo"));
        });

        $(classNm + ".goodsListAuth").bind("click", function(e) {
            e.preventDefault();
            // 로그인 성인체크
            common.link.moveGoodsDetailBarcode($(this).attr("data-ref-itemNo"));
        });
    },

    /** 상품평 삭제 전 처리 **/
    // 오프라인리뷰관련추가
       moveGoodsGdasDel : function(gdasSeq, goodsNo, lgcGoodsNo, pntPayYn, retUrl, gdasSctCd){

           var loginCheck = common.loginChk();

//           var deleteMessage = '작성하신 상품평을 삭제하시겠습니까?';
           var deleteMessage = '작성한 리뷰를 삭제하시겠습니까?';

           if(!loginCheck) return;

           if(!confirm(deleteMessage)) return;

           common.delGdasProceess(gdasSeq, goodsNo, lgcGoodsNo, retUrl, gdasSctCd);
       },

       /** 상품평 삭제 처리 **/
    // 오프라인리뷰관련추가
       delGdasProceess : function(gdasSeq, goodsNo, lgcGoodsNo, retUrl, gdasSctCd){

           var data = {gdasSeq : gdasSeq, goodsNo:goodsNo, retUrl: retUrl, gdasSctCd : gdasSctCd, lgcGoodsNo : lgcGoodsNo};
           //jsTemplet
           common.Ajax.sendJSONRequest("POST"
               , _baseUrl + "mypage/delGdasJson.do?gdasSeq="+gdasSeq
               , data
               , common.afterDelGoodsGdasSuccess
           );
       },

    /** 상품평 삭제 후 처리 * */
    afterDelGoodsGdasSuccess : function(data) {

        if (data.resultCd == "000") {
            // alert("성공적으로 삭제하였습니다.");
            alert("삭제 완료");

            // 삭제 후 이전페이지로
            history.back();
        } else {
            alert("삭제가 실패하였습니다.");
        }
    },

    /** 개인정보취급방침 * */
    getPrivacy : function() {

    },

    /** 상품 사이즈별 이미지경로 생성 * */
    getSizeImgUrl : function(size, imgUrl) {

        var goodsPath = "", imgSctCd = "", sizePath = "", prefixPath = _goodsImgUploadUrl;

        var pathArr = imgUrl.split("/");

        // 이미지 구분 코드를 구별하기 위한 Split
        if (pathArr.length > 1) {
            imgSctCd = pathArr[0];
        }

        // 상세 이미지일 경우 사이즈 패스 필요 없음
        if (imgSctCd != "40") {
            sizePath = size + "/";
        }

        // imgUrl + sizePath + goodsImgUrl 형식의 타입으로 Return
        // 상세 sizePath가 ""로 들어감
        goodsPath = prefixPath + sizePath + imgUrl;

        return goodsPath;
    },

    // 드래그 이벤트 막기
    preventDrag : function() {
        $('.userSelectnone').css('use-select', 'none');
    },

    // 행사안내 팝업 닫기
    closePromEvtPop : function() {

        common.popFullClose();

        // 장바구니에서 자세히보기 레이어팝업 닫을 때 pin 스크립트 오류 수정
        if ($(".pin-wrapper").css("height") == "0px") {
            $('.basket_sticky ').css('width', '100%');
        }

        if (location.href.indexOf("getCart.do") > 0 && common.cart.regCartCnt > 0) {
            var linkCartNo = location.href.substring(location.href.indexOf("cartNo=") + 7);
            var sumCartNo = "";

            if (linkCartNo != "") {
                if (cartNosForDirectCart != "") {
                    sumCartNo = linkCartNo + "," + cartNosForDirectCart;
                } else {
                    sumCartNo = linkCartNo;
                }
            }

            cartNosForDirectCart = "";
            common.cart.regCartCnt = 0;

            if (location.href.indexOf("cartNo=") > 0) {
                location.href = _secureUrl + "cart/getCart.do?cartNo=" + sumCartNo;
            } else {
                window.location.reload();
            }
        }
    },

    /**
     * 이미지 공통 처리
     */
    errorImg : function(obj) {
        obj.src = _imgUrl + "/comm/noimg_550.gif";
        obj.onerror = '';
    },
    errorProfileImg : function(obj) {
        obj.src = _imgUrl + "/comm/my_picture_base.jpg";
        obj.onerror = '';
    },
    errorBrandImg : function(obj) {
        obj.src = _imgUrl + "/comm/noimage_brandshop.png";
        obj.onerror = '';
    },
    errorCatImg : function(obj) {
    	obj.src = _imgUrl + "/comm/noimg_550.gif";
        obj.onerror = '';
        obj.parentElement.className = 'img no-img';
    },
    errorCrcImg : function(obj) {
    	obj.src = _imgUrl + "/category/brand_default.png";
    	obj.onerror = '';
    	obj.parentElement.className = 'img no-img';
    },
    errorCurationBrandImg : function(obj) {
    	obj.src = _imgUrl + "curation/brand_bg.png";
    	obj.onerror = "";
    },
    imgLoads : function(obj,size){
        var _thisImg = $(obj);
        if(_thisImg.attr('src').indexOf('?') == -1){
            _thisImg.attr('src',common.resizeImg(obj, size));
        }
    },
    errorResizeImg : function(obj, size) {
        obj.src = _fileUploadUrl + "comm/noimg_550.gif?RS="+size;
        obj.onerror = '';
    },
    errorResizeProfileImg : function(obj, size) {
        obj.src = _fileUploadUrl + "comm/my_picture_base.jpg?RS="+size;
        obj.onerror = '';
    },
    resizeImg : function(obj, thum_size){
        $('#reviewBestDiv').show();//CS 높이 체크 위해 추가
        var _thisImg = $(obj);
        var _thisImgUrl = _thisImg.attr('src');
        var _thiswidth = _thisImg.width(), _thisHeight = _thisImg.height();
        var _resize_size = thum_size, _resize_ratio = 2;
        var rs_width = 0, rs_height = 0, cs_width = 0, cs_height = 0;

        if(_thiswidth > _thisHeight){
            if(_thisHeight > _resize_size){
                rs_width = _resize_size * _resize_ratio, rs_height = 0;
                cs_width = _resize_size, cs_height = _resize_size;
            }else if(_thisHeight <= _resize_size){
                //rs_width = _resize_size * _resize_ratio, rs_height = _resize_size * _resize_ratio;
                //cs_width = _resize_size, cs_height = _resize_size;
                rs_width = _resize_size * _resize_ratio, rs_height = 0;
                cs_width = _thisHeight, cs_height = _thisHeight;
            }
        }else if(_thiswidth < _thisHeight){
            if(_thiswidth > _resize_size){
                rs_width = _resize_size * _resize_ratio, rs_height = 0;
                cs_width = _resize_size, cs_height = _resize_size;
            }else if(_thiswidth <= _resize_size){
                //rs_width = _resize_size * _resize_ratio, rs_height = _resize_size * _resize_ratio;
                //cs_width = _resize_size, cs_height = _resize_size;
                rs_width =_thiswidth, rs_height = 0;
                cs_width = _thiswidth, cs_height = _thiswidth;
            }
        }else if(_thiswidth == _thisHeight){
            rs_width = _resize_size, rs_height = _resize_size;
            cs_width = _resize_size, cs_height = _resize_size;
        }
        return_url = _thisImgUrl+'?RS='+parseInt(rs_width)+'x'+parseInt(rs_height)+'&CS='+parseInt(cs_width)+'x'+parseInt(cs_height);
        setTimeout(function() {
            //웹로그 바인딩
            //_thisImg.css('visibility','visible')
        }, 100);

        // 2020-07-28 ---- 강제로 show를하는 거지같은경우
        try{
            let tabClass = "#main-swiper-tab3:not(.swiper-slide-duplicate)" + " ";
            let dispCatNo = $(tabClass+"#mTab li.on").attr("data-ref-dispCatNo");
            if(dispCatNo == '900000100100002'){
                // 리뷰 베스트인 경우
                $(tabClass+"#reviewBestDiv").show();
            }else{
                // 판매 베스트인 경우
                $(tabClass+"#reviewBestDiv").hide();
            }
        }catch(e){
        	void 0;
        }
        /////// ----

        return return_url;
    },
    onLoadProfileImg : function(obj, size){
        var _thisProfileImg = $(obj);
        if($(obj)[0].src.indexOf("?CS=") > -1){
            var temp = $(obj)[0].src.substring(0,$(obj)[0].src.indexOf("?CS="));
            $(obj)[0].src = temp;
        }
        _thisProfileImg.siblings('div.thum').find('img.profileThum_s').attr('src',common.profileImgResize(obj, size));
    },
    profileImgResize :  function(obj, thum_size){
        var _thisImg = $(obj);
        var _thisImgUrl = _thisImg.attr('src');
        var _thiswidth = _thisImg.width(), _thisHeight = _thisImg.height();
        var _resize_size = thum_size, _resize_ratio = 0;
        var rs_width = 0, rs_height = 0, cs_width = 0, cs_height = 0;

        if(_thiswidth > _thisHeight){
            if(_thisHeight > _resize_size){
                _resize_ratio = _resize_size / _thisHeight;
                rs_width = _thiswidth * _resize_ratio, rs_height = _resize_size;
                cs_width = _resize_size, cs_height = _resize_size;
            }else if(_thisHeight < _resize_size){
                rs_width = _thiswidth, rs_height = _thisHeight;
                cs_width = _thisHeight, cs_height = _thisHeight;
            }
        }else if(_thiswidth < _thisHeight){
            if(_thiswidth > _resize_size){
                _resize_ratio = _resize_size / _thiswidth;
                rs_width = _resize_size, rs_height = _thisHeight * _resize_ratio;
                cs_width = _resize_size, cs_height = _resize_size;
            }else if(_thiswidth < _resize_size){
                rs_width = _thiswidth, rs_height = _thisHeight;
                cs_width = _thiswidth, cs_height = _thiswidth;
            }
        }else if(_thiswidth == _thisHeight){
            if(_thiswidth > _resize_size){
                rs_width = _resize_size, rs_height = _resize_size;
                cs_width = _resize_size, cs_height = _resize_size;
            }else if(_thiswidth < _resize_size){
                rs_width = _thiswidth, rs_height =_thiswidth;
                cs_width = _thiswidth, cs_height = _thiswidth;
            }
        }
        return_url = _thisImgUrl+'?RS='+parseInt(rs_width)+'x'+parseInt(rs_height)+'&CS='+parseInt(cs_width)+'x'+parseInt(cs_height);
        return return_url;
    },
    /** EP 쿠폰 오픈 * */
    epCouponOpen : function() {
        $("#layerPop").html($("#epCouponLayerPop").html());
        common.popLayerOpenNoReSize("LAYERPOP01");
    },

    /**
     * 웹로그
     */
    wlog : function(wlKey) {
    },

    // 정상적인 상태에서 세션스토리지 정보를 리셋함.
    resetSessionStorage : function() {
        // [CJOYMS-626] 다른 계정으로 로그인 시 바로 전 로그인 되었던 유저의 배송지 목록이 표시 되는 오류 제거
        sessionStorage.removeItem('todayDeliveryAddressList');

        var popInfo = sessionStorage.getItem("urgentNoticePop");
        var bannerCloseYn = sessionStorage.getItem("bannerCloseYn");
        var subDispCatNo = sessionStorage.getItem("subDispCatNo");
        var fullPopDispYn = sessionStorage.getItem("fullPopDispYn");
        var callBrazeMainYn = sessionStorage.getItem("callBrazeMainYn");
        var callBrazeAdClickYn = sessionStorage.getItem("callBrazeAdClickYn");
        var enterWcare = sessionStorage.getItem(STORAGE_KEY.SESSION.WCARE_ENTER_YN);
        var liveNudgeSkip = sessionStorage.getItem(STORAGE_KEY.SESSION.LIVE_NUDGE_SKIP_YN); //
        // 기프트관 2차 jwkim
        var sessionVoteClose = sessionStorage.getItem("sessionVoteClose");

        var presentOptionTextCloseYn = sessionStorage.getItem("presentOptionTextCloseYn");

        var manBanInfo = sessionStorage.getItem("manBanInfo");

        var appBanInfo = sessionStorage.getItem("appBanInfo");

        var healthSecretInfo = sessionStorage.getItem("healthSecretInfo");

		var firstPurchaseBanInfo = sessionStorage.getItem("firstPurchaseBanInfo");

		var byIsNotLoginFirPurBan = sessionStorage.getItem("byIsNotLoginFirPurBan");

		// 쇼핑알림 서비스
        var shopAlimGetTime = sessionStorage.getItem("shopAlimGetTime");
        var shopAlimOlLiveList = sessionStorage.getItem("shopAlimOlLiveList");

        var gnbMenus = sessionStorage.getItem('gnbMenus');
        var gnbMenuId = sessionStorage.getItem('gnbMenuId');

        //패럴렉스 효과
        var parallax = sessionStorage.getItem("parallax");

        sessionStorage.clear();

        if (gnbMenus != undefined && gnbMenus != 'undefined') {
            sessionStorage.setItem('gnbMenus', gnbMenus);
        }
        if (gnbMenuId != undefined && gnbMenuId != 'undefined') {
            sessionStorage.setItem('gnbMenuId', gnbMenuId);
        }
        if (parallax != undefined && parallax != "undefined") {
        	sessionStorage.setItem("parallax", parallax);
        }
        if (popInfo != undefined && popInfo != "undefined") {
            sessionStorage.setItem("urgentNoticePop", popInfo);
        }
        if (bannerCloseYn != undefined && bannerCloseYn != "undefined") {
            sessionStorage.setItem("bannerCloseYn", bannerCloseYn);
        }
        if (subDispCatNo != undefined && subDispCatNo != "undefined") {
            sessionStorage.setItem("subDispCatNo", subDispCatNo);
        }
        // 기프트관 2차 jwkim
        if (sessionVoteClose != undefined && sessionVoteClose != "undefined") {
            sessionStorage.setItem("sessionVoteClose", sessionVoteClose);
        }
        if (presentOptionTextCloseYn != undefined && presentOptionTextCloseYn != "undefined") {
            sessionStorage.setItem("presentOptionTextCloseYn", presentOptionTextCloseYn);
        }

        if (fullPopDispYn != undefined && fullPopDispYn != "undefined") {
            sessionStorage.setItem("fullPopDispYn", fullPopDispYn);
        }

        if (callBrazeMainYn != undefined && callBrazeMainYn != "undefined") {
            sessionStorage.setItem("callBrazeMainYn", callBrazeMainYn);
        }

        if (enterWcare != undefined && enterWcare != "undefined") {
            sessionStorage.setItem(STORAGE_KEY.SESSION.WCARE_ENTER_YN, enterWcare);
        }

        if (liveNudgeSkip != undefined && liveNudgeSkip != "undefined") {
            sessionStorage.setItem(STORAGE_KEY.SESSION.LIVE_NUDGE_SKIP_YN, liveNudgeSkip);
        }

        if (callBrazeAdClickYn != undefined && callBrazeAdClickYn != "undefined") {
            sessionStorage.setItem("callBrazeAdClickYn", callBrazeAdClickYn);
        }

        if (manBanInfo != undefined && manBanInfo != "undefined") {
            sessionStorage.setItem("manBanInfo", manBanInfo);
        }

        if (appBanInfo != undefined && appBanInfo != "undefined") {
            sessionStorage.setItem("appBanInfo", appBanInfo);
        }

        if (healthSecretInfo != undefined && healthSecretInfo != "undefined") {
            sessionStorage.setItem("healthSecretInfo", healthSecretInfo);
        }

        //첫구매 유도 배너
        if (firstPurchaseBanInfo != undefined && firstPurchaseBanInfo != "undefined") {
            sessionStorage.setItem("firstPurchaseBanInfo", firstPurchaseBanInfo);

            if(firstPurchaseBanInfo == "done"){
            	if(common.isLogin()){
            		if(common.isEmpty(common.getCookie("firstPurchaseTempCookie"))){		//동일 세션에서 한번 봤던거는 다시 돌리지 않는다
            			common.setSessionCookie("firstPurchaseTempCookie", "false");

            		}else if(common.getCookie("firstPurchaseTempCookie") == "false"){
            			common.setSessionCookie("firstPurchaseTempCookie", "done");
            		}
            	}
            }
        }else{
        	if(common.isLogin() && common.isEmpty(firstPurchaseBanInfo)
        			&& common.getCookie("firstPurchaseTempCookie") == null){  // 자동 로그인하면서 다시 들어올때
        		common.setSessionCookie("firstPurchaseTempCookie", "false");
        	}else if(common.isLogin() && common.isEmpty(firstPurchaseBanInfo)
        			&& common.getCookie("firstPurchaseTempCookie") == "false" ){ //로그인 직 후
	        	common.setSessionCookie("firstPurchaseTempCookie", "done");
        	}else if(common.isLogin() && common.isEmpty(firstPurchaseBanInfo)
        			&& common.isEmpty(common.getCookie("firstPurchaseTempCookie"))){ //앱종료 후 자동로그인으로 들어왔을때
        		sessionStorage.setItem("byThroughAppFirstPurchase", "done");
        	}
        }

        if (byIsNotLoginFirPurBan != undefined && byIsNotLoginFirPurBan != "undefined") {
            sessionStorage.setItem("byIsNotLoginFirPurBan", byIsNotLoginFirPurBan);
        }

        if (shopAlimGetTime != undefined && shopAlimGetTime != "undefined") {
            sessionStorage.setItem("shopAlimGetTime", shopAlimGetTime);
            sessionStorage.setItem("shopAlimOlLiveList", shopAlimOlLiveList);
        }
        common.setCookie_search("storeNo", '', '-1');
        common.setCookie_search("storeNm", "", "-1");
        common.setCookie_search("genderCd", "", "-1");
        common.setCookie_search("ageCd", "", "-1");
        common.setCookie_search("priceCd", "", "-1");
        common.setCookie_search("divisionCd", "", "-1");
        common.setCookie_search("categoryCd", "", "-1");

        var exdays = "0";
        if(common.app != undefined && common.app.appInfo != undefined ){
            var appInfo = common.app.appInfo;

            if(appInfo.isapp && appInfo.ostype == "10" && common.app.compareVersion(appInfo.appver, "3.1.8") == ">"){
                exdays = "-1";
            }
        }
        common.setCookie_search("linkageString", "", exdays);
    },

    /**
     * 2019.12.09 | jp1020 장바구니 담기(공통) 상품상세 이외 전역에서 사용 가능
     *
     * @param options.onSuccess : 성공시 콜백함수 - 2024.05.13 jpark 추가
     */
    gf_regCart : function(obj, options = {}) {

        if ($(obj).attr('data-rccode') == 'mc_detail_soldout_ac') {
            common.wlog('goods_soldout_popup_prod_cart');
        }
        if ($(obj).attr('data-rccode') == 'mc_detail_cart_a') {
            common.wlog('goods_cart_curation_popup_prod_cart');
        }

        newGoods.event.bindButtonWebLog($(obj),'cart');

        var params = $(obj).data();

        if(callOrg == undefined || callOrg == ""){
            if($(obj).context != undefined) {
                callOrg = $(obj).context.className;
            } else {
                callOrg = '';
            }
        }

        giftPlusItemYn = $(obj).attr('iconClass');

        // curation reload
        // if(!!localStorage.getItem("curationPopInfo")) {
        //     localStorage.setItem("curationReload", "Y");
        // }

        if (common.loginChk()) {
            // 옵션선택이 있거나, 없거나 일단 화면 진입
            var url = _baseUrl + "common/getCartOptionSelectAjax.do";

            // 마이페이지 주문/배송조회 장바구니 기능 개선으로 분기 처리 - [3330196] 올리브영 모바일 주문목록 개선 요청(CHY)
            if(params.loadPage != null && params.loadPage != ""){
            	url += "?loadPage=" + params.loadPage;

            	if(params.totalQty != null && params.totalQty != ""){
            		url += "&totalQty=" + params.totalQty;
            	}

            	// 마이페이지 주문/배송조회 페이지와 자주 구매 상품 페이지 DS 분기 처리 - [3330196] 올리브영 모바일 주문목록 개선 요청(CHY)
            	if(params.loadPage == "order"){
            		common.wlog("mypage_orderlist_addcart");
            	}if(params.loadPage == "often"){
            		common.wlog("mypage_oftenlist_addcart");
            	}
            }

            var tmpItemNo = params.itemNo;

            if (tmpItemNo.length > 3) {
                tmpItemNo = "001";
            }

            var data;

            // 오늘드림 전문관 리스트인 경우 장바구니 클릭시 오늘드림 장바구니에 추가되게끔 하기위해 값 추가
            // quickInfo class는 오늘드림 전문관에서만 사용함
            if ($(this).closest("li").hasClass("quickInfo")) {
                data = {
                    goodsNo : params.goodsNo || params.refGoodsno,
                    itemNo : tmpItemNo,
                    quickYn : "Y"
                };
            } else {
                data = {
                    goodsNo : params.goodsNo || params.refGoodsno,
                    itemNo : tmpItemNo
                };

                if(params.quickYn == "Y") {
                    data.quickYn = "Y";
                }

                if(callOrg == 'btnbag') {
                	recoCart = "Y";
                }

                if(!common.isEmpty(params.rccode)) {
                	data.recoRcCode = params.rccode;
                }

                if(!common.isEmpty(params.strno)) {
                	data.strNo = params.strno;
                }

                // 20200827 기프트관 장바구니 분기처리 CBLIM
                if(callOrg == 'btn_basket') {
                	recoCart = "G";
                	giftTrackCode = "Gift_Main_Set";
                } else {
                    giftTrackCode = "";
                }

                // 메인페이지 UI 분기처리 - [3383750] (메인 페이지 개편) OY추천상품 개선 건(CSH)
                if(callOrg == 'cart btnbag') {
                	recoCart = "Y";
                }

                // 올알랭 추가 - [3383769] (메인 페이지 개편) 올알랭 신규 건 (CSH)
                if(callOrg == 'prd-cart') {
                	recoCart = "Y";
                }

            }

            if (params.o2oDlvSp && params.o2oDlvSp != null) {
                if (params.o2oDlvSp == "2") {
                    data.cartTypeCd = "03";
                } else {
                    if (data.quickYn == 'Y') {
                        data.cartTypeCd = "02";
                    } else {
                        data.cartTypeCd = "01";
                    }
                }

            } else {
                if (data.quickYn == 'Y') {
                    data.cartTypeCd = "02";
                } else {
                    data.cartTypeCd = "01";
                }
            }

            var curaImg = $(obj).closest(".inner").find(".curaimg"); //메인페이지 레코벨 하단
            var curaImg2 = $(obj).closest("li").find(".curaimg"); //메인페이지 레코벨 상단
            var curaImg3 = $(obj).closest("div").find("a.prd_img").find("img"); //마이페이지 주문취소내역

            // 마이페이지 주문/배송조회 UI 개선으로 분기 처리 - [3330196] 올리브영 모바일 주문목록 개선 요청(CHY)
            var imgStr = "#" + params.goodsNo + "_" + tmpItemNo;
            var curaImg4 = $(imgStr).find("p.thum").find("a.prd_img").find("img");

            // 메인페이지 UI 분기처리 - [3383750] (메인 페이지 개편) OY추천상품 개선 건(CSH)
            var curaImg5 = $(obj).closest(".prod-inner").find(".pic-thumb");

            // 올알랭 추가 - [3383769] (메인 페이지 개편) 올알랭 신규 건 (CSH)
            var curaImg6 = $(obj).closest(".prd-item").find(".thumb");

            // [3407293] 주목해야 할 브랜드/카테고리 랭킹 개선 건
            var curaImg7 = $(obj).closest(".prod-wrap").find(".pic-thumb");

            // [3409501] 브랜드관 개발 요청(CHY)
            var curaImg8 = $(obj).closest("#planProd").find(".pic-thumb");
            var curaImg9 = $(obj).closest("#mdGoodsProd").find(".pic-thumb");

            // [3428979] 장바구니 옵션 있을 시, 오특, 신상, 카테고리, 중카테고리, 이벤트, 기프트관 > 베스트상품과 세트상품, 기프트관, 기프트관 > 브랜드, 오늘드림
            var curaImg10 = $(obj).closest(".prod").find(".thumb").find("img");

            // [3428979] 홈 > 인기 행사만 모았어요
            var curaImg11 = $(obj).closest("li").find(".thumb");

            // [342979] 검색 > 주간특가상품
            var curaImg12 = $(obj).closest(".prod").closest("li").find("img");

            var evtImg13 = $(obj).closest("#evtCartYn");

            var newGoodsImg = $(obj).closest(".goods-list").find('.thumb').find("img");

            var awardsGoodsImg = $(obj).closest('.product_inner').find('img');

            var adultImg = $(obj).closest(".goods-list").find('.thumb.adult');

            if (curaImg.length > 0) { //장바구니 옵션 팝업 이미지 호출 용
            	data.imgSrc = curaImg.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length > 0 && curaImg3.length <= 0){
            	data.imgSrc = curaImg2.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg3.length > 0){
            	data.imgSrc = curaImg3.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg4.length > 0){
            	data.imgSrc = curaImg4.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg5.length > 0){
            	data.imgSrc = curaImg5.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg6.length > 0){
            	data.imgSrc = curaImg6.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg7.length > 0){
            	data.imgSrc = curaImg7.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg8.length > 0){
            	data.imgSrc = curaImg8.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg9.length > 0){
            	data.imgSrc = curaImg9.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg10.length > 0){
            	data.imgSrc = curaImg10.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg11.length > 0){
            	data.imgSrc = curaImg11.attr("src");
            }else if (curaImg.length <= 0 && curaImg2.length <= 0 && curaImg12.length > 0){
            	data.imgSrc = curaImg12.attr("src");
            }else if (evtImg13.length > 0){
            	data.imgSrc = "noImg";
            }else{
            	data.imgSrc = $("#"+params.goodsNo).attr('data-part');
            }

            if(newGoodsImg.length > 0) {
                data.imgSrc = newGoodsImg.attr("src");
            }

            if(awardsGoodsImg.length > 0) {
                data.imgSrc = awardsGoodsImg.attr('src');
            }

            if(adultImg.length > 0) {
                data.imgSrc = adultImg.css("background-image").replace(/^url\(['"](.+)['"]\)/, '$1');
            }

            if (data.imgSrc == undefined) {
                data.imgSrc = "noImg";
            }

            if(params.optSelectYn == 'Y'){ //큐레이션 장바구니 옵션팝업에서 선택 버튼 클릭 했을 경우
            	data.optSelectYn = 'Y';
            }

            // 상품카드 장바구니버튼 트래킹코드
            common.cart.trackingInfo.setTrackingCd(obj);
            common.cart.cartBtnObj = $(obj);
            common.Ajax.sendRequest("POST", url, data, function (res) {

                // 임시회원 체크 후 회원연동 화면으로 이동
                var tmpOption = $("<div id=\"tmpOption\">" + res + "</div>");
                if (tmpOption.find("#isTempMember").val() === "true") {
                    location.href = _secureUrl + 'login/tempMemberBridge.do?returnUrl=' + encodeURIComponent(location.href);
                    return false;
                }

                if (options != undefined) {
                    common._callCartOptionSelect(res, options);
                } else {
                    common._callCartOptionSelect(res);
                }
            });
        }
    },

    // 상품 옵션에 유무에 따른 분기 로직
    _callCartOptionSelect : function(data, options) {

    	common.cart.scroll = $(window).scrollTop(); // 담기 후 스크롤 위치 이동을 위하여

        var tmpOption = $("<div id=\"tmpOption\">" + data + "</div>");

        // 프로모션 정보 가져오기
        common.cart.promKndCd = tmpOption.find("#promKndCd").val();
        common.cart.promNo = tmpOption.find("#promNo").val();
        common.cart.buyCnt = tmpOption.find("#buyCnt").val();
        common.cart.getItemAutoAddYn = tmpOption.find("#getItemAutoAddYn").val();

        var rccode = tmpOption.find("#recoRcCode").val();
        var cartTypeCd = tmpOption.find("#paramCartTypeCd").val();

        if(!common.isEmpty(rccode)) {
        	recoRcCode = rccode;
        } else {
        	recoRcCode = "";
        }

        var quickYn = tmpOption.find("#quickYn").val();
        var strNo = tmpOption.find("#recoStrNo").val();

        if(common.isEmpty(cartTypeCd)) {
            if (!common.isEmpty(quickYn) && quickYn == "Y") {
                cartTypeCd = "02";
            } else {
                cartTypeCd = "01";
            }
        }

        if(quickYn == "Y" && !common.isEmpty(strNo)) {
        	if($("#prdOptionPopup").find("input[name='recoStrNo']").length == 0) {
        		$("#prdOptionPopup").append("<input type='hidden' name='recoQuickYn' value='"+quickYn+"' />");
        		$("#prdOptionPopup").append("<input type='hidden' name='recoStrNo' value='"+strNo+"' />");
        	} else {
        		$("#prdOptionPopup").find("input[name='recoStrNo']").val(strNo);
        		$("#prdOptionPopup").find("input[name='recoQuickYn']").val(quickYn);
        	}
        }

        // 옵션 상품의 경우 옵션 레이어 노출 후 옵션상품 선택하는 로직이지만, 기획 요구사항으로 우선 이기능은 제외하고 적용함
        // 2019.12.08 | jp1020
        // if (tmpOption.find("#dupYn").val() != 'Y') {

        var itemNoList = [];

        tmpOption.find("li").each(function(){
            var optInfo = $(this).find('a');
            itemNoList.push(optInfo.attr("data-ref-itemNo"));
        });


        // 옵션이 없는 상품일 경우 바로 장바구니 등록

        var cartGoodsNo = tmpOption.find("#paramGoodsNo").val();
        var cartItemNo = (tmpOption.find("#dupYn").val() == "Y" && tmpOption.find("li").length == 1) ? itemNoList[0] : tmpOption.find("#paramItemNo").val()
        var ordPsbMinQty = tmpOption.find("#ordPsbMinQty").val();

        // 오늘드림  장바구니 저장하기 위한 값
        var cartQuickYn = tmpOption.find("#quickYn").val();

        // Y가 아닌경우는 오늘드림 관련 제어가 필요 없기 때문에 N으로 초기화
        if (cartQuickYn != "Y") {
            cartQuickYn = "N";
        }

        // 주문/베송조회, 취소/반품/교환 페이지와 자주 구매 상품 페이지에서는 구매한 수량 그대로 장바구니에 추가 - [3330196] 올리브영 모바일 주문목록 개선 요청(CHY)
        if(tmpOption.find("#paramLoadPage").val() == "order" || tmpOption.find("#paramLoadPage").val() == "often" ){
        	ordPsbMinQty = tmpOption.find("#paramTotalQty").val();
        }

       /*
   	 	  TODO 큐레이션 영역일 경우의 분기 추가 필요
                 주문내역쪽에서도 해당 펑션을 사용하지만 옵션팝업 호출이 불필요함
                 혹시 오늘 드림 장바구니에 넣어달라는 요구사항이 올수 있으나 해당 처리는 안되어 있음
       */
        /* [3330196] 올리브영 모바일 주문목록 개선 요청(CHY)
         * 마이페이지 주문/배송조회 장바구니 기능 개선으로 조건문 추가
         * loadPage가 order(주문/배송조회)이나 often(자주 구매 상품)이 아닐 때만 옵션 레이어 팝업 노출
         */

        const isOption = tmpOption.find("#dupYn").val() == "Y" && tmpOption.find("li").length > 1;

        if(isOption && tmpOption.find("#optSelectYn").val() == "N" && tmpOption.find("#paramLoadPage").val() != "order" && tmpOption.find("#paramLoadPage").val() != "often"){ //옵션 있는 상품의 경우 AND 옵션 선택팝업에서 장바구니 담기로 호출 된 경우가 아닐 때
           if (recoCart == "G") {
               common.prdOptPopLayerOpen('prdOptionPopup','giftMain');
           } else {
               common.prdOptPopLayerOpen('prdOptionPopup');
           }

        $("#prdOptionPopup .choice").html('상품을 선택해주세요.'); //[3401377] 장바구니 담기시 옵션 상품일 경우 이전 선택 값 초기화 진행   | 2020.09.15 | -by jp1020

       	$("#prdOptionPopup .item-box img").attr("src", tmpOption.find("#optImgSrc").val());
       	var onlyoneSctStr = "";
// 옵션창 exclusive 제거 20201117
//        if (tmpOption.find("#onlyoneSctCd").val() == "1") {
//            onlyoneSctStr = "<strong class=\"exclusive\">EXCLUSIVE</strong> ";
//        }
       	// [3428979] 브랜드 노출 안하기로
       	//$("#prdOptionPopup .bname").html(onlyoneSctStr + tmpOption.find("#onlBrandName").val());
       	$("#prdOptionPopup .iname").text(tmpOption.find("#goodsNm").val());
       	$("#prdOptionPopup .item-box img").attr("alt", tmpOption.find("#goodsNm").val());

       	tmpOption.find("#onlBrandName").val()

       	var optionHtml = ""; //옵션 리스트 영역
       	tmpOption.find("li").each(function(){
       		var optInfo = $(this).find('a');
       		var optionPrice = $(this).find(".price").text().replace('원','').trim();

       		optionHtml += "<li>"
       		optionHtml += '<a href="#" class="price-box" data-ref-goodsNo="'+optInfo.attr("data-ref-goodsNo")
       												   +'" data-ref-itemNo="'+optInfo.attr("data-ref-itemNo")+'">';
       		optionHtml += 	'<div class="txt-opt">';
       		optionHtml += 		'<p class="oname">'+$(this).find(".optItemName").text()+'</p>';
       		if($(this).find(".icon").length > 0){
       			optionHtml += 		'<p class="icon">';
       			if($(this).find(".plus").length > 0){
       				optionHtml += 			'<span class="plus">'+$(this).find(".plus").text()+'</span>';
       			}
       			if($(this).find(".delivery").length > 0){
       				optionHtml += 			'<span class="delivery">오늘드림</span>';
       			}
       			optionHtml += 		'</p>';
       		}
       		optionHtml += 	'</div>';
       		optionHtml +=  	'<span class="price">' + optionPrice + '<em>원</em>' + '</span>';
       		optionHtml += '</a>';
       		optionHtml += '</li>';
       	});

       	$("#reco_option_area").html(optionHtml); //옵션 선택 영역 생성

       	if(tmpOption.find("#optImgSrc").val() == 'noImg'){
        	$("#prdOptionPopup .img-ar").remove();

            $("#prdOptionPopup .select-type").css({
                marginTop: 0,
                width: '100%'
            })
        } else {
       	    if (!$("#prdOptionPopup .img-ar").length) {
                $("#prdOptionPopup .select-type").removeAttr('style');
                $("#prdOptionPopup .item-box").prepend('<div class="img-ar"><img src="" alt="" /></div>');
                $("#prdOptionPopup .item-box img").attr("src", tmpOption.find("#optImgSrc").val());
                $("#prdOptionPopup .item-box img").attr("alt", tmpOption.find("#goodsNm").val());
            }
        }



       	//20200901 기프트관 일 시 안내문구 추가 및 퍼블 적용 CBLIM
        if(callOrg == 'btn_basket') {
        	$("#gift_guidance_txt").empty();
           	$("#reco_option_area").closest(".select-type").after('<div class="txt_info_gift" id="gift_guidance_txt">'
           															+'<p class="txt_1">선물 받는 분이 같은 가격의 옵션으로 직접 변경할 수 있어요!</p>'
           														+'</div>'
           	);
           	$("#prdOptionPopup").find(".btnLineGreen").attr('class','btnLineGreen mgTz');
           	$("#prdOptionPopup").find(".btnGreen").attr('class','btnGreen mgTz');
        }
       	//20200901 기프트관 일 시 안내문구 추가 CBLIM

       	$("#reco_option_area").find('li').click(function(){ //옵션 선택시 이벤트
       		var target = $(this).closest(".select-type");
       		var optName = $(this).find(".oname").text();
       		var optPrice = $(this).find(".price").text();
       		var selectHtml = '<p class="txt">'+optName+'<em class="pri">'+optPrice+'</em></p>';
       		target.find(".choice").html(selectHtml);
       		void 0;
       		var goodsNo = $(this).find('a').attr("data-ref-goodsNo");
       		var itemNo = $(this).find('a').attr("data-ref-itemNo");
       		$("#prdOptionPopup input[name='goodsNo']").val(goodsNo);
       		$("#prdOptionPopup input[name='itemNo']").val(itemNo);
       	});

       	$('.select-type').unbind('click');

        $('.select-type').click(function(e){//셀렉트 박스 오픈 이벤트  퍼블 작업
            var _this = $(this),
                _inner = _this.find('.inner');

            if(_inner.hasClass('open')){
                _inner.removeClass('open');

                if ($('#prdOptionPopup').css('display') == 'block') {
                    $('#prdOptionPopup').css('margin-top', (parseInt($('#prdOptionPopup').css('margin-top').substring(0, $('#prdOptionPopup').css('margin-top').length - 2)) + ($('.sel-list').height() / 2)) + 'px');
                }
            }else{
                _inner.addClass('open');

                if ($('#prdOptionPopup').css('display') == 'block') {
                    $('#prdOptionPopup').css('margin-top', (parseInt($('#prdOptionPopup').css('margin-top').substring(0, $('#prdOptionPopup').css('margin-top').length - 2)) - ($('.sel-list').height() / 2)) + 'px');
                }
            }
            return false;
        });

       }else if (cartGoodsNo != undefined && cartGoodsNo != "" && cartItemNo != undefined && cartItemNo != "") {
            var resultData = new Array();
            var param = {
                goodsNo : cartGoodsNo,
                itemNo : cartItemNo,
                ordQty : ordPsbMinQty,
                quickYn : cartQuickYn,
                cartTypeCd : cartTypeCd
            }
            resultData.push(param);

            // 프로모션이 동일(P201), A+B(P203) 이고, N+1 중 N이 1인 경우, FreeGift 가 1종류인 경우
            // Get상품 추가
            var promNo = common.cart.promNo;
            var promKndCd = common.cart.promKndCd;

            var buyGoodsNo = cartGoodsNo;
            var buyItemNo = cartItemNo;
            var buyOrdQty = 1;
            var samePrdSumOrdQty = buyOrdQty;
            var buyCondStrtQtyAmt = common.cart.buyCnt;

            var getItemAutoAddYn = common.cart.getItemAutoAddYn;
            var getGoodsNo = (promKndCd == "P201") ? cartGoodsNo : tmpOption.find("#getItemGoodsNo").val();
            var getItemNo = (promKndCd == "P201") ? cartItemNo : tmpOption.find("#getItemItemNo").val();

            if (promNo != undefined && promNo != '' && buyCondStrtQtyAmt == 1) {
                if (promKndCd == "P201"
                        || (promKndCd == "P203" && getItemAutoAddYn == "Y" && getGoodsNo != undefined
                                && getGoodsNo != '' && getItemNo != undefined && getItemNo != '')) {
                    var getGoodsData = {
                        goodsNo : getGoodsNo,
                        itemNo : getItemNo,
                        ordQty : buyOrdQty,
                        rsvGoodsYn : "N", // 예약상품여부
                        dispCatNo : "", // 전시카테고리 번호
                        drtPurYn : "N", // 바로구매여부
                        promKndCd : promKndCd, // 프로모션구분
                        crssPrstNo : promNo, // 프로모션번호
                        prstGoodsNo : buyGoodsNo, // 타겟buy군의 상품번호
                        prstItemNo : buyItemNo, // 타겟buy군의 아이템번호
                        buyCondStrtQtyAmt : buyCondStrtQtyAmt,
                        samePrdSumOrdQty : samePrdSumOrdQty, // 상품번호 아이템번호가
                                                                // 같은상품의 수량을 합한값
                        getItemAutoAddYn : getItemAutoAddYn,
                        cartTypeCd : cartTypeCd
                    };

                    resultData.push(getGoodsData);
                }
            }
            // N+1 동일 일 경우 장바구니에 자동 추가 (끝)

            // 장바구니 적재
            var resultData = common.cart.regCart(resultData, 'N', '', 'Y');

            if (common.cart.cartBtnObj) {
                if (common.cart.cartBtnObj.attr('data-ref-cornernm') && common.cart.cartBtnObj.attr('data-ref-goodstrackingno')) {
                    var eventProperties = {
                        entry_source: common.getPageName(),
                        click_source: common.cart.cartBtnObj.attr('data-ref-cornernm'),
                        brand_name: common.cart.cartBtnObj.attr('data-ref-goodsbrand'),
                        product_category: common.cart.cartBtnObj.attr('data-ref-goodscategory'),
                        product_name: common.cart.cartBtnObj.attr('data-ref-goodsnm'),
                        product_number: common.cart.cartBtnObj.attr('data-ref-goodsno'),
                        product_option: resultData.gtmGoodsInfoList && resultData.gtmGoodsInfoList.length > 0 ? resultData.gtmGoodsInfoList[0].itemNm || "" : "",
                        product_type: resultData.result ? common.cart.cartBtnObj.attr('data-ref-goodstype') :  resultData.message,
                        number: common.cart.cartBtnObj.attr('data-ref-goodstrackingno')
                    }

                    if (resultData.result) {
                        callLogEvent("상품카드_장바구니 완료", eventProperties);
                    } else {
                        callLogEvent("상품카드_장바구니 미완료", eventProperties);
                    }

                }
                common.cart.cartBtnObj = undefined;
            }

            if (resultData.result) {
                // 장바구니 담기 완료 메세지
            	// 2020-08-27 옴니채널 서비스 구축 - 큐레이션 : 장바구니 담기 후 토스트 팝업으로 전체 변경
            	/*if(recoCart == 'Y') {
            		common.cart.showBasket2(cartGoodsNo);
            	}else if(recoCart == 'G'){						//20200827 기프트관 장바구니 분기처리 CBLIM
            		common.cart.showBasket3(cartGoodsNo);
            	}else{
            		common.cart.showBasket();
            	}*/

            	if(recoCart == 'G'){						//20200827 기프트관 장바구니 분기처리 CBLIM
            		common.cart.showBasket3(cartGoodsNo);
            	}else{
            		common.cart.showBasket();
            	}

            	if(resultData.gtmGoodsInfoList && resultData.gtmGoodsInfoList.length > 0) {
            	    var gtmInfo = resultData.gtmGoodsInfoList[0];
            	    var categoryArray = gtmInfo.stdCatNm.split('>');
            	    var price = Number(gtmInfo.salePrc);
                    common.app.sendEventForFirebase('add_to_cart', {
                        currency: "KRW",
                        lgc_goods_no: gtmInfo.lgcGoodsNo,
                        value: price,
                        items: [{
                            item_id: gtmInfo.goodsNo,
                            item_name: gtmInfo.goodsNm,
                            item_brand: gtmInfo.onlBrndNm,
                            currency: "KRW",
                            item_category: categoryArray[0],
                            item_category2: categoryArray[1],
                            item_category3: categoryArray[2],
                            price: price,
                            quantity: 1
                        }]
                    });
                }

                // onSuccess 콜백 함수 추가 -- 2024.05.13
                try {
                    if(options && options.onSuccess && typeof options.onSuccess === 'function') {
                        options.onSuccess(resultData);
                    }
                } catch(_) {
                    void 0;
                }
            }

            var brazeProductInfoList = resultData.gtmGoodsInfoList;

            if(!!brazeProductInfoList && brazeProductInfoList.length > 0) {
                const onlBrndNm = brazeProductInfoList[0].onlBrndNm;
                const dispCatNm = brazeProductInfoList[0].dispCatNm;
                const dispCatArr = dispCatNm.replaceAll(' ','').split('>');
                const smlCatNm = dispCatArr.pop() || "";
                const midCatNm = dispCatArr.pop() || "";
                const lagCatNm = dispCatArr.pop() || "";
                common.callBrazeProductCustomEvent(brazeProductInfoList[0], 'goodsCart');
                common.callBrazeCustomAttribute('goodsCart_Brnd', onlBrndNm);
                common.callBrazeCustomAttribute('goodsCart_goodsNmNo', brazeProductInfoList[0].goodsNm + '|' + brazeProductInfoList[0].goodsNo);
                common.callBrazeCustomAttribute('goodsCart_dispCate', lagCatNm + '|' + midCatNm + '|' + smlCatNm);

            }

            try {
                var goodsPrice = Number(resultData.gtmGoodsInfoList[0].salePrc);
                var contentsForFixel = [{
                    id: resultData.gtmGoodsInfoList[0].goodsNo,
                    quantity: 1,
                }];

                common.sendMetaAddToCart(contentsForFixel, goodsPrice);
            } catch(_) {
                void 0;
            }

            try {
                var productAf = resultData.gtmGoodsInfoList[0];
                var contentsForAppsFlyer = [{
                    id: productAf.goodsNo,
                    quantity: 1,
                }];
                var leafDispCategoryNm = productAf.dispCatNm.split('>')[0];

                common.app.callTrackEvent('cart', {
                    "af_price": productAf.salePrc,
                    "af_content_id": productAf.goodsNo,
                    "af_content_nm": productAf.goodsNm,
                    "af_category_nm": leafDispCategoryNm,
                    "af_brand": productAf.onlBrndNm,
                    "af_quantity": "1",
                    "af_content_type": "product",
                    "af_content": JSON.stringify(contentsForAppsFlyer).replace(/"/g, "'"),
                    "af_currency": "KRW",
                    "af_revenue": productAf.salePrc,
                    "af_member_level_on": "",
                });
            } catch(_) {
                void 0
            }


        } else {
            alert("판매종료된 상품입니다. 다른 상품을 담아주세요.");
            recoRcCode = "";
        }
        /*
         * } else { //옵션이 있는경우 $("#basketOption").html(data);
         *  // 옵션변경일 경우 선택된 옵션은 음영처리 var optChgYn =
         * (common.cart.regCartRecoBellGoodsInCartYn == "Y") ? "N" :
         * $("#optChgYn").val(); var selGoodsNo = $("#paramGoodsNo").val(); var
         * selPkgGoodsObj = $("table.tbl_prd_list").find("tr[pkgGoodsNo=" +
         * selGoodsNo + "]").attr("goodsNo"); var selItemNo =
         * $("#paramItemNo").val();
         *
         * if(selPkgGoodsObj != undefined) selGoodsNo = selPkgGoodsObj;
         *  // [START 오늘드림 옵션상품 개선:jwkim] var cartQuickYn =
         * tmpOption.find("#quickYn").val();
         *  // 오늘드림인 경우 오늘드림이 아닌 옵션상품을 품절처리 // (품절 문구는 없으나 품절처럼 선택할 수 없게 하기위해서
         * 사용) if(cartQuickYn == "Y"){ $("#basketOption
         * .nonQuick").addClass("soldout"); } // [END 오늘드림 옵션상품 개선:jwkim]
         *
         * if(optChgYn == "Y"){ $("ul.sel_option_list li").each(function(){ var
         * curGoodsNo = $(this).find("a").attr("data-ref-goodsNo"); var
         * curItemNo = $(this).find("a").attr("data-ref-itemNo");
         *
         * if( selGoodsNo == curGoodsNo && selItemNo == curItemNo ){
         * $(this).addClass("on");
         * $("a#mainCartSelect").text($(this).find("span.option_value").text()); }
         * });
         *
         * if($("ul.sel_option_list li").length <= 1)
         * $("a#mainCartSelect").text("선택 가능한 상품이 없습니다."); }
         *
         * fnLayerSet('basketOption', 'open');
         *
         * //닫기버튼 클릭이벤트 $("#basketOption").find(".layer_close").bind('click',
         * function(){ fnLayerSet('basketOption', 'close'); }); }
         */
    },

    before_regCart : function(idName, options){
    	var goodsNo = $("#"+idName+" input[name=goodsNo]").val();
    	var itemNo = $("#"+idName+" input[name=itemNo]").val();

    	// 큐레이션 팝업 - 장바구니 담기 위해 추가.
    	var strNo = $("#"+idName+" input[name=recoStrNo]").val();
    	var quickYn = $("#"+idName+" input[name=recoQuickYn]").val();
    	if (goodsNo != undefined && goodsNo != "") {
            if (options != undefined && options != null) {
                common.gf_regCart($("<span data-goods-no='"+goodsNo+"' data-opt-select-Yn='Y' data-item-no='"+itemNo+"' data-rccode='"+recoRcCode+"' data-strno='"+strNo+"' data-quick-yn='"+quickYn+"'>"), options);
            } else {
                common.gf_regCart($("<span data-goods-no='"+goodsNo+"' data-opt-select-Yn='Y' data-item-no='"+itemNo+"' data-rccode='"+recoRcCode+"' data-strno='"+strNo+"' data-quick-yn='"+quickYn+"'>"));
            }
    		common.popLayerClose(idName);
    	}else{
    		alert("상품을 선택해주세요"); //TODO 메시지 확인할 것
    	}

    },

    _giftCardCheck : function(data) {
    	var retStr = 'N';

    	var giftcardText = ['기프트카드', '기푸트카드', '기프드카드', '기프투카드', '기프트가드', '기프트카두', '기푸드카드', '기푸투카드', '기푸트가드', '기푸트카두', '기프드가드',
				    		'기프드카두', '기프투가드', '기프투카두', '기프트가두', '기푸드가드', '기푸드카두', '기프드가두', '기프투가두', '기푸투카두', '기푸드가두', '기푸투가두',
				    		'기프트카트', '키프트카드', '기츠트카드', '기프티카드', '기프트칻ㅡ', '기브트카드', '기푸트카트', '기프투카트', '기프트가트', '기프트카투', '기푸투카트',
				    		'기푸트가트', '기푸트카투', '기프투가트', '기프투카투', '기프트가투', '기프투가투', '기푸투카투', '기푸트가투', '기푸투가투', '키푸트카드', '키프드카드',
				    		'키프투카드', '키프트가드', '키프트카두', '키푸드카드', '키푸투카드', '키푸트가드', '키푸트카두', '키프드가드', '키프드카두', '키프투가드', '키프투카두',
				    		'키프트가두', '키푸드가드', '키푸드카두', '키프드가두', '키프투가두', '키푸투카두', '키푸드가두', '키푸투가두'];

    	data = data.replaceAll(' ','');

    	if( giftcardText.indexOf(data) > -1){
    		retStr = 'Y';
    	}

    	return retStr;
    },

    /** 쿠폰 다운로드 콜백 함수 liveCommerce 제공하기위해 공통영역에 생성
     *  -by jp1020 2020-05-19
     * * */
    _callBackCouponDownload : function(data){
        if( data.ret == '-1'){
            common.link.moveLoginPage();
        }else{
            alert(data.message);
            //common.popLayerClose('LAYERPOP01');
        }

    },

    /** 쿠폰 다운로드 클릭 * */
    couponDownload : function(cpnNo){
        var url = _baseUrl + "main/downCouponJson.do";
        var data = {cpnNo : cpnNo};
        common.Ajax.sendRequest("POST",url,data,common._callBackCouponDownload);
    },
    sendRecobell : function(item_id, track, onlineItemId) {
	    var src = (('https:'==document.location.protocol)?'https':'http')+'://logger.ai.oliveyoung.co.kr/js/logger.min.js';
	    var scriptLen = $("script").filter("[src='"+src+"']").length;

	    if(scriptLen == 0) {
	    	(function(s,x){s=document.createElement('script');s.type='text/javascript';
		    s.async=true;s.defer=true;s.src=(('https:'==document.location.protocol)?'https':'http')+
		    '://logger.ai.oliveyoung.co.kr/js/logger.min.js';
		    x=document.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);})();
	    }

	    eglc.op('setVar', 'cuid', recoCuid);
	    eglc.op('setVar', 'itemId', item_id);
	    eglc.op('setVar', 'onlineItemId', !onlineItemId ? '' : onlineItemId);

	    if(track == "cart" && !common.isEmpty(recoRcCode)) {
	    	eglc.op('setVar', 'rcCode', recoRcCode);
	    	recoRcCode = "";
	    }

	    eglc.op('setVar', 'userId', hashedRecoSsoMbrNo);
	    eglc.op('track', track);
    },

    //oy 레이어팝업 S
    oyLayerOpen : function(id){
        var oylayId, oyPosY;
        $htmlBody = $('html, body');
        oyWrapper = $('#mWrapper');

        common.oylayId = $('#'+id);
        common.scrollOff();
        common.dimShow();
        common.oylayId.show();
        common.popPos();
    },
    dimShow : function(){
        common.oylayId.append('<div class="oyDimmed"></div>');
        $('.oyDimmed').on('click', function(){
            common.oyLayerClose(common.oylayId);
        });
    },
    popPos : function(){
        var height = $(window).height(),
            lay = common.oylayId.children('.oyLayerContainer'),
            layConts = common.oylayId.find('.oyContents'),
            layContsh = layConts.height(),
            layCont = lay.find('.oyCont'),
            layConth = height-90,
            layh = lay.height(),
            layhban = layh/2;
        if(height<=layh){
            if(layCont.hasClass('oyBtnFix')){
                layCont.css({
                    'max-height':layConth-70,
                    'touch-action':'auto',
                });
                layhban = common.oylayId.children('.oyLayerContainer').height()/2
            }else{
                layCont.css({
                    'max-height':layConth,
                    'touch-action':'auto',
                });
                layhban = common.oylayId.children('.oyLayerContainer').height()/2
            }
        }
        layCont.scrollTop(0);
        lay.css('margin-top', -layhban);
    },
    oyLayerClose : function(id){
        common.scrollOn();
        common.oylayId.hide();
        $('.oyDimmed').remove();
    },
    scrollOff : function(){
        oyPosY = window.pageYOffset;
        var varUA = navigator.userAgent.toLowerCase();

        if(common.oylayId.hasClass('oyFullLayer')){
            oyWrapper.css({'position':'fixed','top': -oyPosY});
            $htmlBody.addClass('scrollfix');
        }else{
            if(varUA.indexOf('android') > -1) {
                $htmlBody.addClass('scrollOff');
            }else if( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
                $htmlBody.addClass('scrollfix');
                oyWrapper.css({position:'fixed','top': -oyPosY});
            }else{
                $htmlBody.addClass('scrollfix');
                oyWrapper.css({position:'fixed','top': -oyPosY});
            }
        }
    },
    scrollOn : function(){
        $htmlBody.removeClass('scrollfix scrollOff');
        oyWrapper.removeAttr('style');
        $(window).scrollTop(oyPosY);
    },
    oyFullOpen : function(id){
        $htmlBody = $('html, body');
        oyWrapper = $('#mWrapper');
        common.oylayId = $('#'+id);
        common.scrollOff();
        common.oylayId.show();
        common.oylayId.find('.oyContents').scrollTop(0);
        if(common.app.appInfo.hassafearea == "true") {
            $("body").attr("style","position:inherit;overflow:inherit!important;height:100vh");
            $("html").removeClass("scrollfix");
        }
    },
    oyFullClose : function (id){
        common.scrollOn();
        common.oylayId.hide();
        if(common.app.appInfo.hassafearea == "true") {
            $("body").attr("style","");
        }
    },

    setBrandZzimOn : function(type){
        if(type=='on'){
            //$('#brandOn').fadeIn(500);
            // $('.com.zzimOn.brand').fadeIn(500);

            $(".layerAlim").removeClass("Basket");
            $(".layerAlim").removeClass("zzimOff");
            $(".layerAlim").removeClass("zzimOn");
            $(".layerAlim").removeClass("brand");

            $(".layerAlim").addClass("zzimOn").show();
            $(".layerAlim > p").html("");

            setTimeout(function(){
                $(".layerAlim").removeClass("zzimOn").hide();
            }, 1070);
        }

        // else{
        //     $('#brandOff').fadeIn(500);
        //     // $('.layerAlim.zzimOff.brand').fadeIn(500);
        // }

        // setTimeout(function(){
        //     $(".laytoast").fadeOut(800);
        // }, 1200);
    },
    //oy 레이어팝업 E

    goLinkUrl: function(url, trackingCd) {
        var linkUrl = url;
        if (!common.isEmpty(trackingCd)) {
            var trackingParam = '';
            if (url.indexOf('?') > -1) {
                trackingParam = '&trackingCd=' + trackingCd;
            } else {
                trackingParam = '?trackingCd=' + trackingCd;
            }

            if (url.indexOf('#') > -1) {
                var link = url.split('#');
                linkUrl = link[0] + trackingParam + '#' + link[1];
            } else {
                linkUrl = url + trackingParam
            }
        }
        location.href = linkUrl;
    },

    setCookie : function(name, value, expires) {
        var expdate = new Date();

        if (typeof expires == 'undefined') {
            document.cookie = name + "=" + value + "; path=/; domain=" + document.domain + ";";
        } else {
            expdate.setTime(expdate.getTime() + (typeof expires == 'number' ? expires : (1 * 24 * 60 * 60 * 1000)));
            document.cookie = name + "=" + value + "; path=/; domain=" + document.domain + "; expires="
                + expdate.toGMTString();
        }
    },
    setCookie_search : function(c_name,value,exdays) {
        var exdate=new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString())+ ";";
        c_value += "path=/;";
        document.cookie=c_name + "=" + c_value;
        common.app.syncCookie();
    },
    setSessionCookie : function(name, value) {
        this.setCookie(name, value);
    },
    getCookie : function(name) {
        var cName = name + '=';
        var cookieData = document.cookie;
        var start = cookieData.indexOf(cName);
        var cValue = '';
        if (start != -1) {
            start += cName.length;
            var end = cookieData.indexOf(';', start);
            if (end == -1)
                end = cookieData.length;
            cValue = cookieData.substring(start, end);
        }
        return unescape(cValue);
    },
    getBrndLikeInfo : function(onlBrndCd) {
        var brndLikeInfo = null;
        if ((onlBrndCd != null && onlBrndCd != "")) {
            var url = _baseUrl + "common/getBrndLikeInfoAjax.do";
            $.ajax({
                type: "POST",
                url: url,
                data: { "onlBrndCd" : onlBrndCd },
                dataType: 'json',
                async: false,
                success: function (data) {
                    if (data) {
                        brndLikeInfo = data;
                    }
                }
            });
        }

        return brndLikeInfo;
    },
     /**
     * 파라미터 문자열을 파싱하여 객체로 반환
     * (URL이 아닌 순수 파라미터 문자열만 가능)
     *
     * @param {String} querystring key1=value1&key2=value2
     * @returns {Object} paramObject {{ key1: value1, key2: value2 }}
     */
    parseQuerystringToObject: function (querystring) {
        const ret = {};
        const params = querystring.split('&');
        for (const param of params) {
            const [key, value] = param.split('=');
            ret[key] = value;
        }
        return ret;
    },
    convertObjectToQuerystring: function(obj) {
      var str = [];
      for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
          str.push((p) + "=" + (encodeURIComponent(obj[p])));
        }
      }
      return str.join("&");
    },
    /**
     * 입력된 문자열을 사이즈만큼 잘라서 리턴
     */
    cmCheckMaxSize : function(_input, size) {
        var str = _input.val();
        if(str.length > size) {
            var pos = _input[0].selectionEnd;
            var endStr = str.substring(pos, str.length);
            var startStr = str.substr(0, size-endStr.length);
            _input.val(startStr+endStr);
            _input[0].setSelectionRange(startStr.length,startStr.length);
        }
    },

    getValueForABTestFromPCID : function () {
        let cookie = common.getFullNameCookie('PCID') || "0";
        return cookie.slice(cookie.length-1) < 5 ? 'A' : 'B'
    },

    getTrackingCodeForABTest : function (trackingCode) {
        return common.getValueForABTestFromPCID() === 'A' ? trackingCode : trackingCode + '_B';
    },

    getFullNameCookie : function (name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin == -1) {
            begin = dc.indexOf(prefix);
            if (begin != 0) {
                return null;
            }
        } else {
            begin += 2;
        }

        var end = document.cookie.indexOf(";", begin);

        if (end == -1) {
            end = dc.length;
        }

        return unescape(dc.substring(begin + prefix.length, end));
    },

    // braze
    isApp: function() {
        var ua = (window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent.toLowerCase() : undefined;
        var parseResult = {
            appver : null,
            ostype : null,
            osver : null,
            devicemodel : null,
            deviceid : null,
            mode : null,
            isapp : false,
            hassafearea : false
        };
        var tmpSplitArr = ua.split(" ");
        var itemArr;
        if (tmpSplitArr.length > 0) {
            for (var i = 0; i < tmpSplitArr.length; i++) {
                if (tmpSplitArr[i].trim() == "") {
                    continue;
                }
                itemArr = tmpSplitArr[i].trim().split(/\//g);
                if (itemArr.length > 1) {
                    parseResult[itemArr[0]] = itemArr[1];
                }
            }
            if (parseResult.appver != null && parseResult.deviceid != null) {
                parseResult.isapp = true;
            }
        }

        return parseResult.isapp;
    },

    initBraze: function(brazeApiKey, brazeSDKEndPoint, gtmMbrNoForBraze, ssoMbrNo) {
        if(!common.isApp()) {
            +function(a,p,P,b,y){a.braze={};a.brazeQueue=[];for(var s="BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson Banner CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty automaticallyShowInAppMessages hideContentCards showContentCards showInAppMessage toggleContentCards changeUser destroy getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardDismissal logContentCardImpressions logContentCardClick logCustomEvent logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags".split(" "),i=0;i<s.length;i++){for(var m=s[i],k=a.braze,l=m.split("."),j=0;j<l.length-1;j++)k=k[l[j]];k[l[j]]=(new Function("return function "+m.replace(/\./g,"_")+"(){window.brazeQueue.push(arguments); return true}"))()}window.braze.getCachedContentCards=function(){return new window.braze.ContentCards};window.braze.getUser=function(){return new window.braze.User};window.braze.getFeatureFlag=function(){return new window.braze.FeatureFlag};(y=p.createElement(P)).type='text/javascript';
                y.src='https://js.appboycdn.com/web-sdk/6.5/braze.min.js';
                y.async=1;(b=p.getElementsByTagName(P)[0]).parentNode.insertBefore(y,b)
            }(window,document,'script');
            var hashedGtmMbrNoForBraze = '';
            var hashedSsoMbrNo = '';

            if(gtmMbrNoForBraze !== 'null' && gtmMbrNoForBraze) {
                hashedGtmMbrNoForBraze = CryptoJS.SHA256(gtmMbrNoForBraze).toString();
            }
            if(ssoMbrNo !== 'null' && ssoMbrNo) {
                hashedSsoMbrNo = CryptoJS.SHA256(ssoMbrNo).toString();
            }

            braze.initialize(brazeApiKey, {
                enableLogging: false,
                allowUserSuppliedJavascript: true, // braze에서 배너를 띄우기 위함
                baseUrl: brazeSDKEndPoint,
                minimumIntervalBetweenTriggerActionsInSeconds: 0,
            });
            braze.automaticallyShowInAppMessages();

            if(hashedGtmMbrNoForBraze) {
                common.isLogin(function () {
                    braze.changeUser(hashedGtmMbrNoForBraze);
                    if(hashedSsoMbrNo) {
                        braze.getUser().addAlias(hashedSsoMbrNo, 'cjone_memberNumber');
                    }
                });
            }

            braze.openSession();
        }
    },

    callBrazeProductCustomEvent: function(data, type) {
        if(data) {
            var url = window.location.search;
            var params = new URLSearchParams(url);
            var paramDispCatNo = params.get('dispCatNo') === null ? data.dispCatNo : params.get('dispCatNo');
            var clickAreaStr = "올리브영";
            if (paramDispCatNo) {
              clickAreaStr = paramDispCatNo.startsWith("400000") ? "올리브베러" : "올리브영";
            }

            let dispCatNm = data.dispCatNm;
            if ($("#categoryShop_small_name").length != 0) {
                var large = $("#categoryShop_large_name").val();
                var middle = $("#categoryShop_middle_name").val();
                var small = $("#categoryShop_small_name").val();
                dispCatNm = "특대" + " > " + large + " > " + (middle==="전체"?"":middle) + " > " + (small==="전체"?"":small);
            }

            var currentCatArray = ['lagCate', 'midCate', 'smlCate'];
            var categoryObj = common.getBrazeCategoryProperty(data.stdCatNm, currentCatArray);
            var displayCatObj = common.getDisplayBrazeCategoryObj(dispCatNm, paramDispCatNo);

            var brazeObj = {
                onlBrndNm : data.onlBrandName || data.onlBrndNm || '',
                onlBrndCd : data.onlBrndCd || '',
                goodsNo : data.goodsNo || '',
                goodsNm : data.goodsNm || '',
                price : Number.isNaN(+data.salePrc) ? 0 : +data.salePrc,
                date : common.setBrazeDateFormat(),
                click_area: clickAreaStr
            }

            var returnObj = { ...categoryObj, ...brazeObj, ...displayCatObj };

            common.callBrazeCustomEvent(type, returnObj);
        }
    },

    setBrazeDateFormat: function() {
        var d = new Date();
        var currentMonth = common.setNumberPadLeft((d.getMonth()+1));
        var currentDate = common.setNumberPadLeft(d.getDate());
        var currentHour = common.setNumberPadLeft(d.getHours());
        var currentMinute = common.setNumberPadLeft(d.getMinutes());

        //return  [d.getFullYear().toString(), currentMonth, currentDate].join('-') + ' ' + [currentHour, currentMinute, '00'].join(':') ;
        return  [currentMonth, currentDate, d.getFullYear().toString()].join('/') + ' ' + [currentHour, currentMinute].join(':');
    },

    setNumberPadLeft: function(input) {
        if(!input) {
            return '';
        }

        return input.toString().padStart(2,'0');
    },

    getBrazeCategoryProperty: function (productCategory, categoryArray) {
        var currentProductArray = productCategory.length > 0 ? productCategory.split('>') : ['', '', ''];

        var categoryPropertyObject = {};

        categoryArray.forEach(function (value, index) {
            categoryPropertyObject[categoryArray[index]] = currentProductArray[index] ? currentProductArray[index].trim() : '';
        })

        return categoryPropertyObject;
    },

    encodeBrazeValues: function (obj) {
        if(!obj) {
            return obj;
        }

        var result = {};
        for(var key in obj) {
            var value = encodeURIComponent(obj[key]);
            result[key] = value;
        }
        return result;
    },

    callBrazeCustomEvent: function (customEventType, brazeObj) {
        if (common.isApp()) {
            var currentBrazeObj = {
                customEvent: customEventType,
                brazeObj: brazeObj === undefined ? {} : brazeObj,
            };

            common.app.sendCustomEventForBraze(currentBrazeObj);
        } else {
            braze.logCustomEvent(customEventType, brazeObj === undefined ? {} : brazeObj);
        }
    },

    callBrazeCustomAttribute: function (attributeName, attributeValue) {
        if(!attributeName) return;

        if (common.app != undefined && common.app.appInfo != undefined && common.app.appInfo.isapp) {
            common.app.addCustomAttributeForBraze(attributeName, attributeValue);
        } else {
            braze.getUser().addToCustomAttributeArray(attributeName, attributeValue);
        }
    },

    callBrazeSetCustomAttribute: function (attributeName, attributeValue) {
        if(!attributeName) return;

        if (common.app != undefined && common.app.appInfo != undefined && common.app.appInfo.isapp) {
            common.app.setCustomAttributeForBraze(attributeName, attributeValue);
        } else {
            braze.getUser().setCustomUserAttribute(attributeName, attributeValue);
        }
    },

    callBrazePurchaseEvent: function (price, quantity, purchaseObj) {
        var productId = 'onl_purchase';

        if (common.app != undefined && common.app.appInfo != undefined && common.app.appInfo.isapp) {
            common.app.sendPurchaseEventForBraze(productId, price, quantity, purchaseObj);
        } else {
            braze.logPurchase(productId, price, 'USD', quantity, purchaseObj);
            braze.requestImmediateDataFlush();
        }

        if(purchaseObj.gift_order =="Y"){
            common.callBrazeCustomAttribute('getGiftOrderComplete', new Date().format("MM/dd/yy"));
        }
    },

    // header에서 바로 호출하기 때문에 common.app 이 존재하지 않아 공통 customEvent 에서 제외
    callBrazeAgreeTerm: function() {
            sessionStorage.removeItem('callBrazeMemberJoin');
    },

    callBrazeMainPageAccessEvent: function () {
        // http://cjics.cj.net/jira/browse/CJOYCOMM-582
        if(common.app.appInfo.isapp && !localStorage.getItem(STORAGE_KEY.LOCAL.IS_ACCESSED_FOR_BRAZE_POPUP)) {
            localStorage.setItem(STORAGE_KEY.LOCAL.IS_ACCESSED_FOR_BRAZE_POPUP, true);
            return;
        }
        if(sessionStorage.getItem(STORAGE_KEY.SESSION.CALL_BRAZE_MAIN_YN) !== "Y") {
            sessionStorage.setItem(STORAGE_KEY.SESSION.CALL_BRAZE_MAIN_YN, "Y");
            common.callBrazeCustomEvent('main_intropopup', {});
        }
    },

    callBrazeAllLiveNotificationEvent: function (evtNo, evtTitle) {
        common.callBrazeCustomEvent('liveNotificationButton', { evtNo });
        common.callBrazeCustomAttribute('liveNotificationButton', evtNo + " | " + evtTitle);
    },

    callBrazeAllLiveEnterButtonEvent: function (evtNo) {
        common.callBrazeCustomEvent('liveEntry', { evtNo });
    },

    callBrazeOyLiveEnterEvent: function (evtNo, liveTitle, endDt, reEntry) {
        common.callBrazeCustomEvent('OyliveEntry', { evtNo, liveTitle, endDt, reEntry });
        common.callBrazeCustomAttribute('OyliveEntry', liveTitle + "|" + evtNo + "|" + endDt + "|" + reEntry);
    },

    // 장바구니 진입 시점에 체크 되어있는 상품 가격 전송
    callBrazeEnterCart: function (formattedTotalPrc, formattedSalePrc, o2oOrder) {
        const totalPrc = formattedTotalPrc.replace(/[, ]/g, '');
        const salePrc = formattedSalePrc.replace(/[, ]/g, '');

        common.callBrazeCustomEvent('enterCartPage', {
            o2o_order: o2oOrder,
            price: parseInt(totalPrc) - parseInt(salePrc), // 배송비 제외한 결제예상금액 (총 상품금액 - 총 할인금액)
        });
    },

    // 상품상세페이지 내 CE
    callBrazeGoodsDetailBtnBrand: function(onlBrndCd, onlBrndNm) {
        common.callBrazeCustomEvent('goodsDetail_btn_brand', { onlBrndCd, onlBrndNm });
    },

    callBrazeGoodsDetailBtnTodayDelivery: function(errorInfo) {
        common.callBrazeCustomEvent('goodsDetail_btn_todayDelivery', { errorInfo });
    },

    callBrazeGoodsDetailBtnGift: function() {
        common.callBrazeCustomEvent('goodsDetail_btn_gift');
    },

    callBrazeGoodsDetailBtnBuy: function() {
        common.callBrazeCustomEvent('goodsDetail_btn_buy');
    },

    callBrazeGoodsDetailBtnReview: function() {
        common.callBrazeCustomEvent('goodsDetail_btn_review');
    },

    callBrazeGoodsDetailBtnRelation: function() {
        common.callBrazeCustomEvent('goodsDetail_btn_relation');
    },

    callBrazeGoodsDetailBtnBenefit: function() {
        common.callBrazeCustomEvent('goodsDetail_btn_benefits');
    },

    callBrazeAdInFlow: function() {
        var BRAZE_SESSION_KEY = "callBrazeAdClickYn";
        var adClickAlready = sessionStorage.getItem(BRAZE_SESSION_KEY);

        if(adClickAlready === 'Y') return;

        var url = window.location.search;
        var params = new URLSearchParams(url);

        var afSub2 = params.get('af_sub2');
        var afSub3 = params.get('af_sub3');
        var afSub4 = params.get('af_sub4');

        if(afSub2 && afSub2.startWith('adCom-')) {
            common.callBrazeCustomEvent('adClick', {
                campaign: afSub2,
                type: afSub3,
                detailType: afSub4,
            });
            sessionStorage.setItem(BRAZE_SESSION_KEY, "Y");
        }
    },

    // 9월 브랜딩캠페인
    getDateBrnActiveFormat: function() {
        var today = new Date();
        var year = today.getFullYear().toString().substring(2, 4);
        var month = (today.getMonth()+1).toString().padStart(2, '0');
        var date = today.getDate().toString().padStart(2, '0');
        var hour = today.getHours().toString().padStart(2, '0');
        var min = today.getMinutes().toString().padStart(2, '0');

        return year + '/' + month + '/' + date + ' ' + hour + ':' + min;
    },

    callBrazeBrnMission: function(missionStatusYn) {
        var actvCount = missionStatusYn.filter(function(x) {
            return x === 'Y';
        }).length;

        common.callBrazeCustomEvent('BRN_CMP_mission_actv', {
            mission_actvTime: this.getDateBrnActiveFormat(),
            mission1_actvYn: missionStatusYn[0],
            mission2_actvYn: missionStatusYn[1],
            mission3_actvYn: missionStatusYn[2],
            mission4_actvYn: missionStatusYn[3],
            mission5_actvYn: missionStatusYn[4],
            mission6_actvYn: missionStatusYn[5],
            mission_actvCount: actvCount,
        });
    },

    callBrazeBrnMissionCpn: function(isCpnReceive) {
        common.callBrazeCustomEvent('BRN_CMP_getCpn', {
            BRN_CMP_cpnY: isCpnReceive ? 'Y' : null,
            BRN_CMP_cpnTime: this.getDateBrnActiveFormat(),
        });
    },

    callBrazeBrnEventApply: function(isApply) {
        common.callBrazeCustomEvent('BRN_CMP_getEvt', {
            BRN_CMP_EvtYn: isApply ? 'Y' : 'N',
            BRN_CMP_EvtTime: this.getDateBrnActiveFormat(),
        });
    },

    callBrazeReviewProfile: function(reviewInfo) {
        common.callBrazeCustomEvent('reviewerProfile', {
            reviewer_skinCondition: reviewInfo.reviewer_skinCondition,
            reviewer_reviewCount: reviewInfo.reviewer_reviewCount,
            reviewer_assistanceCount: reviewInfo.reviewer_assistanceCount,
            reviewer_ranking: reviewInfo.reviewer_ranking,
        })
    },

    callBrazeReviewLounge: function() {
        common.callBrazeCustomEvent('reviewLounge', {});
    },

    callBrazeKakaoShare: function(shareCnt) {
        common.callBrazeCustomEvent('kakaoshare', {
            frievent1_count: shareCnt,
        });
    },

    callBrazeKakaoSecretShare: function(isSecretYn) {
        common.callBrazeCustomEvent('kakaoshare_secret', {
            frievnt1_secret: isSecretYn,
        });
    },

    callBrazeBlackFriCoupon: function(cpnName, cpnNo, type) {
        var eventName = '';
        if(!type) {
            switch(cpnName) {
                case 'APP':
                    eventName = 'getBlackFriCoupon_APP';
                    break;
                case 'OFF':
                    eventName = 'getBlackFriCoupon_OFF';
                    break;
                case 'PRM':
                    eventName = 'getBlackFriCoupon_PRM';
                    break;
            }
        } else {
            switch(cpnName) {
                case 'APP':
                    eventName = 'getBlackFriCoupon2_APP';
                    break;
                case 'OFF':
                    eventName = 'getBlackFriCoupon2_OFF';
                    break;
            }
        }

        var couponParam = {
            cpnYn: cpnNo ? 'Y' : 'N',
        }
        if(cpnNo) {
            couponParam.cpnNo = cpnNo;
        }

        common.callBrazeCustomEvent(eventName, couponParam);
    },

    callBrazeFriSoldoutApply: function() {
        var now = new Date();
        var month = now.getMonth() + 1;
        var date = now.getDate();
        if(month !== 11) return;
        if(date < 8 || date > 14) return;

        var soldOutDate = {}
        soldOutDate[`day_${date}`] = 'Y';

        common.callBrazeCustomEvent('soldout_raffle', soldOutDate);
    },

    callBrazeFriNumber: function() {
        var now = new Date();

        var session1S = new Date('2022.11.08 00:00:00');
        var session1E = new Date('2022.11.08 18:59:59');
        var session2E = new Date('2022.11.09 18:59:59');
        var session3E = new Date('2022.11.10 18:59:59');
        var session4E = new Date('2022.11.11 18:59:59');
        var session5E = new Date('2022.11.11 23:59:59');

        var sessionObj = {};

        if (now - session1S < 0 || now - session5E > 0) return;
        if (now - session1E <= 0) {
            sessionObj.session_1 = 'Y';
        } else if (now - session2E <= 0) {
            sessionObj.session_2 = 'Y';
        } else if (now - session3E <= 0) {
            sessionObj.session_3 = 'Y';
        } else if (now - session4E <= 0) {
            sessionObj.session_4 = 'Y';
        } else {
            sessionObj.session_5 = 'Y';
        }

        common.callBrazeCustomEvent('fri_number', sessionObj);
    },

    getDisplayBrazeCategoryObj: function (currentDispCatNm, currentDispCatNo) {
        var currentCatArray = ['disp_lagCate', 'disp_midCate', 'disp_smlCate'];
        var displayCategory = common.getDisplayCategoryList(currentDispCatNm);

        var displayCatObj = {};
        displayCatObj['disp_lagCateNo'] = common.sliceOrEmpty(currentDispCatNo, 11);
        displayCatObj['disp_midCateNo'] = common.sliceOrEmpty(currentDispCatNo, 15);
        displayCatObj['disp_smlCateNo'] = common.sliceOrEmpty(currentDispCatNo, 19);
        return {...common.getBrazeCategoryProperty(displayCategory, currentCatArray), ...displayCatObj};

    },
    sliceOrEmpty(value, len) {
        return typeof value === 'string' && value.length >= len
            ? value.slice(0, len)
            : '';
    },
    getDisplayCategoryList: function (dispCategory) {
        if (typeof dispCategory !== 'string' || !dispCategory.includes('>')) {
            return [];
        }
        var dipCategoryArray = dispCategory.split('>');
        return dipCategoryArray.slice(1, dipCategoryArray.length).join('>');
    },

    // 올라이브 tracking
    allLiveClickEvent: function(evtNo) {
        common.app.sendEventForFirebase('live_click', { evtNo });
        common.app.callTrackEvent('af_live_click', { 'evtNo' : evtNo });
    },

    allLiveAlarmEvent: function(evtNo) {
        common.app.sendEventForFirebase('live_alarm', { evtNo });
        common.app.callTrackEvent('af_live_alarm', { 'evtNo' : evtNo });
    },

    allLiveCommentEvent: function(evtNo) {
        common.app.sendEventForFirebase('live_comment', { evtNo });
        common.app.callTrackEvent('af_live_comment', { 'evtNo' : evtNo });
    },

    allLiveGateNoLogin: function(resvId) {
        common.app.sendEventForFirebase('live_gate_nologin', { resvId: resvId });
        common.app.callTrackEvent('af_live_gate_nologin', { resvId: resvId });
    },

    allLiveGateLogin: function(resvId) {
        common.app.sendEventForFirebase('live_gate_login', { resvId: resvId });
        common.app.callTrackEvent('af_live_gate_login', { resvId: resvId });
    },

    allLiveGateNologinEntrace: function(resvId) {
        common.app.sendEventForFirebase('live_gate_nologin_entrance', { resvId: resvId });
        common.app.callTrackEvent('af_live_gate_nologin_entrance', { resvId: resvId });
    },

    allLiveGateLoginEntrace: function(resvId) {
        common.app.sendEventForFirebase('live_gate_login_entrance', { resvId: resvId });
        common.app.callTrackEvent('af_live_gate_login_entrance', { resvId: resvId });
    },

    // 선물하기, 기프트카드 tracking
    giftClickEvent: function() {
        common.app.sendEventForFirebase('gift_shop' );
        common.app.callTrackEvent('af_gift_shop');
    },
    giftAddToCartEvent: function() {
        var stdCatNm = $('#stdCatNm').val();
        var categoryNm = stdCatNm.split('>')[0];
        var giftCartParam = {
            af_content_id: $('#goodsNo').val(),
            af_category_nm: categoryNm,
            af_quantity: $('#totalCnt').text(),
            af_price: $('#totalPrc').val(),
            af_content_nm: $('#goodsNm').val(),
        }

        common.callBrazeGoodsDetailBtnGift();
        common.app.sendEventForFirebase('gift_btn', giftCartParam);
        common.app.callTrackEvent('af_gift_btn', giftCartParam);
    },
    giftPurchaseEvent: function(giftPurchaseParam) {
        common.app.sendEventForFirebase('gift_purchase', giftPurchaseParam);
        common.app.callTrackEvent('af_gift_purchase', giftPurchaseParam);
    },
    giftCardClickEvent: function() {
        common.app.sendEventForFirebase('giftcard_shop');
        common.app.callTrackEvent('af_giftcard_shop');
    },
    giftCardPurchaseEvent: function(giftPurchaseParam) {
        common.app.sendEventForFirebase('giftcard_purchase', giftPurchaseParam);
        common.app.callTrackEvent('af_giftcard_purchase', giftPurchaseParam);
    },

    // 오늘 드림 tracking
    pickupPurchaseEvent: function(pickupPurchaseParam) {
        common.app.sendEventForFirebase('pickup_purchase', pickupPurchaseParam);
        common.app.callTrackEvent('af_pickup_purchase', pickupPurchaseParam);
    },

    // 라이브관 입장 tracking
    liveEntranceEvent: function() {
        common.app.sendEventForFirebase('live_shop');
        common.app.callTrackEvent('af_live_shop');
    },

    // Amplitude TabbarTracking
     tabbarTracking: function(eventName, click_source) {
       var eventProperties = {
         entry_source: "탭바",
         click_source,
       };

       callLogEvent(eventName, eventProperties);
     },

    /**
     * Meta interface
     */
    sendMetaViewContent: function(contentId, totalPrice) {
        fbq('track', 'ViewContent', {
            content_ids: [contentId],
            content_type: 'product',
            value: totalPrice,
            currency: 'KRW',
        });
    },

    sendMetaAddToCart: function(contents, totalPrice) {
        fbq('track', 'AddToCart', {
            contents: contents,
            content_type: 'product',
            value: totalPrice,
            currency: 'KRW',
        });
    },

    sendMetaPurchase: function(contents, totalPrice) {
        fbq('track', 'Purchase', {
            contents: contents,
            content_type: 'product',
            value: totalPrice,
            currency: 'KRW',
        });
    },
    /**
     * Hackle 공통 헬퍼 - SDK 준비 + userId/vstrId 동기화 후 callback 실행
     * hackleInit.jsp가 include된 페이지에서만 동작하며, init 안 된 페이지에서는 no-op.
     *
     * ⚠️ setUser는 overwrite 동작:
     *   - 여기서 명시하지 않은 properties/deviceId는 모두 초기화됨
     *   - setUserProperty/updateUserProperties 등으로 속성을 추가할 경우
     *     이 헬퍼 호출 이후 해당 속성이 사라질 수 있음
     *   - properties 도입 시 이 헬퍼 내부 setUser에도 함께 포함시킬 것
     *
     * @param callback (hackleClient) => void
     */
    hackleReady: function(callback) {
        if (typeof hackleClient === 'undefined') return;
        hackleClient.onReady(function() {
            // vstrId fallback: JSP 주입이 없으면 (최초 방문자) Dataplatform에서 재조회
            if (!window.hackleVstrId
                && typeof Dataplatform !== 'undefined'
                && Dataplatform.userProperties
                && Dataplatform.userProperties.visitor_id) {
                window.hackleVstrId = Dataplatform.userProperties.visitor_id;
            }

            // 핵클 user 구성 (userId + $vstrid 커스텀 식별자)
            var identifiers = {};
            if (window.hackleVstrId) {
                identifiers['$vstrid'] = window.hackleVstrId;
            }
            hackleClient.setUser({
                userId: window.hackleHashedMbrNo || undefined,
                identifiers: identifiers
            });

            callback(hackleClient);
        });
    },

    /**
     * Hackle A/B 테스트
     * @param actionA variation A일때 callback
     * @param actionB variation B일때 callback
     */
    hackleVariation: function(actionA, actionB) {
        common.hackleReady(function(client) {
            var decision = client.variationDetail(hackleExperimentKey);
            /* 드래프트/종료 → 신규(B), 정지 → 기존(A), 그 외 → variation */
            switch(decision.reason) {
                case 'EXPERIMENT_DRAFT':
                case 'EXPERIMENT_COMPLETED':
                    actionB();
                    break;
                case 'EXPERIMENT_PAUSED':
                    actionA();
                    break;
                default:
                    if (decision.variation === 'B') actionB();
                    else actionA();
            }
        });
    },

    showFailMessage: function(message){
        // trigger 된 toast body에 존재할 경우 return
        if ($('.toast').length) {
            return;
        }

        // toast text 클래스 제어
        // :: 현재 footerTab 쪽 lci (하단 메뉴바) 존재할 경우
        //    => class="toast"에 "live" 클래스 추가를 통해 bottom 위치 up
        var html = "<div class='toast'><p>" + message + "</p></div>";

        // document에 추가
        $("body").append(html);

        // toast up/down action time 후 element 제거
        setTimeout(function(){
            $(".toast").remove();
        }, 2800);
    },

    eventLoopUtil: {
        defaultOptions: {
            timeInterval: 1000,
            executeEventCondition: function () { return false; }
        },
        currentIntervalKey: 0,
        timeIntervalCount: 0,
        instance: {
            const: {
                /**
                 * @requiredFields: 'eventName', 'timeInterval', 'executeEventCondition', 'eventTrigger'
                 * @excludeFields: 'clearTrigger'
                 */
                EVENT_OBJECT_KEYS: ['eventName', 'timeInterval', 'executeEventCondition', 'eventTrigger'], //'clearTrigger'
                status: {
                    READY: 'READY',
                    START: 'START',
                    STARTED: 'STARTED',
                    STOP: 'STOP'
                }
            },
            _status: 'READY',
            start: function () {
                if (this._status === this.const.status.STARTED) return;
                this._status = this.const.status.START;
                common.eventLoopUtil._loop();
                this._status = this.const.status.STARTED;
            },
            stop: function () {
                clearInterval(this.currentIntervalKey);
            },
        },
        trigger: {
            objects: [],
            remove: function (eventName) {
                var foundIndex = -1;
                for (var i = 0; i < this.objects.length; i++) {
                    var object = this.objects[i];
                    if (object.eventName === eventName) {
                        foundIndex = i;
                        break;
                    }
                }
                if (foundIndex >= 0) {
                    this.objects.splice(foundIndex, 1);
                }
            }
        },
        _hasEvent: function (eventObject) {
            var eventName = eventObject.eventName;
            if (!eventName) void 0;
            return this._findTriggeredByEventName(eventName).length > 0
        },
        _validEvent: function (eventObject) {
            var eventObjectKeys = this.instance.const.EVENT_OBJECT_KEYS;
            var keys = Object.keys(eventObject);
            if (keys.length <= 0) return false;
            return eventObjectKeys.filter(function (defaultObjectKey) {
                return keys.indexOf(defaultObjectKey) > -1;
            }).length >= eventObjectKeys.length;
        },
        _findTriggeredByEventName: function (eventName) {
            return this.trigger.objects.filter(function (legacyEvent) {
                return legacyEvent.eventName === eventName;
            });
        },
        _loop: function () {
            function isRunTimeForInterval(timeIntervalCount, timeInterval) {
                return ((timeIntervalCount * 1000) % timeInterval) === 0;
            }

            var timeIntervalCount = this.timeIntervalCount,
                trigger = this.trigger,
                triggers = trigger.objects;

            function setTimeLimit() {
                if (timeIntervalCount >= 60) {
                    timeIntervalCount = 0;
                }
            }

            this.currentIntervalKey = setInterval(function () {
                for (var i = 0; i < triggers.length; i++) {
                    var event = triggers[i];
                    var eventName = event.eventName;
                    var eventTrigger = event.eventTrigger;
                    var timeInterval = event.timeInterval
                        || common.eventLoopUtil.defaultOptions.timeInterval;
                    var clearTrigger = event.clearTrigger;
                    var executeEventCondition = event.executeEventCondition
                        || common.eventLoopUtil.defaultOptions.executeEventCondition;
                    var doRunTrigger = isRunTimeForInterval(timeIntervalCount, timeInterval);
                    if (doRunTrigger && executeEventCondition && executeEventCondition()) {
                        eventTrigger();
                    }
                    if (clearTrigger && clearTrigger()) {
                        trigger.remove(eventName);
                    }
                    setTimeLimit();
                }
                timeIntervalCount++;
            }, this.defaultOptions.timeInterval);
        },
        /**
         * 이벤트 옵션 오브젝트
         * @Parameter {
         *    eventName(:required): [String],
         *    timeInterval(:required): [Number],
         *    executeEventCondition(:required): [Function] @return true/false [실행 조건 작성]
         *    eventTrigger(:required): [Function], [이벤트 작성]
         *    clearTrigger: [Function] @return true/false, [이벤트 종료 조건 작성]
         * }
         */
        setEventTrigger: function (eventObject) {
            if (!this._validEvent(eventObject)) {
                void 0;
                void 0;
                return;
            }

            var replaceObject = eventObject.isReplaceObject && eventObject;
            if (replaceObject) {
                this.trigger.remove(eventObject.eventName);
            }

            if (this._hasEvent(eventObject)) {
                return;
            }

            this.trigger.objects.push(eventObject);
            this.instance.start();
        },
    },

    /**
     * Object를 URL parameter string으로 변경한다.
     * @param {object} obj e.g. {key1: value1, key2: value2}
     * @returns {string} "key1=value1&key2=value2"
     */
    getParameterString: function (obj) {
        var param = [];
        for(var key in obj) {
            param.push(key + "=" + encodeURIComponent(obj[key]));
        }
        return param.join("&");
    },

    /**
     * URL이 정상적이지 않을 경우 정상적인 URL로 변경해 줍니다.
     * @param urlString {string} 대상 URL e.g. display/getBrandShopDetail.do
     * @return {string} 변환된 URL e.g. http://display/getBrandShopDetail.do
     */
    normalizeURL: function (urlString) {
        // Check if the URL string starts with a protocol, and prepend if necessary
        if (!/^https?:\/\//i.test(urlString)) {
            urlString = "http://" + urlString;
        }

        return urlString;
    },


    /**
     * 대상 URL값에서 Query Parameter 값을 객체로 반환하는 함수
     * @param urlString 대상 URL e.g. http://example.com/test?param1=test&param2=test2#hash
     * @return {object} 변환된 URL e.g. { param1: test, param2: test2 }
     */
    parseQueryParameter: function (urlString) {
        if(typeof urlString !== "string") return {};

        var url = new URL(urlString);
        var queryParams = new URLSearchParams(url.search);

        var queryParameters = {};

        for (const [key, value] of queryParams) {
            queryParameters[key] = value;
        }

        return queryParameters;
    },

    /**
     * 대상 URL값에서 Hash Parameter 값을 객체로 반환하는 함수
     * @param urlString 대상 URL e.g. http://example.com/test?param1=test&param2=test2#hash
     * @return {string} 변환된 URL e.g. #hash
     */
    parseHashFragment: function(urlString) {
        if(typeof urlString !== "string") return {};

        var url = new URL(urlString);
        var hashFragment = url.hash;

        return hashFragment;
    },
    moveSmoothScroll: function(top, duration, callback) {
        var startPosition = window.scrollY;
        var distance = top - startPosition;
        var startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;

            var timeElapsed = currentTime - startTime;
            var run = ease(timeElapsed, startPosition, distance, duration);

            window.scrollTo(0, run);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            } else {
                $(window).trigger('onFinishAnimate');

                if(callback) callback();
            }
        }

        function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        $(window).trigger('onStartAnimate', { delay: duration });
        requestAnimationFrame(animation);
    }
};

$.namespace("common.header");
common.header = {

    bindFlag : "N",
    scpClickFlag : "N",
    suddenClickFlag : "N",

    init : function() {
        common.header.bindEvent();
        if (common.app.appInfo.isapp) {
            $(".mAllSearch").addClass("app");
        }

        // 메인 header GNB 영역
        if ($('#mGnb').length) {

            var isShowcaseMenu = false;
            var isCurationMenu = false;
            var showcaseMenuTitleLength = 0

            /*gnb_cate class 영역에 fix_layout class 추가
            case1.추천 메뉴 노출 && 쇼케이스 메뉴 노출 or case2.추천 메뉴 비노출 && 쇼케이스 메뉴 노출 (단, 쇼케이스 글자 5자 이상일 경우)*/
            $('#mGnb > ul > li').each(function () {
                var menuId = $(this).data('gnb-id');
                if (mmain.main.gnbInfo.showcase.menuId == menuId) {
                    isShowcaseMenu = true
                    showcaseMenuTitleLength = Number($(this).find('.text_box').data('title-length'))
                }
                if (mmain.main.gnbInfo.curation.menuId == menuId) {
                    isCurationMenu = true
                }
            });
            $('#mGnb').find('.gnb_cate').removeClass('fix_layout')
            if ((isCurationMenu && isShowcaseMenu) ||
                (!isCurationMenu && isShowcaseMenu && showcaseMenuTitleLength >= 5)) {
                $('#mGnb').find('.gnb_cate').addClass('fix_layout')
            }

            // 쇼케이스 메뉴 타이틀 글자수 7글자 초과할 경우 애니메이션 효과 적용
            if (showcaseMenuTitleLength > 7) {
                var $target = $('#mGnb').find('.text_box')
                $target.append(' ' + $target.html()).addClass('is-rolling')
            }
        }
    },
    //2020.07.21 slideSearchAjax.do Click Event 변경
    initSwiperSrcCnt : 1,
    clickSearchEvent : function(){
        $(document).scrollTop(0);

        common.gnb.initSearchPop();

        // setTimeout(function () {
        //    var textArea = $(".searchScpInput").val();
        //    if (textArea != undefined && textArea != "") {
        //    	//common.header.initSearchSwiper();
        //
        //    	 $("#mSearchWrapper").find('.search_auto_area').removeClass('off');
        //         $("#mSearchWrapper").find('.search_swiper_area').hide();
        //         $("#mSearchWrapper").find('.btn_sch_del').addClass('on');
        //         $("#mSearchWrapper").find('#mContainer').addClass('fix');
        //         $(".scp_cont").css("display", 'none');
        //    }
        //
        //     common.header.initSearchSwiper();
        //     $("#mSearchWrapper").find("#query").keyup();
    	// }, 100);
    },

    initSearchSwiper : function() {
        // [상세검색개선] 최근 검색어, 급상승, 최근본상품 swiper 2020-09-10
            var swiperIndex = Number(localStorage.getItem("searchSwiperIndex") || 1);

//    		if($('.dsearch')[0] && $('.dsearch')[0].swiper){
//            	$('.dsearch')[0].swiper.destroy();
//            }

    		//alert(cookieSwiperIndex);
    		//if (common.header.initSwiperSrcCnt == 0) {
				var swiperSrc = new Swiper('.dsearch', {
					initialSlide : swiperIndex,
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 12,
					pagination: { el: '.paging', clickable: true },
					loop :false
				});
				//common.header.initSwiperSrcCnt = 1;
			//}

			// 마지막으로 이동한 슬라이드를 저장한다.
			swiperSrc.on('slideChangeTransitionStart', function(e){
				//alert(swiperSrc.realIndex);
				//alert("realIndex : " + swiperSrc.realIndex);
				//cookie.set('swiperIndex', swiperSrc.realIndex);
                localStorage.setItem("searchSwiperIndex", swiperSrc.realIndex);
				// DS 처리
				if (swiperSrc.realIndex == 0) {
					common.wlog("home_header_search_recent"); //최근 검색어 탭
				} else if (swiperSrc.realIndex == 1) {
					common.wlog("home_header_search_populoar"); //급상승 검색어탭
				} else if (swiperSrc.realIndex == 2) {
					common.wlog("home_header_search_recentgoods"); //최근본 상품
				}
				//common.wlog();
				// 앱 쿠키 동기화
				common.app.syncCookie();
			});


			// 저장된 슬라이드로 이동
			//swiperSrc.slideTo(cookieSwiperIndex);

		// [상세검색개선] 최근 검색어, 급상승, 최근본상품 swiper 2020-09-10 - end
    },

    bindEvent : function() {
        $(".mAllSearch").find(".m_btn_barcode").bind("click", common.gnb.scanBarcodeThrottle("header_barcode_btn"));

        //2020.07.21 slideSearchAjax.do Click Event 변경
        $(".searchScp").bind("click", function() {
            common.header.clickSearchEvent();
        });

        // 2020-07-17 검색어 백버튼 분기처리용 플래그
        $("#sHeaderBackBtn_SearchMain").bind("click", function(){
            common.header.goSearchInputPage();
        });

        $("#sHeaderDrawer").bind("click", function(e){
            e.preventDefault();
            if ($(this).attr("data-ref-linkurl") != undefined && $(this).attr("data-ref-linkurl") != "") {
                location.href = $(this).attr("data-ref-linkurl");
            }
        });

        $("#sHeaderSearch").bind("click", function(e){
            e.preventDefault();

            if ($(this).attr("data-entrysource") && $(this).attr("data-clicksource")) {

                const customProperty = $(this).attr("data-customproperty");
                const title = $("#subTitle").text();
                const planNo = $(this).attr("data-planno");
                const properties = {
                    entry_source : $(this).attr("data-entrysource"),
                    click_source: $(this).attr("data-clicksource"),
                }

                if (customProperty) {
                    if (title) {
                        properties[customProperty] = $("#subTitle").text();
                    } else if ($(".tit.type-c").text()) {
                        properties[customProperty] = $(".tit.type-c").text();
                    }
                }

                if (planNo) {
                    properties.dispcatno = planNo;
                }

                callLogEvent("검색입력창 진입 페이지", properties);
            }

            if ($(this).attr("data-ref-linkurl") != undefined && $(this).attr("data-ref-linkurl") != "") {
                location.href = $(this).attr("data-ref-linkurl");
            }
        });

        $("#sHeaderHome").bind("click", function(e){
            e.preventDefault();
            if ($(this).attr("data-ref-linkurl") != undefined && $(this).attr("data-ref-linkurl") != "") {

                location.href = $(this).attr("data-ref-linkurl");
            }
        });

        $("#sHeaderBackBtn").bind("click", function(e){
            e.preventDefault();
            var dsId = $(this).attr("data-ref-clickId");
            var cUrl = location.href;

            if (dsId == "other") {
                if (cUrl.indexOf("/planshop/getSpcShopDetail.do?dispCatNo=500000200080001") > -1) {
                    common.wlog("premiumshop_header_back");
                    history.back();
                } else if (cUrl.indexOf("/main/getGiftMainList") > -1) {
                    common.wlog("giftmain_header_back");
                    display.gift.goHistoryBack();
                } else if (cUrl.indexOf("/counsel/getQnaForm") > -1) {
                  common.wlog("3type_header_back");
                  // 앱 버전 3.42.0 이상일 경우에만 스택스크린이다.
                  if(common.app.appInfo.isapp && (common.app.compareVersion(common.app.appInfo.appver, "3.42.0") === ">" || common.app.compareVersion(common.app.appInfo.appver, "3.42.0") === "=")) {
                    var finishStackScreen = function() {
                      // 앱 3.51.0 이상: 새 네이티브 웹뷰 → goBack (미만은 기존 스택스크린, 하위호환)
                      common.link.goBackScreen(function() {
                        if (common.header.finishStackScreen()) return;
                        history.back();
                      });
                    }
                    // 문의하기 페이지에서 나갈 경우 시스템 컨펌으로 확인한다.
                    // 1:1 문의 페이지가 스택스크린이 될 예정이므로 스택이 닫히는 인터페이스 호출하고 앱이 아닐 경우에는 인터페이스는 실행되지 않으니 뒤로가기 실행한다.
                    if($("#mTab").find("li.on").attr("id") == "qnaForm") {
                        // 문의하기 탭이 활성화인 경우에만 컨펌 노출한다.
                        if(confirm("문의를 취소하시겠습니까?\n작성중인 글은 삭제됩니다.")){
                          finishStackScreen();
                        }
                    } else {
                      finishStackScreen();
                    }
                  } else {
                    // 앱이 아닐 경우 또는 앱버전이 3.42.0 미만일 경우 기존과 동일하게
                    mcounsel.back()
                  }
                } else if (cUrl.indexOf("/mypage/getMySkinCondition") > -1) {
                    common.wlog("3type_header_back");
                    // 2021.10.19 리뷰스쿼드 리뷰어라운지 뎁스 추가로 인한 뒤로가기 방식 수정
                    // location.href= _baseUrl + 'mypage/getReviewerProfile.do';
                    // [2024-05 셔터브리티 모집] 로그인 페이지 타고 넘어온 경우 2회 뒤로가기
                    document.referrer.indexOf("/login/login.do") > -1 ? history.go(-2) : history.back();
                } else if (cUrl.indexOf("/mypage/getGdasList") > -1) {
                    common.wlog("3type_header_back");
                   // location.href= _baseUrl + 'mypage/myPageMain.do';
                    history.back();
                } else if (cUrl.indexOf("/display/getSCategoryList") > -1) {
                    if (typeof finishCategoryShopScreen !== "undefined") {
                        finishCategoryShopScreen();
                    } else {
                        history.back();
                    }
                    // displaysearch/display.js 에서 history.pushState({status:"MCategoryMain"},null,null); 하기 때문에 뒤로 가려면 두번 가야함
                    //if ( history.state != null && history.state.status == "MCategoryMain" ) {
                    //common.wlog("3type_header_back");
                    //history.go(-2);
                    //}
                } else if (cUrl.indexOf("/main/getSaleList") > -1) {
                    common.wlog("sale_header_back");
                    history.back();
                } else if (cUrl.indexOf("/main/getMembership") > -1) {
                    common.wlog("membership_header_back");
                    history.back();
                } else if (cUrl.indexOf("/giftCardGuide/getGiftCardGuide") > -1) {
                    common.wlog("giftcard_header_back");
                    history.back();
                } else if (cUrl.indexOf("/planshop/getSpcShopDetail.do?dispCatNo=500000200090001") > -1) {
                    common.wlog("petshop_header_back");
                    history.back();
                } else if (cUrl.indexOf("/counsel/main") > -1) {
                  common.wlog("counselmain_header_back");
                  // 앱 3.51.0 이상: 새 네이티브 웹뷰 → goBack (미만은 기존 스택스크린, 하위호환)
                  common.link.goBackScreen(function() {
                    // 앱 버전 3.42.0 이상일 경우에만 스택스크린이다.
                    if(common.app.appInfo.isapp && (common.app.compareVersion(common.app.appInfo.appver, "3.42.0") === ">" || common.app.compareVersion(common.app.appInfo.appver, "3.42.0") === "=")) {
                      // 고객센터 페이지가 스택스크린이 될 예정이므로 스택이 닫히는 인터페이스 호출하고 앱이 아닐 경우에는 인터페이스는 실행되지 않으니 뒤로가기 실행한다.
                      if (common.header.finishStackScreen()) return;
                    }
                    history.back();
                  });
                } else if (cUrl.indexOf("/mypage/getReviewerLounge") > -1) {
                    common.wlog("reviewerlounge_header_back");
                    history.back();
                } else if (cUrl.indexOf("/order/getOrderComplete.do") > -1) {
                    common.wlog("order/getOrderComplete_header_back");
                    location.href = _baseUrl + '/index.do';
                } else if (cUrl.indexOf("/orderGiftCard/getOrderComplete.do") > -1) {
                    common.wlog("orderGiftCard/getOrderComplete_header_back");
                    location.href = _baseUrl + '/index.do';
                } else if (cUrl.indexOf("/display/getCategoryShop.do") > -1) {
                    if (typeof finishCategoryShopScreen !== "undefined") {
                        finishCategoryShopScreen();
                    } else {
                        history.back();
                    }
                } else if (cUrl.indexOf("/display/getBrandShopDetail.do") > -1) {
                    if (typeof finishBrandShopScreen !== "undefined") {
                        finishBrandShopScreen();
                    } else {
                        history.back();
                    }
                } else if (cUrl.indexOf("/company/locationPolicy.do") > -1) {

                    if (window.App
                        && window.App.finishLocationTermsScreen) {
                        window.App.finishLocationTermsScreen();
                    }

                    if (window.webkit
                        && window.webkit.messageHandlers
                        && window.webkit.messageHandlers.finishLocationTermsScreen) {
                        window.webkit.messageHandlers.finishLocationTermsScreen.postMessage({});
                    }

                    history.back();

                } else if (cUrl.indexOf("/mbb/affiliate/affiliateComplete.do") > -1) {
                    common.wlog("MBB_affiliate_complete_back");
                    history.go(-2);
                    // location.href = _baseUrl + "";

                }  else if (cUrl.indexOf("/counsel/getNoticeList.do?ntcClssCd=03") > -1 || cUrl.indexOf("/mypage/getMyEventList.do") > -1 || cUrl.indexOf("/main/getPaymentBenefitInfo.do") > -1) {
                    if (common.header.finishStackScreen()) return;

                    history.back();
                } else if(cUrl.indexOf("/company/privacy") > -1) {
                  // 앱 버전 3.42.0 이상일 경우에만 스택스크린이다.
                  if(common.app.appInfo.isapp && (common.app.compareVersion(common.app.appInfo.appver, "3.42.0") === ">" || common.app.compareVersion(common.app.appInfo.appver, "3.42.0") === "=")) {
                    // 개인정보 처리방침 네이티브에서는 스택스크린화되어 인터페이스 존재시 스택이라 가정하고 스택을 닫는다.
                    if (common.header.finishStackScreen()) return;
                  }
                  history.back();
                } else {
                    common.wlog("3type_header_back");
                    history.back();
                }
            } else if (dsId === 'deliveryRegistForm' || dsId === 'getCancelForm') {
                history.back();
                return false;
            } else {
                common.wlog(dsId);
                if (dsId === "goodsdetail_header_back") sessionStorage.setItem("giftBack", "1");
                if (cUrl.substring(cUrl.length - 1, cUrl.length) == '#') history.go(-2);
                else history.back();
                //history.back();
            }

            // 상단 헤더 뒤로가기서 펑션 호출
            common.header.goodsStackScreen('finishGoodsDetailScreen');
        });
        $("#mypageAlarmBtn").bind("click", function(e) {
            e.preventDefault();
            sessionStorage.setItem("notificationBoxFilter", null);
            common.wlog("mypage_main_alarm");
            common.link.moveAppPushHistList();
        });
    },
    callSuddenKeyWord : function(){


    	/* [상세검색개선] 삭제
    	if($(".searchFix #mTab11 li:eq(1)").hasClass("on")){
    		suddenKeyword();
    		common.header.suddenClickFlag = "Y";
    	}

    	$(".searchFix #mTab11 li:eq(1)").on("click", function(){
    		if (common.header.suddenClickFlag == "N") {
    			suddenKeyword();
    			common.header.suddenClickFlag = "Y";
    		}
        });
    	[상세검색개선] 삭제 - end */

    	//[상세검색개선] 급상승 키워드 2020-09-02
   		suddenKeyword('keyword_main');
		//[상세검색개선] 급상승 키워드 2020-09-02 - end
    },
    appDownBannerMainInit : function() {
        // 배너를 종료여부
        if (sessionStorage.getItem("bannerCloseYn") != "Y") {
            // 유입채널이 있으면
            // if($("#chlNoBanner")!=undefined && $("#chlNoBanner")!="" &&
            // $("#chlNoBanner")!=null && $("#chlNoBanner").val().length>0){
            // 앱이 아니면
            if (common.app.appInfo == undefined || !common.app.appInfo.isapp) {
                $('#webBanner_main').css("display", "block");
            }
            // }
        }

        var webBannerTimeout = setTimeout(function() {
            // 앱다운로드 배너 추가건
            /*
             * BI Renewal. 20190918. nobbyjin. Start
             * if($('#webBanner_main').css("display") == 'block'){
             * $('#webBanner_main').parent().css('height', '190px');
             * $('#mHome-visual').css({'padding-top':'48px'}); }else
             * if($('#webBanner_main').css("display") == 'none'){
             * $('#webBanner_main').parent().css('height', '142px');
             * $('#mHome-visual').css({'padding-top':'0'}); } BI Renewal.
             * 20190918. nobbyjin. End
             */
            if ($('#webBanner_main').css("display") == 'block') {
                $('#mContainer.mMain').css({
                    'padding-top' : '135px'
                });
            } else if ($('#webBanner_main').css("display") == 'none') {
                $('#mContainer.mMain').css({
                    'padding-top' : '87px'
                });
            }
            clearTimeout(webBannerTimeout);
        }, 200);
        common.header.appDownBannerMainBindEvent();
    },

    appDownBannerMainBindEvent : function() {
        if (common.header.bindFlag == "N") {
            $("#banner_close_main").bind("click", function() {
                common.wlog("appDownClose");
                $('#webBanner_main').css('display', 'none');
                $('#webBanner_main').parent().css('height', '87px');
                // BI Renewal. 20190918. nobbyjin. Start
                // $('#mHome-visual').css({'padding-top':'0'});
                $('#mContainer.mMain').css({
                    'padding-top' : '87px'
                });
                // BI Renewal. 20190918. nobbyjin. End
                sessionStorage.setItem("bannerCloseYn", "Y");

            });
            $("#hd_banner_cont_main").bind("click", function() {
                common.header.appDownLink();
            });

        }
        common.header.bindFlag = "Y";

    },
    getScpGoodsListAjax : function() {
        var url = _baseUrl + "common/getScpGoodsListAjax.do";
        var loginResult = false;

        $.ajax({
            type : "POST",
            url : url,
            data : null,
            async : false,
            cache : false,
            success : function(data) {
                common.header.getScpGoodsListAjaxCallBack(data);
            },
            error : function() {

            }
        });
    },
    getScpGoodsListAjaxCallBack : function(data) {

        $("#scp_cont_id").html(data);
        common.wish.init();
        common.gnb.initScpSwiper();
        common.bindGoodsListLink();
    },
    appDownBannerInit : function() {
        // 배너를 종료여부
        if (sessionStorage.getItem("bannerCloseYn") != "Y") {
            // 유입채널정보가 있으면
            // if($("#chlNoBanner")!=undefined && $("#chlNoBanner")!="" &&
            // $("#chlNoBanner")!=null && $("#chlNoBanner").val().length>0){
            // 앱이 아니면
            if (common.app.appInfo == undefined || !common.app.appInfo.isapp) {
                $('#webBanner_detail').css("display", "block");
            }
            // }
        }

        if ($('#webBanner_detail').css("display") == 'block') {
            $('#mHeader.subHead.detail').css("height", "auto");
            $('#mHgroup').css("height", "auto");
        } else if ($('#webBanner_detail').css("display") == 'none') {
            $('#mHeader.subHead.detail').css("height", "60px");
            // BI Renewal. 20190918. nobbyjin.
            // $('#mHgroup').css("height","97px");
        }
        common.header.appDownBannerBindEvent();
    },
    appDownBannerBindEvent : function() {
        $("#banner_close_detail").bind("click", function() {
            $('#webBanner_detail').css('display', 'none');
            $('#mHeader.subHead.detail').css("height", "60px");
            // BI Renewal. 20190918. nobbyjin.
            // $('#mHgroup').css("height","97px");
            $('#mHeader.sHeader').css({
                'margin-top' : '0px'
            });
            sessionStorage.setItem("bannerCloseYn", "Y");
            common.wlog("appDownClose");
        });
        $("#hd_banner_cont_detail").bind("click", function() {
            common.header.appDownLink();
        });
    },

    openSearch : function() {
        common.wlog("mFooterTabSearch");
        location.href = "/m/mtn/search";
    },

    appDownLink : function() {

        common.wlog("appDownLink");
        // var linkUrl =
        // window.location.href.substring(window.location.href.indexOf("/m/")+3,window.location.href.length);
        // BI Renewal. 20190918. nobbyjin. - Link 수정
        // var linkUrl = "main/getCouponList.do?tabIdx=0&couponMode=coupon"
        var today = new Date().format("yyyyMMdd");
        var linkUrl = "event/getEventDetail.do?evtNo=00000000006705";

        if (today >= 20210801) {
        	linkUrl = "event/getEventDetail.do?evtNo=00000000007817";
        }
        if (today >= 20210901) {
            linkUrl = "event/getEventDetail.do?evtNo=00000000007840";
        }
        common.link.commonMoveUrl("common/getAppDownload.do?redirectUrl=" + linkUrl);
    },
    goSearchInputPage: function() {
        history.back();
    },
    resetSearchInputPage: function() {
        location.replace('/m/mtn/search');
    },
    /**
     * 마이페이지 설정 오픈 툴팁
     * 1. 하루 1 회 툴팁 노출
     * 2. 마이페이지 > 설정 진입 회원은 노출 없음.
     * 3. 1/25~2/7일까지 노출
     * 4. myPageTooltip {expiry: new Date() , mypage: 'Y', setting:'Y'}
     */
    myPageToolTip: function() {
        var today = new Date();
        if(new Date(2024,1,8) <= today){
            // 2024.02.07 까지 노출 8일부터는 미노출
            // month index 0~11
            localStorage.removeItem('myPageTooltip'); // 사용 값 삭제
            return;
        }

        localStorage.removeItem('myPageTooltipConnectedYn'); // 기존값 삭제
        var myPageTooltip = localStorage.getItem('myPageTooltip');
        if(myPageTooltip != null && myPageTooltip != undefined && myPageTooltip != ''){
            try{
                //  myPageTooltip {expiry: , mypage: 'Y', setting:'Y'}
                myPageTooltip = JSON.parse(myPageTooltip);
                // 1. 설정페이지 진입 회원은 미노출
                if('Y' === myPageTooltip.setting){
                    return;
                }
                // 2. 당일자 내에 마이페이지 진입 이력 있으면
                if('Y' === myPageTooltip.mypage
                    && today.toDateString() === new Date(myPageTooltip.expiry).toDateString()){
                    return;
                }
            }catch (e) {
                // ignore error
            }
        }

        // 객체 존재할때 애니메이션 동작
        var myPageTooltipDiv = document.querySelector('#myPageTooltip');
        if (myPageTooltipDiv) {
            localStorage.setItem('myPageTooltip', JSON.stringify({expiry: today, mypage: 'Y', setting:'N'}));
            myPageTooltipDiv.classList.add('on');
            setTimeout(function() {
                myPageTooltipDiv.classList.remove('on');
                myPageTooltipDiv.classList.add('off');
            }, 3500);
        }
    },
    /**
     * 상품상세페이지 스택스크린 펑션 체크 및 펑션 호출
     * @param methodName        실행할 메소드명
     * @param methodParam       실행할 메소드의 필요 파라미터
     * @param version           체크할 앱버전
     * @param stackScreenPage   스택스크린적용된 페이지
     */
    goodsStackScreen(methodName, methodParam = {}, version = "3.13.0", stackScreenPage = ['goods/getGoodsDetail.do', 'goods/invalid.do']) {
        try {
            const cUrl = location.href;
            const goodsStackScreenPageCheck = stackScreenPage.some(value => cUrl.indexOf(value) > -1);

            // 스택스크린 적용된 페이지 이고, 앱버전과 os타입이 있을경우만 실행
            if (goodsStackScreenPageCheck === true && common.app.appInfo.appver !== null && common.app.appInfo.ostype !== null) {
                let varCompareVersionOs = common.app.compareVersion(common.app.appInfo.appver, version);
                // 특정 버전과 같거나 클경우만 해당 메소드 실행
                if (varCompareVersionOs === '=' || varCompareVersionOs === '>') {
                    if (
                        common.app.appInfo.ostype === '10'
                        && window.webkit !== undefined
                        && window.webkit.messageHandlers !== undefined
                        && window.webkit.messageHandlers[methodName] !== undefined
                        && window.webkit.messageHandlers[methodName].postMessage !== undefined
                    ) {
                        // os가 ios일경우 해당 메소드가 존재하면 실행
                        window.webkit.messageHandlers[methodName].postMessage(methodParam);
                    } else if (
                        common.app.appInfo.ostype === '20'
                        && window.App !== undefined
                        && window.App[methodName] !== undefined
                    ) {
                        // os가 android일경우 해당 메소드가 존재하면 실행
                        window.App[methodName]();
                    }
                }
            }
        } catch (e) {

        }
    },
    finishStackScreen: function() {
        if (window.App && window.App.finishStackScreen) {
            window.App.finishStackScreen();
            history.back();

            return true;
        }

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.finishStackScreen && window.webkit.messageHandlers.finishStackScreen.postMessage) {
            window.webkit.messageHandlers.finishStackScreen.postMessage({});
            history.back();

            return true;
        }

        return false;
    }
};

$.namespace("common.gnb");
common.gnb = {
    hasExe : false,
    // 2020.07.22 유틸바 제어 초기화 (카테고리관)
    hasTabSearch : false,
    hasTabHome : false,
    hasTabMypage : false,
    hasTabRecentGoods : false,


    init : function() {
        /*
         * BI Renewal. 20190918. nobbyjin. Start. if (!common.gnb.hasExe &&
         * $(".allmenuOpen").length > 0) { common.gnb.bindEvent();
         *
         * setTimeout(function() { common.gnb.initSearchPop(); }, 600);
         *  // setTimeout(function() { common.gnb.initSlideMenu(); // }, 100);
         *
         *
         * common.gnb.hasExe = true; } BI Renewal. 20190918. nobbyjin. End.
         */

          common.gnb.bindSearchPop();
          common.gnb.bindEvent();
          common.gnb.hasExe = true;
    },

    bindEvent : function() {
        /*
         * BI Renewal. 20190918. nobbyjin. Start.
         * $(".allmenuOpen").click(function(){ //타이틀영역 숨기기
         * $("#titConts").hide();
         *
         * var num=$(".allmenu").hasClass("show");
         *
         * if(!num){ common.setLazyLoad();
         * $(".allmenu").addClass("show").stop().animate({left:
         * 0},240).parents("body").css({"overflow" : "hidden"})
         * $(".dim").show(); //앱 호출 setTimeout(function() {
         * common.app.callMenu("Y"); },100); }else {
         * $(".allmenu").removeClass("show").stop().animate({left:
         * '-85%'},200).parents("body").css({"overflow" : "visible"})
         * $(".dim").hide(); //앱 호출 setTimeout(function() {
         * common.app.callMenu("N"); },100); } }); BI Renewal. 20190918.
         * nobbyjin. End.
         */
        $(document).on('click', '.dim', function() {
            // 타이틀영역 보이기
            $("#titConts").show();

            if ($(".allmenu").hasClass("show") || $("#footerTab").length > 0) {
                try {
                    // BI Renewal. 20190918. nobbyjin.
                    $("#footerTab").show();

                    var scollH = $(".allmenu div").scrollTop();
                    if (scollH > 0) {
                        $(".allmenu div").scrollTop(0.0);
                    }
                    $(".allmenu").stop().animate({
                        left : '-100%'
                    }, 200).delay(2000).parents("body").removeAttr('style');
                    setTimeout(function() {
                    	// 2020.07.01 드로우 화면 속성 내용 수정 (카테고리관)
                        $(".allmenu").removeClass("show new");
                        //2020-07-29 공통으로 body 속성 변경
                        $(window).scrollTop($("body").attr("data-scrolltop"));
                        $("#footerTab").removeClass("visible-allmenu");
                        $("body").removeAttr("data-scrolltop");
                    }, 150);

                    // [3640931] 주문서 > 보유쿠폰 dim 영역 터치 시 dim 해제 결함
                    if(!$('#userCpPop').is(':visible')){
                    	$(".dim").hide();
                    }
                    // 앱 호출
                    common.app.callMenu("N", 100);
                } catch (e) {
                }

            } else if ($(".popLayerWrap").hide()) {// 추가부분
                $("body").css({
                    "overflow" : "visible"
                });
                try {
                    var varNowScrollY = parseInt(sessionStorage.getItem("scrollY_popLayer"));

                    if ((varNowScrollY > 0)) {
                        $(window).scrollTop(varNowScrollY);
                        sessionStorage.removeItem("scrollY_popLayer");
                    }
                } catch (e) {
                }

                $('.dim').hide();
            }
        });

        // 탭 컨텐츠 show/hide
        $('#mTab').find('button').on(
                {
                    'click' : function(e) {
                        e.preventDefault();
                        $(this).parent().addClass('on').attr('title', '현재 선택된 메뉴').siblings().removeClass('on')
                                .removeAttr('title');
                        $('.tab_contents:eq(' + $(this).parent().index() + ')').removeClass('hide').siblings()
                                .addClass('hide');
                    }
                });

        // 장바구니 버튼
        $("#headerBasket").click(function(e) {
            e.preventDefault();
            var cUrl = location.href;
            var logParameter = "";

            // 앰플리튜드 가이드 참고
            // https://cjics.cj.net/confluence/pages/viewpage.action?pageId=221061314#id-%EB%A1%9C%EA%B7%B8%ED%88%B4%EB%82%B4%EB%B6%80%EA%B0%80%EC%9D%B4%EB%93%9C(%EC%95%B0%ED%94%8C%EB%A6%AC%ED%8A%9C%EB%93%9C)-MO%ED%97%A4%EB%8D%94%3E%EC%9E%A5%EB%B0%94%EA%B5%AC%EB%8B%88

            if (cUrl.indexOf("/mypage/getOrderList.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=장바구니";
            } else if(cUrl.indexOf("mypage/getOftenOrderList.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=자주구매상품_장바구니";
            } else if(cUrl.indexOf("mypage/getOrderDetail.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=주문상세정보_장바구니";
            } else if(cUrl.indexOf("mypage/getChangeForm.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=교환상품선택_장바구니";
            } else if(cUrl.indexOf("mypage/getReturnForm.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=반품상품선택_장바구니";
            } else if(cUrl.indexOf("mypage/getCancelForm.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=취소상품선택_장바구니";
            } else if(cUrl.indexOf("mypage/getOrderCancelList.do") > -1) {
                logParameter = "t_page=마이페이지_주문배송조회&t_click=취소반품교환내역_장바구니";
            } else if (cUrl.indexOf("/giftCardGuide/getGiftCardGuide") > -1) {
                logParameter = getEventParameterString({
                    t_page: "기프트카드",
                    t_click: "장바구니"
                })
            } else if (cUrl.indexOf("/main/getSaleList") > -1) {
                logParameter = getEventParameterString({
                    t_page: "세일",
                    t_click: "장바구니"
                });
            } else if(cUrl.indexOf("/main/getGiftMainList") > -1) {
                logParameter = getEventParameterString({
                    t_page: "선물하기",
                    t_click: "장바구니"
                });
            } else if (cUrl.indexOf("/display/getBrandShopDetail.do") > -1) {
                logParameter = "t_page=브랜드관&t_click=장바구니";
            } else if (cUrl.indexOf("/display/getCategoryShop.do") > -1) {
                var middleCategory = $('#subTitle');
                logParameter = "t_page=카테고리관_"+middleCategory.text()+"&t_click=장바구니";
            } else if (cUrl.indexOf("/display/getSCategoryList.do") > -1) {
                var smallCategory = $('#subTitle');
                logParameter = "t_page=카테고리관_"+smallCategory.text()+"&t_click=장바구니";
            } else if(cUrl.indexOf("/mypage/getCouponList.do") > -1){
                logParameter = getEventParameterString({'t_page':'쿠폰','t_click':'헤더','t_header_type':'장바구니'})
            } else if(cUrl.indexOf("/main/getMembership") > -1){ // 회원영역 로그파라미터 추가
                var tPage = new URL(location.href).searchParams.get('t_click'); // 파라미터에서 t_page는 이전페이지 t_click은 현재클릭해서진입한페이지
                tPage = tPage? tPage: '멤버십라운지';
                try {
                    logParameter = getEventParameterString({t_page:tPage, t_click:'헤더', t_header_type:'장바구니'});
                }catch (e) { void 0; logParameter = "t_page="+tPage+"&t_click=헤더&t_header_type=장바구니"; }

            } else if(cUrl.indexOf("/mypage/myPageMain.do") > -1){
                try {
                    logParameter = getEventParameterString({t_page:'마이페이지', t_click:'헤더', t_header_type:'장바구니'});
                }catch (e) { void 0; logParameter = "t_page=마이페이지&t_click=헤더&t_header_type=장바구니"; }
            } else if(cUrl.indexOf("/planshop/getPlanShopDetail.do") > -1){
                var dispCatNo = new URL(location.href).searchParams.get('dispCatNo');
                logParameter = "t_page=기획전상세&t_click=장바구니&t_disp_cat_no=" + dispCatNo + "&t_plan_name=" + $("#titConts").find(".tit").text();
            } else if(cUrl.indexOf("/event/getEventDetail.do") > -1){
                var evtNo = new URL(location.href).searchParams.get('evtNo');
                logParameter = "t_page=이벤트상세&t_click=장바구니&t_disp_cat_no=" + evtNo + "&t_event_name=" + $("#titConts").find(".tit").text();
            } else if(cUrl.indexOf("/cart/getCart.do") > -1){
                logParameter = "t_page=장바구니&t_click=장바구니";
            } else if(cUrl.indexOf("/counsel/main.do") > -1){
                logParameter = "t_page=고객센터&t_click=장바구니";
            } else if(cUrl.indexOf("/store/getStoreMain.do") > -1){
                logParameter = "t_page=매장안내&t_click=장바구니";
            } else if(cUrl.indexOf("/mypage/getGoodsQnaList.do") > -1){
                var smallCategory = $('#subTitle');
                logParameter = "t_page=상품QA"+smallCategory.text()+"&t_click=장바구니";
            } else if(cUrl.indexOf("/goods/getGoodsDetail.do") > -1){
                try {
                    logParameter = getEventParameterString({
                        t_page: '상품상세',
                        t_click: '장바구니',
                    });
                } catch (e) {
                    void 0;
                    logParameter = "t_page=상품상세&t_click=장바구니";
                }
            } else if(cUrl.indexOf("/myGiftCard/getMyGiftCard.do") > -1){
                logParameter = "t_page=기프트카드&t_click=장바구니";
            } else if(cUrl.indexOf("/myGiftCard/getMyGiftCardReg.do") > -1){
                logParameter = "t_page=기프트카드&t_click=장바구니";
            } else if(cUrl.indexOf("/giftCardGuide/getGiftCardGuide.do") > -1) {
                logParameter = "t_page=기프트카드&t_click=장바구니";
            } else if(cUrl.indexOf("/myGiftCard/getMyGiftCardUseList.do") > -1){
                logParameter = "t_page=기프트카드&t_click=장바구니";
            } else if(cUrl.indexOf("/mypage/getGiftBoxList.do") > -1){
                logParameter = "t_page=선물함&t_click=장바구니";
            }

            if ($(this).data("entrysource")) {
                logParameter = "t_page=" + $(this).data("entrysource") + "&t_click=장바구니";
            }
            common.link.moveCartPage(logParameter);
        });

        $(".mAllSearch").find("button").click(function(e) {
            if ($(this).attr("data-ref-linkurl") != undefined && $(this).attr("data-ref-linkurl") != "") {
                location.href = $(this).attr("data-ref-linkurl");
            }
            e.stopPropagation();
        });

        //2020.07.21 slideSearchAjax.do Click Event 변경
        $(".searchScpInput").click(function() {
            common.header.goSearchInputPage();
        });

        // 검색 버튼
        if ($("#mContainer").find(".mAllSearch a").length > 0) {
            $("#mContainer").find(".mAllSearch a").click(function() {
                history.replaceState({
                    status : "search",
                    scrollY : common.getNowScroll().Y
                }, null, null);

                $("#mWrapper").hide();
                $("#mSearchWrapper").show();
                $(document).scrollTop(0);

                $("#mSearchWrapper").find("#query").focus();

                history.pushState({
                    status : "SearchPop"
                }, null, null);
                common.wlog("detailsrch_input");
                // common.gnb.initScpSwiper();
            });
        }

        // 검색 버튼
        $("#mHeader").find(".mAllSearch a").click(function() {
            history.replaceState({
                status : "search",
                scrollY : common.getNowScroll().Y
            }, null, null);

            $("#mWrapper").hide();
            $("#mSearchWrapper").show();
            $(document).scrollTop(0);

            $("#mSearchWrapper").find("#query").focus();

            history.pushState({
                status : "SearchPop"
            }, null, null);
            common.wlog("detailsrch_input");
            // common.gnb.initScpSwiper();
        });

        $("#mHeader").find(".mSearch").click(function() {
            history.replaceState({
                status : "search",
                scrollY : common.getNowScroll().Y
            }, null, null);

            $("#mWrapper").hide();
            $("#mSearchWrapper").show();
            $(document).scrollTop(0);

            $("#mSearchWrapper").find("#query").focus();

            history.pushState({
                status : "SearchPop"
            }, null, null);
            common.wlog("detailsrch_input");
            // common.gnb.initScpSwiper();
            if (common.header.scpClickFlag == "N") {
                common.header.getScpGoodsListAjax();
                suddenKeyword('keyword_main');
                //[상세검색개선] 최근본 상품 조회 2020-09-10
                common.recentGoods.getList('search');
                //[상세검색개선] 최근본 상품 조회 2020-09-10 - end
                //[상세검색개선] 최근 검색어 new 2020-09-04
                //getMyKeyword();
                getMyNewKeyword();
                //[상세검색개선] 최근 검색어 new 2020-09-04 - end
                common.header.scpClickFlag = "Y";
            }
        });

        $("#footerTabSearch").click(function() {
            common.header.openSearch();
        });

        // 신규 검색 화면으로 이동하면서 제거
        // $("#goodsHeaderSearch").click(function() {
        // 	history.replaceState({
        //         status : "search",
        //         scrollY : common.getNowScroll().Y
        //     }, null, null);

        //     $("#mWrapper").hide();
        //     $("#mSearchWrapper").show();
        //     $(document).scrollTop(0);

        //     $("#mSearchWrapper").find("#query").focus();

        //     history.pushState({
        //         status : "SearchPop"
        //     }, null, null);
        // });

        $('#fixedSearch  input').click(function() {
            common.header.clickSearchEvent();
            common.wlog("detailsrch_input");
            // common.gnb.initScpSwiper();
        });

        $("#quickMenuCategoy").click(function() {
            common.gnb.clickSlideMenu("quickmenu");
        });

        // 유틸바 홈
        $("#footerTabHome").click(function() {
            common.wlog("mFooterTabHome");
            common.link.moveMainHome();
        });

        // 유틸바 마이페이지
        $("#footerTabMypage").click(function() {
            common.wlog("mFooterTabMypage");
            common.link.moveMyPageMain(getEventParameterString({t_page: '유틸바' , t_click:'마이페이지'}));
        });

        // 유틸바 최근 본 상품 TODO: 신규 mtn 이전으로
        $("#footerTabRecentGoods").click(function() {
            common.wlog("mFooterTabRecentGoods");
            common.link.moveRecentList("Common_Recent");
        });
        // BI Renewal. 20190918. nobbyjin. End.

        // 상품상세 헤더 검색
        $("#goodsHeaderSearch").click(function() {
            common.wlog($(this).data("wlog-id"));

            try {
                var eventProperties = { entry_source : "상품상세", click_source: "검색입력창"};
                callLogEvent("검색입력창 진입 페이지", eventProperties);
            } catch(e) {
                void 0;
            }

            try {
                const cUrl = location.href;
                if (cUrl.indexOf("/goods/getGoodsDetail.do") > -1) {
                    let logParameter = '';
                    logParameter = getEventParameterString({
                        t_page: '상품상세',
                        t_click: '검색',
                    });

                    location.href = "/m/mtn/search?" + logParameter;
                } else {
                    // 신규 아키텍처 검색 화면으로 이동
                    location.href = "/m/mtn/search";
                }
            } catch (e) {
                void 0;
                location.href = "/m/mtn/search";
            }
        });

        // 상품상세 헤더 홈
        $("#goodsHeaderHome").click(function() {
            common.wlog('goodsdetail_header_home');

            try {
                const cUrl = location.href;
                if (cUrl.indexOf("/goods/getGoodsDetail.do") > -1) {
                    let logParameter = '';
                    logParameter = getEventParameterString({
                        t_page: '상품상세',
                        t_click: '홈',
                    });

                    location.href = "/m/main/main.do?" + logParameter;
                } else {
                    location.href = '/m/main/main.do';
                }
            } catch (e) {
                void 0;
                location.href = '/m/main/main.do';
            }
        });

        // 검색 결과 페이지 검색
        /*
        $("#searchResult .searchScpInput, #searchResult .btn_sch_del").click(function() {
            //common.gnb.clickSlideSearch();
        });
        */
        $(window).bind(
                "popstate",
                function() {

                    // 팝업 닫는시점인 경우
                    if (history.state != null && history.state.status == "search") {
                        $("#mSearchWrapper").hide();
                        $("#mWrapper").show();
                        setTimeout(function() {
                            var _mainCheck = $('#mHome-visual');
                            var _btnPlay = $('#mHome-visual').find('#swiper-autoplay').attr('class');
                            $(document).scrollTop(1);
                            $(document).scrollTop(history.state.scrollY);
                            $(document).scroll();
                            if (_mainCheck.length > 0) {
                                if (_btnPlay) {
                                    var _dot = $('#mHome-visual').find(
                                            '.control_box .paging .swiper-pagination-bullet-active');
                                    _dot.next('span').click();
                                }
                            }
                        }, 100);
                    }

                });

        // 웹로그 바인드
        setTimeout(function() {
            common.gnb.bindWebLog();
        }, 200);

    },

    clickSlideSearch : function() {
        history.replaceState({
            status : "search",
            scrollY : common.getNowScroll().Y
        }, null, null);

        $("#mWrapper").hide();
        $("#mSearchWrapper").show();
        $(document).scrollTop(0);

        $("#mSearchWrapper").find("#query").focus();

        history.pushState({
            status : "SearchPop"
        }, null, null);
        common.wlog("goodsdetail_header_search");
        // common.gnb.initScpSwiper();
        if (common.header.scpClickFlag == "N") {
            common.header.getScpGoodsListAjax();
            common.header.callSuddenKeyWord();
			//[상세검색개선] 최근본 상품 조회 2020-09-10
            common.recentGoods.getList('search');
            //[상세검색개선] 최근본 상품 조회 2020-09-10 - end
            //[상세검색개선] 최근 검색어 new 2020-09-04
            //getMyKeyword();
            getMyNewKeyword();
            //[상세검색개선] 최근 검색어 new 2020-09-04 - end
            common.header.scpClickFlag = "Y";
        }
    },

    clickSlideMenu : function(eventFrom) {
        try {
            var existSlideMenu = $(".allmenu").hasClass("show new"); //드로우 메뉴 존재 여부
            common.wlog("mFooterTabCategoy");

            if(existSlideMenu){
                common.gnb.handleSlideMenu(false, eventFrom); // 슬라이드 메뉴 닫기
            } else{
                common.gnb.handleSlideMenu(true, eventFrom); // 슬라이드 메뉴 열기
                common.gnb.callSlideMenuAjax(function () {
                    $('#footerTab').show();
                    $(".allmenuClose").click(function() { // 슬라이드 메뉴 x버튼 클릭시 이벤트 바인딩
                        common.gnb.handleSlideMenu(false, eventFrom); // 슬라이드 메뉴 닫기
                    });

                    common.gnb.bindSlideMenu();
                });
            }
        } catch (e) {
            void 0;
        }
    },

    handleSlideMenu: function(show, eventFrom) {
        // 타이틀영역 숨기기
        $("#titConts").hide();

        if(show){
            common.setLazyLoad();

            // footerTab 포커스 처리
            $('#footerTab > .list > li').each(function(idx, el) {
                var className = $(el).attr('class');

                if(className.startsWith('item01')){ //카테고리(유틸바)
                    $(el).addClass("in"); // 2020.07.22 카테고리(유틸바) 클릭시, in 클래스 추가하여 표시 (카테고리관)
                } else{
                    // 2020.12.03 버튼 내용 클릭 속성으로 있을 경우, 그 속성내용을 저장한다.
                    if($(el).hasClass('in')){
                        if(className.startsWith('item02')){//검색(유틸바)
                            common.gnb.hasTabSearch = true;
                        } else if(className.startsWith('item03')){//홈 아이콘
                            common.gnb.hasTabHome = true;
                        } else if(className.startsWith('item04')){//마이페이지 아이콘
                            common.gnb.hasTabMypage = true;
                        } else if(className.startsWith('item05')){//최근본상품 아이콘
                            common.gnb.hasTabRecentGoods = true;
                        }

                        $(el).removeClass("in");

                        return false;
                    }
                }
            });

            common.footer.setLiveNudgeVisibility(false); // 네이티브 하단바 올라이브 넛지 숨김넛
            // 네이티브 하단바 포커스 표시 전달
            common.footer.setNativeTabBarFocusCallback(common.footer.tabBarFocusType.DRAWER, function () {
                // http://cjics.cj.net/jira/browse/CJOYCOMM-1018
                if($("#LAYERPOP01").css("display") === "block"){
                    common.popLayerClose('LAYERPOP01');
                }

                // 앱일 경우 새로운 푸시 있는지 확인하는 스킴 호출
                location.href = "oliveyoungapp://getpushnewmsgyn";
                common.app.callMenu("Y");
            });

            //2020-07-29 공통으로 body 속성 변경
            var windowScrollTop = $(window).scrollTop();

            $("body").attr("data-scrolltop", windowScrollTop);
            $("#footerTab").addClass("visible-allmenu");
            $(".dim").show();

            if (eventFrom === "footer") {
                // 2020.07.01 드로우 화면 속성 내용 수정 (카테고리관)
                $(".allmenu").addClass("show new").stop().animate({
                    left : 0
                }, 240);
            } else if (eventFrom === "quickmenu") {
                $(".allmenu").addClass("show").stop().animate({ // 열때 우에서 좌로
                    left : 0
                }, 240);
            } else {
                // 2020.07.01 드로우 화면 속성 내용 수정 (카테고리관)
                $(".allmenu").addClass("show new").stop().animate({
                    left : 0
                }, 240);
            }
        } else{
            $(".item01").removeClass("in"); // 2020.07.22 유틸바(카테고리) 클릭시, in 클래스 제거 (카테고리)

            var tabBarFocusType = common.footer.tabBarFocusType.NONE;

            // 2020.07.22 드로우 화면 종료시 클릭표시를 전환한다. (카테고리관)
            if (common.gnb.hasTabSearch == true) {
                $(".item02").addClass("in"); //검색(유틸바)
                tabBarFocusType = common.footer.tabBarFocusType.SEARCH;
            } else if (common.gnb.hasTabHome == true) {
                $(".item03").addClass("in"); //홈 아이콘
                tabBarFocusType = common.footer.tabBarFocusType.HOME;
            } else if (common.gnb.hasTabMypage == true) {
                $(".item04").addClass("in"); //마이페이지 아이콘
                tabBarFocusType = common.footer.tabBarFocusType.MYPAGE;
            } else if (common.gnb.hasTabRecentGoods == true) {
                $(".item05").addClass("in");
                tabBarFocusType = common.footer.tabBarFocusType.RECENT; // 네이티브 하단바 포커스 표시 전달
            }

            // 앱 호출
            common.footer.setNativeTabBarFocusCallback(tabBarFocusType, function () {
                common.app.callMenu("N");
            });
            common.footer.setLiveNudgeVisibility(true); // 네이티브 하단바 올라이브 넛지 표시
            common.footer.setNativeTabBarVisibility(true); // 네이티브 하단바 표시 처리

            // 2020.07.22 유틸바 속성 값 초기화 (카테고리관)
            common.gnb.hasTabSearch = false;
            common.gnb.hasTabHome = false;
            common.gnb.hasTabMypage = false;
            common.gnb.hasTabRecentGoods = false;

            var bodyScrollTop = $("body").attr("data-scrolltop");

            $(window).scrollTop(bodyScrollTop);
            $("body").removeAttr("data-scrolltop");
            $("#footerTab").removeClass("visible-allmenu");
            $(".dim").hide();

            if (eventFrom == "footer") {
                $(".allmenu").removeClass("show new").stop().animate({
                    left : '-100%'
                }, 200);
            } else if (eventFrom == "quickmenu") { // 닫을때 좌에서 우로
                $(".allmenu").removeClass("show").stop().animate({
                    left:'100%'
                }, 200);
            } else {
                $(".allmenu").removeClass("show new").stop().animate({
                    left : '-100%'
                }, 200);
            }
        }
    },

    callFooterBann : function() {
    	setTimeout(function() {
            var mManban = $('#man_sticky'),
            	mAppban = $('#appPush_sticky'),
            	mFirstPurchaseban = $('#firstPurchase_sticky'),

    		    mFooterTab = $('#footerTab'),
    		    mBanHeight = mManban.height(),
    		    mAppBanHeight = mAppban.height(),
    		    mFirstPurchaseHeight = mFirstPurchaseban.height();

        	var firstPurchaseBanInfo = sessionStorage.getItem("firstPurchaseBanInfo");
        	var shopAlimOlLiveList = sessionStorage.getItem("shopAlimOlLiveList");

        	var firstPurchaseImgNum = $('#footerTab .btmBan_area img').size();
        	var baseHeight = 208;
        	var isPass = true;

            var checkHeight = 0;
            if($('#footerTab .btmBan_area img').length > 0){
            	checkHeight = $('#footerTab .btmBan_area img')[0].naturalHeight;
            	//스와이퍼 앞뒤 생각해서 2개가 있다 생각
            	for (var i = 0 ; i < firstPurchaseImgNum; i++) {
            		var tempHeight = $('#footerTab .btmBan_area img')[i].naturalHeight;
            		if(baseHeight != tempHeight){
            			isPass = false;
            		}
            	}
            }
            if($("#footerTab #man_sticky").length > 0 && $("#footerTab #appPush_sticky").length > 0 && checkHeight == 208){
            	$('#man_sticky').css({
            		top:mAppban.position().top,
            	});
            }else if($("#footerTab #man_sticky").length < 1 && $("#footerTab #appPush_sticky").length > 0 && checkHeight == 208){
            	if(common.isEmpty(shopAlimOlLiveList)) {
            		$("#noti_service").remove();
            	}

            	if(!isPass){
            		$("#appPush_sticky").remove();
            		$('#footerTab').removeClass('mfixAll');
            	}

            }else if($("#footerTab #man_sticky").length > 0 && $("#footerTab #appPush_sticky").length < 1 && checkHeight == 208){
            	if(common.isEmpty(shopAlimOlLiveList)) {
            		$("#noti_service").remove();
            	}
            }else if($("#footerTab #firstPurchase_sticky").length > 0 && checkHeight == 208 && firstPurchaseBanInfo != "done"){
            	if(common.isEmpty(shopAlimOlLiveList)) {
            		$("#noti_service").remove();
            	}

                //첫구매 유도 배너 기입 부분 (비로그인시 )
            	if(!common.isLogin()){
            		sessionStorage.setItem("firstPurchaseBanInfo", "done");
            		sessionStorage.setItem("byIsNotLoginFirPurBan", "done");
            	}

            	if(!isPass){
            		$("#firstPurchase_sticky").remove();
            		$('#footerTab').removeClass('mfixAll');
            	}

            }else if($("#footerTab #firstPurchase_sticky").length > 0 && checkHeight == 208
            		&& common.isLogin() == false && firstPurchaseBanInfo == "done"){
            	$("#firstPurchase_sticky").remove();
                $("#footerTab").removeClass("btmBan");
                $('#footerTab').removeAttr("style");
                if($("#footerTab .btmBan_area").length < 1){
                	if(common.isEmpty(shopAlimOlLiveList)) {
                		$("#noti_service").remove();
                	}
                }
            }else if(!isPass) {
                $("#firstPurchase_sticky").remove();
                $("#appPush_sticky").remove();
                $('#footerTab').removeClass('mfixAll');
            }else{
        		if(common.isEmpty(shopAlimOlLiveList)) {
            		$("#noti_service").remove();
            	}
        	}
          if($("#footerTab #health_secret_popup_sticky").length > 0){
              if(common.isEmpty(shopAlimOlLiveList)) {
                  $("#noti_service").remove();
              }
          }

          // 블라인드 리뷰를 위한 영역
            if($("#rwGuideMsg1").length > 0) {
                if(common.isEmpty(shopAlimOlLiveList)) {
                    $("#rwGuideMsg1").attr('class','rw-guide-msg type2 blinded case1');
                }else{
                    $("#rwGuideMsg1").attr('class','rw-guide-msg type2 blinded case3');
                }
            }
        }, 600);
    },

    //[3428979] 쇼핑알림서비스(2020.11.19)
    callShopAlim : function() {
        var COUNTDOWN = 'COUNTDOWN';
        var READY = 'READY';
        var ON_AIR = 'ON_AIR';
        var UNLOAD = 'UNLOAD';
        var isReady = false;
        var readyInterval;

        /**
         * 매거진관 오픈 툴팁
         * @description
         * 1. 앱 실행시 1번만 툴팁이 보입니다.
         * 2. 앱을 재부팅 시 툴팁이 보입니다.
         * 3. 앱 버전 3.1.0 이하에선 매거진관 오픈 툴팁이 보이지 않습니다.
         * 3월 9일 기준으로 매거진관 하단 툴팁은 일시 중지합니다.
         * 접속 이력을 체크하던 storage data를 삭제하겠습니다.
         */
        var magazineConnectedYn = localStorage.getItem('magazineConnectedYn');
        var magazineTooltipHideYn = sessionStorage.getItem('magazineTooltipHideYn');
        var magazineTooltip = document.querySelector('.tooltip-magazine');

        if(magazineConnectedYn === 'y') {
            localStorage.removeItem('magazineConnectedYn');
        }

        if(magazineTooltipHideYn === 'y') {
            sessionStorage.removeItem('magazineTooltipHideYn');
        }

        // if(common.app.appInfo.isapp) {
        //     if(common.app.compareVersion(common.app.appInfo.appver, "3.1.0") == ">") {
        //         // 메거진관 접속을 하지 않았던경우, 초기 접속(세션스토리지 만료)의 경우 넛지 노출
        //         if (!(magazineConnectedYn === 'y' || magazineTooltipHideYn === 'y')) {
        //             if (magazineTooltip) {
        //                 magazineTooltip.style.display = 'block';
        //
        //                 sessionStorage.setItem('magazineTooltipHideYn', 'y');
        //             }
        //         }
        //     }
        // }else {
        //     if (!(magazineConnectedYn === 'y' || magazineTooltipHideYn === 'y')) {
        //         if (magazineTooltip) {
        //             magazineTooltip.style.display = 'block';
        //
        //             sessionStorage.setItem('magazineTooltipHideYn', 'y');
        //         }
        //     }
        // }

        function mm(time) {
            if (time < 10) {
                return "<span class=\"hms\">" + "0" + time + "</span>";
            } else {
                return "<span class=\"hms\">" + time + "</span>";
            }
        }
        function getCountDownTime(contsDescCountDown) {
            var timeString = contsDescCountDown.replace(" ", "T");
            var olLiveStartDtm = new Date(timeString);
            var now = new Date();
            var distance = olLiveStartDtm - now;
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            var dtmStr = "";

            if (hours >= 0) { // 0 ~ 3시간 사이에서만 표시
                dtmStr = mm(hours) + ":" + mm(minutes) + ":" + mm(seconds);
            }
            return dtmStr;
        }
        function findAlimItem(list, propertyName) {
            try {
                var findList = list.filter(function (item) {
                    return item.contsDescCont && item.contsDescCont.indexOf(propertyName) > -1;
                });
                if (!common.isEmpty(findList)) {
                    return findList[0];
                }
            } catch (error) {
                return null;
            }
            return null;
        }
        function getHtmlForDisplay (item, firstDisplayItem) {
            var displayItem = item[firstDisplayItem];
            var linkUrlAddr = displayItem && displayItem.linkUrlAddr || '';
            var linkStr = common.isEmpty(linkUrlAddr)
              ? 'javascript://'
              : '/m/' + linkUrlAddr;
            // 라이브관에서 넣어주는 파라미터 : 플레이어 닫기 클릭 시 redirectUrl로 이동
            const currentLocation = new URL(location.href);

            var html = '';
            if (firstDisplayItem === COUNTDOWN) {
                var contsDescCont = displayItem.contsDescCont;
                var contsDescCountDown = contsDescCont && contsDescCont.split("_")[1];
                var countDownText = getCountDownTime(contsDescCountDown);
                html += '<a href="' + linkStr + '" class="countdown js-live-link">';
                html += '    <span class="msg">올영라이브 입장까지 <span class="cnt" id="countdownDtimeSpan" data-countdown-dtm="' + contsDescCountDown + '"  >' + countDownText + '</span> 남았어요</span>';
                html += '</a>';
            }
            else if (firstDisplayItem === READY) {
                html += '<a href="' + linkStr + '" class="js-live-link">';
                html += '    <span class="msg">올영라이브 방송이 곧 시작 됩니다!</span>';
                html += '</a>';
            }
            else if (firstDisplayItem === ON_AIR) {
                //백오피스 -> 마케팅관리 -> 라이브커머스 -> 방송관리 -> 방송예약목록의 방송제목
                var newURL  = new URL(location.href);
                newURL.search = "";
                newURL.hash = "";

                currentLocation.searchParams.forEach((value, key) => {
                    if (key !== "oy") {
                        newURL.searchParams.append(key, value);
                    }
                });
                var contsNm = displayItem.contsNm;
                html += '<a href="' + linkStr + "&redirectUrl=" + encodeURIComponent(newURL.toString()) + '" data-attr="홈^올라이브알림^' + contsNm + '" class="liveonair js-live-link">';
                html += '   <div>';
                html += '       <span class="flag">LIVE</span>';
                html += '       <p class="msg">' + contsNm + '</p>';
                html += '   </div>';
                html += '</a>';
            }

            html += '<div type="button" class="btn_close">';
            html += '   <div class="btn_wrapper">';
            html += '       <button class="close_btn">닫기</button>';
            html += '   </div>';
            html += '</div>';

            return html;
        }
        function getDisplayItemName(countDownStartTime, countDownTimeLimit, onAirDispStrtDtime, onAirItemEndTime) {
            var countDownTimeArray, countDownTime, onAirItemTime, currentTime = new Date();
            if (countDownTimeLimit) {
                countDownTimeArray = countDownTimeLimit.split('_');
                if (!common.isEmpty(countDownTimeArray) && countDownTimeArray.length >= 1) {
                    countDownTime = countDownTimeArray[1].replace(" ", "T");
                    countDownTime = new Date(countDownTime);
                }
            }
            if (onAirDispStrtDtime) {
                onAirItemTime = new Date(onAirDispStrtDtime);
            }
            if (currentTime < countDownStartTime || currentTime > onAirItemEndTime) {
                return UNLOAD;
            }
            if (currentTime <= countDownTime && currentTime < onAirItemTime) {
                return COUNTDOWN;
            }
            if (currentTime > countDownTime && currentTime < onAirItemTime) {
                return READY;
            }
            if (currentTime >= onAirItemTime) {
                return ON_AIR;
            }
        }
        function setupOnAirInterval(displayItemName, startTime) {
            if (displayItemName !== READY) return;
            if (isReady) return;
            isReady = true;
            var currentTime, shopAlimOlLiveList;

            readyInterval = setInterval(function () {
              currentTime = new Date();
              if (!!startTime && startTime <= currentTime) {
                  shopAlimOlLiveList = sessionStorage.getItem("shopAlimOlLiveList");
                  setupShopAlimUI(JSON.parse(shopAlimOlLiveList));
                  clearInterval(readyInterval);
              }
            }, 1000);
        }
        function setupShopAlimUI(olLiveList) {
            var noti = $("#noti_service");
            var ulShopAlim = $("#ulShopAlim");

            // 온에어, 카운트다운 분리
            var countDownItem = findAlimItem(olLiveList, 'Countdown');
            var onAirItem = findAlimItem(olLiveList, 'ON Air');

            var displayItem = {
                COUNTDOWN: countDownItem,
                READY: null,
                ON_AIR: onAirItem
            };

            var countDownEndTime = countDownItem && countDownItem.contsDescCont;
            var countDownStartTime = countDownItem && countDownItem.dispStrtDtime;
            var onAirItemStartTime = onAirItem && onAirItem.dispStrtDtime;
            var onAirItemEndTime = onAirItem && onAirItem.dispEndDtime;

            var isSkipLiveNudge = function() {
                return Boolean(sessionStorage.getItem(STORAGE_KEY.SESSION.LIVE_NUDGE_SKIP_YN));
            };

            var removeAlim = function() {
                ulShopAlim.html('');
                noti.remove();
                $('#fixBtn').removeClass('live');
                $('#alwaysOnFixBtn').removeClass('onLive');
            }

            // 카운트다운 > 레디 > 온에어 순에서 표시 결정
            var displayItemName = getDisplayItemName(countDownStartTime, countDownEndTime, onAirItemStartTime, onAirItemEndTime);

            // 넛지 스킵 상태, 카운트다운, 온에어 시간 외 일 경우 표시 제외
            if (isSkipLiveNudge() || displayItemName === UNLOAD || $("#footerTab").hasClass("fhide") || common.isEmpty(displayItemName) ) { // 유틸바 없는 곳에서는 노출안함)
                removeAlim();
                return;
            } else {
                noti.css("display", "block");
            }

            // 첫번째 순서에 의한 HTML 생성
            var innerHtml = getHtmlForDisplay(displayItem, displayItemName);
            if (common.isEmpty(innerHtml)) return;

            noti.show();
            if (innerHtml !== "") {
                $(".fvPop_search").addClass("live");
                $('.shipp_alert').addClass('live');
            }
            ulShopAlim.html(innerHtml);

          var linkUrlAddr = displayItem[displayItemName] && displayItem[displayItemName].linkUrlAddr;
          var contsNm = displayItem[displayItemName] && displayItem[displayItemName].contsNm;

          $('.btn_close').on('click', function () {
                // amplitude
                try {
                  callLogEvent('라이브하단넛지_배너_닫기_클릭', {
                    'entry_source': linkUrlAddr,
                    'click_source': '하단배너 닫기 클릭',
                    'banner_name': contsNm,
                  });
                } catch(_) {
                  void 0;
                }

                sessionStorage.setItem(STORAGE_KEY.SESSION.LIVE_NUDGE_SKIP_YN, 'Y');
                removeAlim();
            });

            $('.js-live-link').on('click', function () {
                // amplitude
                try {
                  callLogEvent('라이브하단넛지_배너_클릭', {
                    'entry_source': linkUrlAddr,
                    'click_source': '하단배너 클릭',
                    'banner_name': contsNm,
                  });
                } catch(_) {
                  void 0;
                }
            })

            setupOnAirInterval(displayItemName, onAirItemStartTime);

            if (!noti.length) return;

            // 목록이 2개 이상일 때
            var notiS = null;
            if (noti.find("li.swiper-slide").length > 1) {
                notiS = new Swiper("#noti_service .swiper-container", {
                    direction: 'vertical',
                    loop: true,
                    speed: 200,
                    observer: true,
                    observeParents: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    height: 42,								// 높이 맞추기위해
                    on : {
                        init(swiper) {
                            let $footerTab = $("#footerTab");
                            //최초 노출 시 autoplay 실행
                            if (!$footerTab.hasClass("on")) swiper.autoplay.stop();
                            // footerTab 클래스 변경 감지 → 변경 시 autoplay 제어
                            let classNames = "";
                            let observer = new MutationObserver(function (mutations) {
                                mutations.forEach(function (mutation) {
                                    if (mutation.attributeName === "class") {
                                        let attributeValue = $(mutation.target).prop(mutation.attributeName);
                                        if (attributeValue != classNames) {
                                            classNames = attributeValue;
                                            //console.log('classNames.indexOf : ' + classNames.indexOf());
                                            if (classNames.indexOf("on") == "-1") {
                                                swiper.autoplay.stop();
                                            } else {
                                                swiper.autoplay.start();
                                            }
                                        }
                                    }
                                });
                            });
                            observer.observe($footerTab[0], {
                                attributes: true
                            });
                        }
                    }
                });
            }

            // 카운트다운 타이머
            $("span[id^='countdownDtimeSpan']").each(function () {
                var me = $(this);
                var dtm = me.attr("data-countdown-dtm");
                var x = setInterval(function () {
                    // 라이브 넛지 스킵 상태이면 제거
                    if (isSkipLiveNudge()) {
                        removeAlim();
                        clearInterval(x);
                        return;
                    }
                    var countDown = getCountDownTime(dtm);
                    if (common.isEmpty(countDown) && !common.isEmpty(notiS)) {
                        notiS.removeSlide(me.parents("li").attr("data-swiper-slide-index"));
                        notiS.update();
                        if (common.isEmpty(notiS.slides)) {
                            noti.hide();
                            clearInterval(x);
                        }
                    } else {
                        if (!countDown) {
                            //[3596726] 올라이브 카운트 다운 종료 후, onair 팝업 전환시 onair 문구 미노출 오류(2021.08.12)
                            setupShopAlimUI(JSON.parse(sessionStorage.getItem("shopAlimOlLiveList")));
                            clearInterval(x);
                        } else {
                            me.html(countDown);
                        }
                    }
                }, 1000);
            });

            /**
             * 매거진관 오픈 툴팁
             * @description
             * 라이브 알림이 노출되어 있을 때는 매거진관 오픈 툴팁을 노출하지 않습니다.
             * 이 코드는 3월에 삭제됩니다.
             */
            var _currentTime = new Date();
            var magazineTooltip = document.querySelector('.tooltip-magazine');

            if(countDownStartTime <= _currentTime.getTime() &&  onAirItemEndTime >= _currentTime.getTime()) {
                if(magazineTooltip) {
                    magazineTooltip.style.display = 'none';
                }
            }
        }

        function shopAlimAjax() {
            $.ajax({
                type : "GET",
                url : _baseUrl + "common/shopAlimAjax.do",
                dataType : 'json',
                cache : true,
                success : function(data) {
                    if ((typeof data) == 'string')		// for cdn
                        data = $.parseJSON(data)

                    sessionStorage.setItem("shopAlimGetTime", new Date().getTime());
                    sessionStorage.setItem("shopAlimOlLiveList", JSON.stringify(data.olLiveList));

                    setupShopAlimUI(data.olLiveList);
                }
            });
        }

        // 조회한지 5분이 지나지 않았으면 저장한 내용을 노출한다.
        var shopAlimGetTime = sessionStorage.getItem("shopAlimGetTime");
        if (!common.isEmpty(shopAlimGetTime)) {
            var d = new Date().getTime() - shopAlimGetTime;
            if (Math.floor((d % (1000 * 60 * 60)) / (1000 * 60)) < 2) {
                var shopAlimOlLiveList = sessionStorage.getItem("shopAlimOlLiveList");
                if (!common.isEmpty(shopAlimOlLiveList)) {
                    setupShopAlimUI(JSON.parse(shopAlimOlLiveList));
                    return;
                }
            }
        }

        shopAlimAjax();
    },
    olLiveList : null,

    callSlideMenuAjax : function(callbackFunc) {
        // 저장된 화면이 없을 경우 html 조회
        $.ajax({
            type : "GET",
            url : _baseUrl + "common/slideMenuAjax.do",
            data : {},
            dataType : 'text',
            cache : false,
            success : function(data) {
                $("#allMenu #mLnb").html(data);
                // For Drawer Brand A/B test
                common.drawerBrandAB.removeABTestData();

                if(callbackFunc) {
                    callbackFunc();
                }
            },
            error : function() {
            },
            complete : function() {
                setTimeout(function() {
                    $('#footerTab').show();
                }, 600);
            },
            beforeSend: function() {
                $("#allMenu #mLnb").html(`
                    <div class="skeleton-wrap">
                        <div class="user-info">
                            <div>
                                <div class="row"><span class="name skeleton-item"></span></div>
                                <div class="row"><a href="#" class="rank skeleton-item"></a></div>
                            </div>
                            <div class="btn-wrap"></div>
                        </div>
                        <div class="drawer-brand-title skeleton-item"></div>
                        <div class="drawer-brand-wrap">
                            <div class="drawer-brand">
                                <a href="#" class="item">
                                    <span class="img no-img skeleton-item"></span>
                                    <p class="txt skeleton-item"></p>
                                </a>
                                <a href="#" class="item">
                                    <span class="img skeleton-item"></span>
                                    <p class="txt skeleton-item"></p>
                                </a>
                                <a href="#" class="item">
                                    <span class="img skeleton-item"></span>
                                    <p class="txt skeleton-item"></p>
                                </a>
                            </div>
                        </div>
                        <div class="lnbSmenu">
                            <div class="lnb_sec">
                                <div>
                                    <span class="skeleton-item"></span>
                                    <span class="skeleton-item"></span>
                                </div>
                                <div>
                                    <span class="skeleton-item"></span>
                                    <span class="skeleton-item"></span>
                                </div>
                                <div>
                                    <span class="skeleton-item"></span>
                                    <span class="skeleton-item"></span>
                                </div>
                                <div>
                                    <span class="skeleton-item"></span>
                                    <span class="skeleton-item"></span>
                                </div>
                                <div>
                                    <span class="skeleton-item"></span>
                                    <span class="skeleton-item"></span>
                                </div>
                                <div>
                                    <span class="skeleton-item"></span>
                                </div>
                                <div>
                                    <span class="skeleton-item"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
            }
        });
    },

    bindSlideMenu : function() {
        // 브랜드 전체보기 클릭 시, 브랜드관 리스트 화면으로 이동한다.
        $(".drawer-brand-title a").each(function() {
            $(this).bind("click", function() {
                location.href = _baseUrl + "display/getBrandList.do";
            });
        });

        // 대카테고리 클릭 시, 해당 카테고리관으로 이동한다. (2020.07.29 카테고리관)
    	$(".lnb_sec .lnb_dep1 .link-full a").each(function() {
            $(this).bind("click", function() {
                common.app.callTrackEvent("category", {
                    "af_content_nm" : $(this).children("span").text()
                });
                common.callBrazeCustomEvent('menu_category', {
                    disp_lagCate: $(this).children("span").text(),
                });

                // left 메뉴 > 카테고리 > 서브카테고리 선택시 저장된 서브카테고리 제거
                sessionStorage.removeItem("subDispCatNo");

                location.href = _baseUrl + "display/getCategoryShop.do?gateCd=Drawer&dispCatNo=" + $(this).attr("data-ref-dispCatNo");
            });
        });

        $('.lnb_dep1 > li > a').click(function() {
    		if ($(this).parents('li').hasClass('on')) {
    			$(this).parents().find('li').removeClass('on');
    		} else {
    			$(this).parents('li').addClass('on').siblings(".lnb_dep1 li").removeClass('on');
    			$('.lnb_dep2 li').removeClass('on');
    		}
    	});

    	$('.lnb_dep2 > li > a').click(function() {
    		if ($(this).parents('.lnb_dep2 li').hasClass('on')) {
    			$(this).parents('.lnb_dep2 li').removeClass('on');
    		} else {
    			$(this).parents('.lnb_dep2 li').addClass('on').siblings('.lnb_dep2 li').removeClass('on');
    		}
    	});

        // 전문관 클릭 이벤트
        $(".lnb-jeonmungwan ul li a[data-ref-dispCatNo]").bind("click", function() {
            var dispCatNo = $(this).attr("data-ref-dispCatNo");
            common.link.moveSpcShop(dispCatNo, 'Drawer');
        });

        // slideMenu Top 프리미엄관 new 클릭 이벤트
        $(".subLink .mlink a[data-ref-dispCatNo]").bind("click", function() {
            var dispCatNo = $(this).attr("data-ref-dispCatNo");
            common.link.moveSpcShop(dispCatNo, 'Drawer');
        });

        // 2020.06.30 slideMenu Top 프리미엄관 new 클릭 이벤트 (개정내용) (카테고리관)
        $(".sub-link a[data-ref-dispCatNo]").bind("click", function() {
        	var dispCatNo = $(this).attr("data-ref-dispCatNo");
        	common.wlog("home_draver_premium");
            common.link.moveSpcShop(dispCatNo, 'Drawer');
        });

        // 2020.07.27 전시배너 스크립트 내용 수정 (카테고리관)
        var drawPaging = $('.drawer-banner-wrap .paging');

        if ($('.drawer-banner .swiper-slide').length > 1) {
        	drawPaging.show();

			var $btnPause2 = drawPaging.find('.btn-autoplay.pause');
			var $btnPlay2 = drawPaging.find('.btn-autoplay.play');

			var ctContentBanner = new Swiper('.drawer-banner', {
				pagination: { el: '.paging-item', clickable: true },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
				loop: true
			});

			$btnPause2.on('click', function () {
				$(this).hide();
				$btnPlay2.show();
				ctContentBanner.autoplay.stop();
			});

			$btnPlay2.on('click', function () {
				$(this).hide();
				$btnPause2.show();
				ctContentBanner.autoplay.start();
			});
		} else {
			drawPaging.hide();
		}

        // 2020.07.01 공지사항 롤링 추가 (카테고리관)
		if ($('#contactNotice .swiper-slide').length > 1) {
			$('#contactNotice .paging').css('display', 'block');

			$('#contactNotice .current').html('1');
			$('#contactNotice .total').html($('#contactNotice .swiper-slide').length);

			var contactNoticeBanner = new Swiper('#contactNotice .contact-notice', {
				direction: 'vertical',
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
				loop: true
			});

			contactNoticeBanner.on('slideChangeTransitionStart', function(e){
				$('#contactNotice .current').html(Number(e.realIndex) + 1);
			});

		} else {
			$('#contactNotice .paging').hide();
		}

        // 웹로그 바인드
        setTimeout(function() {
            common.gnb.bindWebLog("slide");
        }, 200);

    },

    initSearchPop : function() {
        // 저장된 화면이 없을 경우 html 조회
        // $.ajax({
        //     type : "GET",
        //     url : _baseUrl + "common/slideSearchAjax.do",
        //     data : null,
        //     dataType : 'text',
        //     async : false,
        //     cache : false,
        //     success : function(data) {
        //         try {
        //             // 세션에 저장
        //             // 사파리 private mode 예외처리용
        //             sessionStorage.setItem("searchPopMenu", $("#mSearchWrapper").html());
        //         } catch (e) {
        //         }
        //     },
        //     error : function() {
        //     }
        // });

        try {
            const template = $("#mSearchWrapperTmpl").html();

            $("#mSearchWrapper").html(template).promise().then(function() {
                if(common.app.appInfo.isapp){
                    $("#mSearchWrapper").find(".sch_field5").addClass("app");
                }

                $("#mWrapper").hide();
                $("#mSearchWrapper").show();
                $("#mSearchWrapper").find(".search_swiper_area").show();

                getMyNewKeyword();// 최근 검색어
                common.recentGoods.getList('search');// 최근 본 상품
                common.header.callSuddenKeyWord();// 급상승 검색어
                common.header.getScpGoodsListAjax();//주간 특가 상품
                common.header.initSearchSwiper();

                var textArea = $(".searchScpInput").val();

                if (textArea != undefined && textArea != "") {
                    $("#mSearchWrapper").find('.search_auto_area').removeClass('off');
                    // $("#mSearchWrapper").find('.search_swiper_area').hide();
                    $("#mSearchWrapper").find('.btn_sch_del').addClass('on');
                    $("#mSearchWrapper").find('#mContainer').addClass('fix');
                    //$(".scp_cont").css("display", 'none');
                    $("#mSearchWrapper").find('.search_swiper_area').css("height", "177px");

                    request_M_ArkJson(textArea);
                }

                $("#mSearchWrapper").find("#query").val(textArea);
                $("#mSearchWrapper").find("#query").focus();

                common.gnb.bindSearchPop();
                common.app.callMenu("Y");

                ark_init();
            });
            // popkeyword();
            // suddenKeyword();
            // getMyKeyword();

            // [상세검색개선] 최근 검색어, 급상승, 최근본 상품 2020-09-04
            //$("#mSearchWrapper").find(".search_tab_area").find(".tab_contents").show();

            //$("#mSearchWrapper").find(".search_swiper_area").show();

            //var myKeyword = getCookie_search("mykeyword");

            /*if (myKeyword == undefined || myKeyword.trim() == "") {
                $("#mSearchWrapper").find('#mTab11 > li').removeClass("on");
                $("#mSearchWrapper").find('#mTab11 > li:eq(1)').addClass("on");

                $("#mSearchWrapper").find('.tab_contents:eq(1)').removeClass('hide').siblings('.tab_contents')
                        .addClass('hide');

            }*/
            // [상세검색개선] 최근 검색어, 급상승, 최근본 상품 2020-09-04 - end
        } catch (e) {
            void 0;
        }
    },

    scanBarcodeThrottle : function(log) {
        var lastTime = 0;
        return function () {
            var now = Date.now();
            if (now - lastTime >= 1000) {
                common.app.sendAppScanBarcodeEvent();
                common.wlog(log);
                lastTime = now;
            }
        };
    },

    bindSearchPop : function() {
        function resetSettingSearchPop() {
            $("#mWrapper").attr("style", "display:block");
            $("#mSearchWrapper").attr("style", "display:none");
            if($("#main-swiper-tab0:not(.swiper-slide-duplicate) .mVisual-slide").length ) {
                // 메인화면으로 back할때 검색어 삭제
                $("#query").val("");
                $("#query").blur();
                mmain.home.mVisual.ixOverlayList('resize');
            };

            common.app.callMenu("N");
        }

        function handlePopstate() {
            window.removeEventListener("popstate", handlePopstate);
            resetSettingSearchPop();
        }

        // 신규 아키텍처 검색 화면으로 이동
        // $("#searchResult .search_tit").find("#sHeaderBackBtn_SearchMain").bind("click", function() {
        //     history.back();
        // });

        $("#mSearchWrapper").find("#schBackBtn").bind("click", function() {
            history.back();
        });

        window.addEventListener("popstate", handlePopstate);

        $("#mSearchWrapper").find(".btn_sch_new").bind(
                "click",
                function() {
                    if ($("#mSearchWrapper").find("#query").val() == '')
                        return;

                    var keyword = $("#mSearchWrapper").find("#query").val();

                    if(keyword != undefined) {
                        keyword = keyword.replaceAll("\"", "");
                        keyword = keyword.replaceAll("\'", "");
                        keyword = keyword.replaceAll("'", "");
                        keyword = keyword.replaceAll("’","");
                        keyword = keyword.replaceAll("&#34;", "");
                        keyword = keyword.replaceAll("&#39;", "");
                        keyword = keyword.replaceAll("\\\\", "");
                    }

                    var giftYn = common._giftCardCheck($("#mSearchWrapper").find("#query").val());
                    location.href = _baseUrl + "search/getSearchMain.do?query="
                            + encodeURIComponent(keyword)+"&giftYn=" + giftYn;
                    $("#mSearchWrapper").hide();
                    $("#mWrapper").attr('style', 'display: block');
                });

        $("#mSearchWrapper").find(".btn_sch_barcode").bind("click", common.gnb.scanBarcodeThrottle("header_barcode_btn"));

        $("#searchResult").find(".btn_sch_barcode").unbind("click").bind("click", common.gnb.scanBarcodeThrottle("detailsrch_barcode_btn"));
/*

        $(".searchScpInput").bind("click", function() {
            common.header.clickSearchEvent();
        });
*/
        /**
         * 퍼블 작성 스크립트
         */
        $("#mSearchWrapper").find('#mTab11 > li').find('a').on(
                {
                    'click' : function(e) {
                        e.preventDefault();
                        $(this).parent().addClass('on').attr('title', '현재 선택된 메뉴').siblings().removeClass('on')
                                .removeAttr('title');
                        $("#mSearchWrapper").find('.tab_contents:eq(' + $(this).parent().index() + ')').removeClass(
                                'hide').siblings('.tab_contents').addClass('hide');
                    }
                });
        $("#mSearchWrapper").find('.tabList01 > li').each(function() {
            if (!$(this).hasClass('on')) {
                $("#mSearchWrapper").find('.tab_contents:eq(' + $(this).index() + ')').addClass('hide');
            }
        });

        $("#mSearchWrapper").find('.sch_field5').find('.btn_sch_del').on({
            'click' : function(e) {
                e.preventDefault();
                $(this).removeClass('on').parent().find('input[name="query"]').val('');
                var _input = $(this).parent().find('input[name="query"]');
                fnSearchSet(_input);
                $(this).parent().find('input[name="query"]').focus();
                blurGb = 1;
                $(this).blur();
                $("#query").keyup();
            }
        });
        $("#mSearchWrapper").find('.sch_field5').find('input[type="text"]').on({
            'keyup' : function() {
                fnSearchSet($(this));
            },
            'focusin' : function() {
                fnSearchSet($(this));
            }
        })
        $("#mSearchWrapper").find('.sch_field2').find('.btn_sch_del').on({
            'click' : function(e) {
                e.preventDefault();
                $(this).removeClass('on').parent().find('input[type="text"]').val('').focus();
                var _input = $(this).parent().find('input[type="text"]');
                fnSearchSet(_input);
                $("#query").keyup();
            }
        });
        $("#mSearchWrapper").find('.sch_field2').find('input[type="text"]').on({
            'keyup' : function() {
                fnSearchSet($(this));
            },
            'focusin' : function() {
                fnSearchSet($(this));
            }
        });

        var blurGb = 0;
        $("#mSearchWrapper").find(".btn_sch_del").on('blur', function(e){
            if(blurGb == 1){
                $("#query").val('');
                $("#notUseOnlyfocus").focus();
                $(".sch_field5 .searchScpInput").focus();//
            }

            blurGb = 0;
        });
        $("#mSearchWrapper").find("#query").bind("focus", function(){
            $(".scp_cont").css("position", 'absolute');
        });
        $("#mSearchWrapper").find("#query").bind("blur", function(){
            $(".scp_cont").css("position", 'fixed');
        });
        $("#mSearchWrapper").find("#query").bind("keyup", function(){
            if($('input[name="query"]').val().length>0){
                $(".scp_cont").css("display", 'none');
            }else{
                $(".scp_cont").css("display", 'block');
            }
        });

        function fnSearchSet(obj) {
            if (obj.val() != '' && obj.val() != null) { // 페이지 확인을 위한 스크립트
                                                        // 처리(개발시 삭제하셔도됩니다)
                $("#mSearchWrapper").find('.search_auto_area').removeClass('off');
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10
                //$("#mSearchWrapper").find('.search_tab_area').addClass('off');
                $("#mSearchWrapper").find('.search_swiper_area').hide();
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10 - end
                obj.parent().find('.btn_sch_del').addClass('on');// 2017-01-11
                                                                    // 추가
                $("#mSearchWrapper").find('#mContainer').addClass('fix');
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10
                //$("#mSearchWrapper").find('#mTab11').hide();
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10 - end
            } else {
                $("#mSearchWrapper").find('.search_auto_area').addClass('off');
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10
                //$("#mSearchWrapper").find('.search_tab_area').removeClass('off');
                $("#mSearchWrapper").find('.search_swiper_area').show();
                $("#mSearchWrapper").find('.search_swiper_area').css("height", "100%");
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10 - end
                obj.parent().find('.btn_sch_del').removeClass('on');
                $("#mSearchWrapper").find('#mContainer').removeClass('fix');
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10
                //$("#mSearchWrapper").find('#mTab11').show();
                // [상세검색개선] 최근검색어, 급상승, 최근본 상품 new 2020-09-10 - end

            }
        }
        /**
         * 퍼블 작성 스크립트 - 끝
         */

        // 웹로그 바인드
        setTimeout(function() {
            common.gnb.bindWebLog("search");
        }, 200);

    },

    // 웹로그 바인딩
    bindWebLog : function(type) {

        if (type == undefined || type == null || type == "") {
            // 올리브영 BI
            $("#mHgroup h1 a").bind("click", function() {
                common.wlog("home_header_bi");
            });
            // 햄버거메뉴
            $(".allmenuOpen").bind("click", function() {
                common.wlog("home_header_drawer");
            });
            // 장바구니 버튼
            $(".mBasket .basket").bind("click", function() {
                common.wlog("home_header_cart");
            });

            // footer 영역
            $("#login, #logout").bind("click", function() {
                common.wlog("home_footer_login");
            });
            $("#customer").bind("click", function() {
                common.wlog("home_footer_customer");
            });
            $("#onlinePhone").bind("click", function() {
                common.wlog("home_footer_onlinephone");
            });
            $("#1to1").bind("click", function() {
                common.wlog("home_footer_1to1");
            });
            $("#storePhone").bind("click", function() {
                common.wlog("home_footer_storephone");
            });
            $("#email").bind("click", function() {
                common.wlog("home_footer_email");
            });
            $(".mlist-sns .facebook").bind("click", function() {
                common.wlog("home_footer_sns_facebook");
            });
            $(".mlist-sns .instagram").bind("click", function() {
                common.wlog("home_footer_sns_instagram");
            });
            $(".mlist-sns .youtube").bind("click", function() {
                common.wlog("home_footer_sns_youtube");
            });
            /*$(".threeConts .sns .youtube").bind("click", function() {
                common.wlog("home_footer_youtube");
            });*/
            $(".mlist-sns .kakao").bind("click", function() {
                common.wlog("home_footer_sns_kakao");
            });
            /*$(".mlist-sns .twitter").bind("click", function() {
                common.wlog("home_footer_sns_twitter");
            });
            $(".mlist-sns .ribyoung").bind("click", function() {
                common.wlog("home_footer_sns_navercafe");
            });*/
        }

        if (type == "search") {
            // 검색
            $("#mSearchWrapper #mTab11 li:eq(0)").bind("click", function() {
                common.wlog("home_header_search_recent");
            });
            // 검색
            $("#mSearchWrapper #mTab11 li:eq(1)").bind("click", function() {
                common.wlog("home_header_search_populoar");
            });
        }

        if (type == "slide") {
            // 로그인
            $(".linkLogin").bind("click", function() {
                common.wlog("home_drawer_login");
            });
            // 설정
            $(".intro .setup").bind("click", function() {
                common.wlog("home_drawer_setting");
            });
            // 알림
            $(".intro .notice.new").bind("click", function() {
                common.wlog("home_drawer_alarm");
            });
            // 마이페이지
            $(".shortcuts .mypage").bind("click", function() {
                common.wlog("home_drawer_mypage");
            });
            // 주문배송
            $(".shortcuts .order").bind("click", function() {
                common.wlog("home_drawer_delivery");
            });
            // 매장안내
            $(".shortcuts .burial").bind("click", function() {
                common.wlog("home_drawer_store");
            });
            // 고객센터
            $(".shortcuts .customer").bind("click", function() {
                common.wlog("home_drawer_customer");
            });
            // 관심매장 로그인
            $(".notice-list .notice-type button.login").bind("click", function() {
                common.wlog("home_drawer_interest_login");
            });
            // 관심매장 공지
            $(".notice-list .storeNtcList").bind("click", function() {
                common.wlog("home_drawer_interestnews_" + $(this).attr("data-ref-ntcSeq"));
            });
            // 공지사항
            $(".notice-area a").bind("click", function() {
                common.wlog("home_drawer_notice");
            });
            /*
             * //뷰티 $(".lnbSmenu .lnbTab li:eq(0)").bind("click", function() {
             * common.wlog("home_drawer_beauty"); }); //푸드 $(".lnbSmenu .lnbTab
             * li:eq(1)").bind("click", function() {
             * common.wlog("home_drawer_food"); }); //라이프탭 $(".lnbSmenu .lnbTab
             * li:eq(2)").bind("click", function() {
             * common.wlog("home_drawer_life"); });
             */
            // 전문관
            $(".lnb-jeonmungwan li").each(function(idx) {
                $(this).find("a").bind("click", function() {
                    common.wlog("home_drawer_special_menu" + (idx + 1));
                });
            });
            // 최근본상품에 대한 웹로그는 common.recentGoods에서 처리함.
            // 최근본상품 더보기
            $(".late-conts a.btnMore").bind("click", function() {
                common.wlog("home_drawer_recent_more");
            });
            // 하위 카테고리
            $(".lnb_sec li a").bind("click", function() {
                common.wlog("home_drawer_category_" + $(this).attr("data-ref-dispCatNo"));
            });
            // 프리미엄관
            $(".subLink > p > a.premium").bind("click", function() {
                common.wlog("home_draver_premium");
            });
            // 기프트관
            $(".subLink > p > a.gift").bind("click", function() {
                common.wlog("home_draver_gift");
            });

            /**
             * 	일시   : 2020.07.13
             *  내용   : 카테고리관 드로우 화면 개정으로 웹로그 바인딩 클릭 내용 수정
             *  작성자 : 허민 (Heo-Min)
             */

            // 멤버쉽 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".rank").bind("click", function() {
                common.wlog("home_drawer_membership");
            });
            // 공지사항 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".contact-notice .ntc a.link").bind("click", function() {
                common.wlog("home_drawer_notice");
            });
            // 관심매장 공지 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".contact-notice .sto a.link").bind("click", function() {
                common.wlog("home_drawer_interestnews_" + $(this).attr("data-ref-ntcSeq"));
            });
            // 카테고리관 (2020.08.04 드로우 화면 개편으로 주석 처리)
            $(".lnb_sec li.link-full a").bind("click", function() {
                //common.wlog("home_drawer_category_" + $(this).attr("data-ref-dispCatNo") + "_categoryshop");
            });
            // 중위 카테고리 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".lnb_sec li li.link-sub a").bind("click", function() {
                commonlog("home_d.wrawer_category_" + $(this).attr("data-ref-dispCatNo"));
            });
            // 기프트관 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".sub-link > a.item02").bind("click", function() {
            	common.wlog("home_draver_gift");
            });
            // 기프트카드 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".sub-link > a.item03").bind("click", function() {
            	common.wlog("home_draver_gift");
            });
            // 전시배너 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".drawer-banner .swiper-slide a").bind("click", function() {
            	common.wlog("home_drawer_dispbanner_banner" + $(this).attr("data-index"));
            });
            // 브랜드관 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".drawer-brand a.item").bind("click", function() {
                common.callBrazeCustomEvent('menu_brand', {
                    onlBrndNm: $(this).find('.txt').text()
                });
            	common.wlog("home_drawer_brand_brandshop" + $(this).attr("data-index"));
            });
            // 고객센터 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".inner .contact-1 a.link").bind("click", function() {
            	common.wlog("home_drawer_customer");
            });
            // 매장안내 (2020.07.13 드로우 화면 개편으로 내용 수정)
            $(".inner .contact-2 a.link").bind("click", function() {
            	common.wlog("home_drawer_store");
            });
        }
    },
    initScpCnt : 0,
    // SCP상품 swiper init
    initScpSwiper : function() {
        if (common.gnb.initScpCnt == 0) {
            // SCP
            // 랜덤 숫자 가져오는 함수
            var fnRandomNum = function(max) { // 랜덤 숫자 가져오는 함수(0~max사이의 값)
                return Math.floor(Math.random() * max);
            }

            var eventFull_len = $('.scp_slide .swiper-wrapper').children('li').length; // FULL
                                                                                        // 배너
                                                                                        // slide
                                                                                        // 갯수
            var eventFull_init_no = fnRandomNum(eventFull_len); // FULL 배너 slide
                                                                // 초기번호

            // 이벤트 FULL 배너 slide
            var scpSlide_set = {
                slidesPerView : 1,
                initialSlide : 0,
                autoplay : false,
                pagination : { el : '.paging', clickable: true },
                navigation : {
                    nextEl : '.next',
                    prevEl : '.prev',
                },
                freeMode : false,
                spaceBetween : 0,
                loop : false
            }, visual_swiper = new Swiper('.scp_slide', scpSlide_set);
        }
    },
};

$.namespace("common.list");
common.list = {
    /**
     * 리스트의 checkbox 클릭 이벤트 바인딩 : 전체선택, 일부 선택에 대한 checkbox 선택 동작 이벤트
     *
     * 1. 전체선택 선택/해제 시 리스트에 있는 체크박스 모두가 선택/해제 됨
     *
     * 2. 목록의 체크박스 선택/해제시 2.1 모두 선택되었을 경우 전체선택 체크박스가 선택 됨. 2.2 일부만 선택 되거나 모두 해제
     * 되었을 경우 전체선택 체크박스가 해제 됨.
     *
     * 사용법 : // --------------------------------------------------------- //
     * 리스트의 체크박스를 선택/해제 하는 이벤트 바인딩 //
     * --------------------------------------------------------- // >> 전체선택 체크박스 :
     * id="inp_all" // >> 목록의 체크박스 : class="chkSmall" //
     * --------------------------------------------------------- <table>
     * <tr>
     * <th><input type="checkbox" id="inp_all">헤더체크박스</th>
     * ... </tr>
     * <tr>
     * <th><input type="checkbox" class="chkSmall">목록체크박스1</th>
     * ... </tr>
     * <tr>
     * <th><input type="checkbox" class="chkSmall">목록체크박스2</th>
     * ... </tr>
     * ... </table> common.list.bindListCheckboxEvent('#inp_all', '.chkSmall');
     *
     * @param allChkboxJqSelector
     *            "전체선택" 체크박스의 JQuery Selector
     * @param listChkboxJqSelector
     *            리스트에 있는 체크박스의 JQuery Selector
     *
     *
     */
    bindListCheckboxEvent : function(allChkboxJqSelector, listChkboxJqSelector) {
        // 전체선택 체크박스(id=inp_all) 클릭시 동작
        $(allChkboxJqSelector).change(function() {
            $(listChkboxJqSelector).prop('checked', this.checked)
        });
        // 목록 체크박스("class=chkSmall") 클릭 시 동작
        $(listChkboxJqSelector).click(function() {
            var uncheckedEa = $(listChkboxJqSelector + ':not(:checked)').length;
            $(allChkboxJqSelector).prop('checked', uncheckedEa == 0);

        });
    }
};

// 라이브관 오픈 tracking 및 세션 관리
$.namespace("common.wcare");
common.wcare = {
    WCARE: "W CARE",
    TOOLTIP_TEXT: "우먼 케어 서비스 오픈했어요!",
    styleName: {
        quickMenuOn: 'on',
    },

    init: function($wcareLink, memberGradeNm) {
        this.$wcareLink = $wcareLink;
        this.mamberGradeNm = memberGradeNm;

        this.setUp();
        this.bindEvent();

        return this;
    },

    setUp: function() {
        this.$quickMenu = $('.quick-menu');
        this.$quickMenuTooltip = $('.quick-menu-tooltip');
        this.$wcareTooltip = $('#wcare-tooltip');
        this.$mHeader = $('#mHeader');

        this.setQuickMenuTooltipPosition();
    },

    bindEvent: function() {
        this.$wcareLink.on('click', this.enterWcareHandler);

        // 타 영역 선택할 경우
        // 페이지 스크롤할 경우
        var closeQuickMenuTooltip = this.closeQuickMenuTooltip.bind(this);

        $(window).one('scroll', closeQuickMenuTooltip);
        $(window).one('touchStart', closeQuickMenuTooltip);
    },

    // quickmenu 위치 고려하여 툴팁 노출 위치 계산
    setQuickMenuTooltipPosition: function() {
        var targetPosition = this.$quickMenu.offset().top;
        var headerHeight = this.$mHeader.outerHeight();

        this.$quickMenuTooltip.css({
            top: `${targetPosition - headerHeight - 38}px`, // 38은 디자인 가이드 반영 위한 음수값
        });
    },

    toolTipAction: function() {
        var isTooltipAlreadyShow = sessionStorage.getItem(STORAGE_KEY.SESSION.WCARE_ENTER_YN);
        if(isTooltipAlreadyShow !== 'Y') {
            setTimeout(function() {
                this.openQuickMenuTooltip();
            }.bind(this), 700);
            setTimeout(function() {
                this.closeQuickMenuTooltip();
            }.bind(this), 5000);
        }
    },

    closeQuickMenuTooltip: function() {
        this.$quickMenuTooltip.removeClass(this.styleName.quickMenuOn);
    },

    openQuickMenuTooltip: function() {
        this.$wcareTooltip.text(this.TOOLTIP_TEXT);
        this.$quickMenuTooltip.addClass(this.styleName.quickMenuOn);
    },

    enterWcareHandler: function(event) {
        event.preventDefault();

        try {
            // tracking ga
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'click-event',
                'data-attr': '홈^퀵메뉴^W CARE',
            });

            // tracking appsflyer, firebase
            var trackingParams = { af_member_level_on: this.mamberGradeNm || "n" }

            common.app.callTrackEvent('af_wcare_shop', trackingParams);
            common.app.sendEventForFirebase('wcare_shop', trackingParams);
        } catch (_) {
            void 0;
        }

        // 입장여부 sessionStorage에 저장
        sessionStorage.setItem(STORAGE_KEY.SESSION.WCARE_ENTER_YN, 'Y');
    },
}

/*--------------------------------------------------------------------------------*\
 * SNS 공통 script
 \*--------------------------------------------------------------------------------*/
$.namespace("common.sns");
common.sns = {

    /**
     * 공통 SNS 공유 방법
     *
     * 1. 공유를 원하는 페이지에서 common.sns.init 함수를 호출한다.
     *
     * 2. init 함수 호출에 필요한 인자는 이미지URL, 공유제목, 공유할 URL이 된다.
     *
     * 3. init후에는 각 공유 버튼 마다 common.sns,doShare 함수를 호출한다.
     *
     * 4. doShare에 필요한 호출인자는 공유할 서비스 명이다. (kakaotalk, kakaostory, facebook)
     *
     */

    imgUrl : '', // 이미지 URL
    title : '', // 공유 제목
    shareUrl : '', // 공유할 URL

    imgUrlKakaoEvt : '', // 이미지 URL
    titleKakaoEvt : '', // 공유 제목
    shareUrlKakaoEvt : '', // 공유할 URL
    titleNameKakaoEvt : '', //버튼문구

    // SNS 공유 Init 함수(페이지 상단 공통 공유용)
    init : function(imgUrl, title, shareUrl) {

        // 카카오톡 Init
        // 개인계정의 카카오톡 자바스크립트 앱키로 적용해야함
        Kakao.init('24077b12ac18b11a96696382ccaa7138');

        common.sns.imgUrl = imgUrl;
        common.sns.title = '[Oliveyoung]' + title;
        common.sns.shareUrl = shareUrl;

        // https-> http로 변경
        common.sns.imgUrl = common.sns.imgUrl.replaceAll("https://", "http://");
        common.sns.shareUrl = common.sns.shareUrl.replaceAll("https://", "http://");

        // URL INPUT BOX 세팅
        // $("#shareUrlTxt").attr("value",shareUrl);
        // $(".input-url").html(shareUrl);
        $("#CopyUrl").text(shareUrl);
        $("#btnShare").css("display", "block");
    },

    // 페이스북 공유를 위한 메타 태그 세팅
    metaTagInit : function() {
        $("meta[property='og:title']").attr("content", common.sns.title);
        $("meta[property='og:url']").attr("content", common.sns.shareUrl);
        $("meta[property='og:image']").attr("content", common.sns.imgUrl);
    },

    // 공유 처리
    doShare : function(type, appYn) {
        // 메타 태그 INIT
        common.sns.metaTagInit();

        // 카카오톡
        if (type == "kakaotalk") {
            Kakao.Link.sendDefault({
                objectType : 'feed',
                content : {
                    title : common.sns.title,
                    imageUrl : common.sns.imgUrl,
                    link : {
                        webUrl : common.sns.shareUrl,
                        mobileWebUrl : common.sns.shareUrl,
                        androidExecParams : common.sns.shareUrl,
                        iosExecParams : common.sns.shareUrl
                    }
                },
                buttons : [ {
                    title : '앱으로 보기',
                    link : {
                        mobileWebUrl : common.sns.shareUrl,
                        webUrl : common.sns.shareUrl
                    }
                } ],
                installTalk : true
            });

        } else if (type == "kakaostory") { // 카카오스토리
            Kakao.Story.open({
                url : common.sns.shareUrl,
                text : common.sns.title,
                install : true
            });
        } else if (type == "facebook") { // 페이스북

            var facebook_url = "";
            facebook_url += "http://m.facebook.com/sharer.php?";
            facebook_url += "u=" + common.sns.shareUrl;

            // 앱일경우와 앱이 아닐 경우
            if (common.app.appInfo.isapp) {
                common.app.callOpenPage("페이스북", facebook_url, '', 'Y');
            } else {
                window.open(facebook_url);
            }

        } else if (type == "url") {

            if ($("#SNSLAYER").find("#urlInfo").hasClass("on")) {
                $("#SNSLAYER").find("#urlInfo").hide();
                $("#SNSLAYER").find("#urlInfo").removeClass("on");
            } else {
                $("#SNSLAYER").find("#urlInfo").addClass("on");
                $("#SNSLAYER").find("#urlInfo").show();
                // $("#SNSLAYER").find("#shareUrlTxt").focus();
                $("#SNSLAYER").find("#CopyUrl").focus();
            }
        }
    },

    // SNS 공유 Init 함수(카톡공유를 통한 이벤트용)
    initKakaoEvt : function(imgUrl, title, shareUrl) {

        common.sns.imgUrlKakaoEvt = imgUrl;
        common.sns.titleKakaoEvt = '[Oliveyoung]' + title;
        common.sns.shareUrlKakaoEvt = shareUrl;

        // https-> http로 변경
        common.sns.imgUrlKakaoEvt = common.sns.imgUrlKakaoEvt.replaceAll("https://", "http://");
        common.sns.shareUrlKakaoEvt = common.sns.shareUrlKakaoEvt.replaceAll("https://", "http://");

    },

    // SNS 공유 Init 함수(카톡공유를 통한 이벤트용)
    initKakaoEvt2 : function(imgUrl, title, shareUrl, titleName) {

        common.sns.imgUrlKakaoEvt = imgUrl;
        common.sns.titleKakaoEvt = '[Oliveyoung]' + title;
        common.sns.shareUrlKakaoEvt = shareUrl;
        common.sns.titleNameKakaoEvt = titleName;

        // https-> http로 변경
        common.sns.imgUrlKakaoEvt = common.sns.imgUrlKakaoEvt.replaceAll("https://", "http://");
        common.sns.shareUrlKakaoEvt = common.sns.shareUrlKakaoEvt.replaceAll("https://", "http://");

    },

    metaTagInitKakaoEvt : function() {
        $("meta[property='og:title']").attr("content", common.sns.titleKakaoEvt);
        $("meta[property='og:url']").attr("content", common.sns.shareUrlKakaoEvt);
        $("meta[property='og:image']").attr("content", common.sns.imgUrlKakaoEvt);
    },

    // 공유 처리
    doShareKakaoEvt : function(type, appYn) {

        // 메타 태그 INIT
        common.sns.metaTagInitKakaoEvt();

        // 카카오톡
        if (type == "kakaotalk") {
            if(common.isEmpty(common.sns.titleNameKakaoEvt)){
                Kakao.Link.sendDefault({
                    objectType : 'feed',
                    content : {
                        title : common.sns.titleKakaoEvt,
                        imageUrl : common.sns.imgUrlKakaoEvt,
                        link : {
                            webUrl : common.sns.shareUrlKakaoEvt,
                            mobileWebUrl : common.sns.shareUrlKakaoEvt,
                            androidExecParams : common.sns.shareUrlKakaoEvt,
                            iosExecParams : common.sns.shareUrlKakaoEvt
                        }
                    },
                    buttons : [ {
                        title : '앱으로 보기',
                        link : {
                            mobileWebUrl : common.sns.shareUrlKakaoEvt,
                            webUrl : common.sns.shareUrlKakaoEvt
                        }
                    } ],
                    installTalk : true
                });
            } else {
                Kakao.Link.sendDefault({
                    objectType : 'feed',
                    content : {
                        title : common.sns.titleKakaoEvt,
                        imageUrl : common.sns.imgUrlKakaoEvt,
                        link : {
                            webUrl : common.sns.shareUrlKakaoEvt,
                            mobileWebUrl : common.sns.shareUrlKakaoEvt,
                            androidExecParams : common.sns.shareUrlKakaoEvt,
                            iosExecParams : common.sns.shareUrlKakaoEvt
                        }
                    },
                    buttons : [ {
                        title : common.sns.titleNameKakaoEvt,
                        link : {
                            mobileWebUrl : common.sns.shareUrlKakaoEvt,
                            webUrl : common.sns.shareUrlKakaoEvt
                        }
                    } ],
                    installTalk : true
                });
            }
        }
    },

    // 공유 처리 (버튼2용)
    doShareKakaoEvt2 : function(mainBtnNm, subBtnNm, subUrl) {

        // 메타 태그 INIT
        common.sns.metaTagInitKakaoEvt();

        // 카카오톡
        Kakao.Link.sendDefault({
            objectType : 'feed',
            content : {
                title : common.sns.titleKakaoEvt,
                imageUrl : common.sns.imgUrlKakaoEvt,
                link : {
                    webUrl : common.sns.shareUrlKakaoEvt,
                    mobileWebUrl : common.sns.shareUrlKakaoEvt,
                    androidExecParams : common.sns.shareUrlKakaoEvt,
                    iosExecParams : common.sns.shareUrlKakaoEvt
                }
            },
            serverCallbackArgs : {
            	evtNo : $("input[id='evtNo']:hidden").val(),
  			    fvrSeq : $("input[id='fvrSeq1']:hidden").val(),
              	mbrNo : recoSsoMbrNo,
              	type : $("input[id='type']:hidden").val()
            },
            success : function(response) {
            	void 0;
            },
            fail : function(error) {
            	void 0;
            },
            buttons : [ {
                title : mainBtnNm,
                link : {
                    mobileWebUrl : common.sns.shareUrlKakaoEvt,
                    webUrl : common.sns.shareUrlKakaoEvt
                }
            },
            {
                title : subBtnNm,
                link : {
                    mobileWebUrl : subUrl.replaceAll("https://", "http://"),
                    webUrl : subUrl.replaceAll("https://", "http://")
                }
            } ],
            installTalk : true
        });
    },

    // 공유 처리 (응모기능 버튼1용)
    doShareKakaoEvt3 : function(mainBtnNm, mainBtnUrl, mainBtnMessage, _callBackSuccess) {

        // 메타 태그 INIT
        common.sns.metaTagInitKakaoEvt();

        var mobileWebUrl;
        var webUrl;
        if(!common.isEmpty(mainBtnUrl)) {
            mobileWebUrl = mainBtnUrl;
            webUrl = mainBtnUrl;
        }else {
            mobileWebUrl = common.sns.shareUrl;
            webUrl = common.sns.shareUrl;
        }

        var titleKakaoEvt;
        if(!common.isEmpty(mainBtnMessage)) {
            titleKakaoEvt = mainBtnMessage;
        }else {
            titleKakaoEvt = common.sns.titleKakaoEvt;
        }

        // 카카오톡
        Kakao.Link.sendDefault({
            objectType : 'feed',
            content : {
                title : titleKakaoEvt,
                imageUrl : common.sns.imgUrlKakaoEvt,
                link : {
                    webUrl : common.sns.shareUrlKakaoEvt,
                    mobileWebUrl : common.sns.shareUrlKakaoEvt,
                    androidExecParams : common.sns.shareUrlKakaoEvt,
                    iosExecParams : common.sns.shareUrlKakaoEvt
                }
            },
            serverCallbackArgs : {
            	evtNo : $("input[id='evtNo']:hidden").val(),
  			    fvrSeq : $("input[id='fvrSeq1']:hidden").val(),
              	mbrNo : recoSsoMbrNo,
              	type : $("input[id='type']:hidden").val()
            },
            success : function(response) {
            	void 0;
                if(_callBackSuccess) {
                    _callBackSuccess();
                }
            },
            fail : function(error) {
            	void 0;
            },
            buttons : [ {
                title : mainBtnNm,
                link : {
                    mobileWebUrl : mobileWebUrl,
                    webUrl : webUrl
                }
            }],
            installTalk : true
        });
    },

    initNew : function(imgUrl, title, shareUrl, description) {
        // 카카오톡 Init
        // 개인계정의 카카오톡 자바스크립트 앱키로 적용해야함
        Kakao.init('24077b12ac18b11a96696382ccaa7138');

        common.sns.imgUrl = imgUrl;
        common.sns.title = '[Oliveyoung]' + title;
        common.sns.shareUrl = shareUrl;
        // if(description != "" && description != undefined) {
        //     common.sns.description = description;
        // } else {
        //     common.sns.description = title + " 님의 프로필입니다.";
        // }

        common.sns.shareUrl = common.sns.shareUrl.replaceAll("#", "");

        // URL INPUT BOX 세팅
        $("#CopyUrl").text(shareUrl);
        $("#btnShare").css("display", "block");
    },

    metaTagInitNew : function() {
        $("meta[property='og:title']").attr("content", common.sns.title);
        $("meta[property='og:url']").attr("content", common.sns.shareUrl);
        // $("meta[property='og:image']").attr("content", common.sns.imgUrl);
    },

    // 공유 처리
    doShareNew : function(type, appYn) {
        // 메타 태그 INIT
        common.sns.metaTagInitNew();

        // 카카오톡
        if (type == "kakaotalk") {
            Kakao.Link.cleanup();
            Kakao.Link.sendDefault({
                objectType : 'feed',
                content : {
                    title : common.sns.title,
                    // description : common.sns.description,
                    imageUrl : common.sns.imgUrl,
                    link : {
                        webUrl : common.sns.shareUrl,
                        mobileWebUrl : common.sns.shareUrl,
                        androidExecParams : common.sns.shareUrl,
                        iosExecParams : common.sns.shareUrl
                    }
                },
                buttons : [ {
                    title : '앱으로 보기',
                    link : {
                        mobileWebUrl : common.sns.shareUrl,
                        webUrl : common.sns.shareUrl
                    }
                } ],
                installTalk : true
            });

        } else if (type == "kakaostory") { // 카카오스토리
            Kakao.Story.open({
                url : common.sns.shareUrl,
                text : common.sns.title,
                install : true
            });
        } else if (type == "facebook") { // 페이스북
            var facebookShareUrl = common.sns.shareUrl;
            facebookShareUrl = facebookShareUrl.replaceAll(encodeURIComponent("&"), "&");
            var facebook_url = "";
            facebook_url += "http://m.facebook.com/sharer.php?";
            facebook_url += "u=" + encodeURIComponent(facebookShareUrl);

            // 앱일경우와 앱이 아닐 경우
            if (common.app.appInfo.isapp) {
                common.app.callOpenPage("페이스북", facebook_url, '', 'Y');
            } else {
                window.open(facebook_url);
            }

        } else if (type == "naverblog") { // 네이버블로그
            var naverBlogShareUrl = common.sns.shareUrl;
            naverBlogShareUrl = naverBlogShareUrl.replaceAll("\\+", encodeURIComponent("+"));

            var blog_url = "";
            blog_url += "http://share.naver.com/web/shareView?";
            blog_url += "url=" + encodeURIComponent(naverBlogShareUrl);
            blog_url += "&title=" + encodeURIComponent(common.sns.title);

            // 앱일경우와 앱이 아닐 경우
            if (common.app.appInfo.isapp) {
                common.app.callOpenPage("네이버블로그", blog_url, '', 'Y');
            } else {
                window.open(blog_url);
            }
        } else if (type == "naverline") { // 네이버라인
            var line_url = "";
            line_url += "https://line.me/R/msg/text/?";
            // line_url += encodeURIComponent(common.sns.description + "|" + common.sns.title + '\r\n' + common.sns.shareUrl);
            line_url += encodeURIComponent(common.sns.title + '\r\n' + common.sns.shareUrl);

            // 앱일경우와 앱이 아닐 경우
            if (common.app.appInfo.isapp) {
                common.app.callOpenPage("네이버라인", line_url, '', 'Y');
            } else {
                window.open(line_url);
            }
        } else if (type == "twitter") { // 트위터
            var twitter_url = "";
            twitter_url += "https://twitter.com/intent/tweet?";
            twitter_url += "url=" + encodeURIComponent(common.sns.shareUrl);
            twitter_url += "&text=" + encodeURIComponent(common.sns.title);

            // 앱일경우와 앱이 아닐 경우
            if (common.app.appInfo.isapp) {
                common.app.callOpenPage("트위터", twitter_url, '', 'Y');
            } else {
                window.open(twitter_url);
            }
        }
    }
};

/*--------------------------------------------------------------------------------*\
 * 장바구니 공통 script
 \*--------------------------------------------------------------------------------*/
$.namespace("common.cart");
common.cart = {
    /* 레코벨 장바구니 담기 추가하면서 추가 S */
    cartNo : '',
    promKndCd : '',
    promNo : '',
    buyCnt : 0,
    getItemAutoAddYn : 'N', // 프로모션 Get군 상품 자동증가 여부 (Get군의 상품 종류가 1가지일 경우)
    getItemGoodsNo : '', // Get 상품 종류가 1가지인 goods_no
    getItemItemNo : '', // Get 상품 종류가 1가지인 item_no
    /* 레코벨 장바구니 담기 추가하면서 추가 E */
    regCartCnt : 0,
    jsonParam : undefined,
    scroll : 0,
    cartBtnObj : undefined,
    trackingInfo: {
        clickedBtn: '',
        gateVal: '',
        trackVal: '',
        setGateCd: function() {
            if (window.location.href.indexOf('loginForm.do') > -1
                || document.referrer.indexOf('loginForm.do') > -1) return;
            if (window.location.href.indexOf('Drawer') > -1) {
                common.cart.trackingInfo.gateVal = 'Drawer';
                sessionStorage.setItem('referGateCd', 'Drawer');
                return;
            }
            if (window.location.href.indexOf('Search') > -1) {
                common.cart.trackingInfo.gateVal = 'Search';
                sessionStorage.setItem('referGateCd', 'Search');
                return;
            }

            function getGateCd(url) {
                if (url.indexOf('getSearchMain.do') > -1)
                    return 'Search';
                else if (url.indexOf('main.do') > -1)
                    return 'Main';
                else if (url.indexOf('getGoodsDetail.do') > -1)
                    return 'PDP';
                else if (url.indexOf('getCurationPop.do') > -1)
                    return 'PDP';
                else if (url.indexOf('myPageMain.do') > -1)
                    return 'My';
                else if (url.indexOf('/mypage/') > -1)
                    return 'My';

                return null;
            };
            common.cart.trackingInfo.gateVal = getGateCd(window.location.href);
            var temprefer = getGateCd(document.referrer);
            if (!!temprefer && document.referrer.indexOf('getCurationPop.do') < 0) sessionStorage.setItem('referGateCd', temprefer);
        },
        getGateCd: function(target) {
            if (target === 'referrer' || !common.cart.trackingInfo.gateVal) return sessionStorage.getItem('referGateCd');
            return common.cart.trackingInfo.clickedBtn === 'gateCd' ? common.cart.trackingInfo.gateVal : sessionStorage.getItem('referGateCd');
        },
        getTrackingCd: function() {
            var temp = common.cart.trackingInfo.trackVal;
            common.cart.trackingInfo.trackVal = '';
            return temp;
        },
        setTrackingCd: function(obj) {
            var val = '';

            if (typeof obj == 'string')
                val = obj;
            else
                val = $(obj).attr('name') ||
                    $(obj).closest(".prod-info").find("a").attr("name") ||
                    $(obj).closest(".innerBox").find("a").attr("name") ||
                    $(obj).closest("li").find("a").attr("name");

            if (val == 'item_check') return; // 건강비밀 예외처리
            if (!!val)
                common.cart.trackingInfo.trackVal = val;
            common.cart.trackingInfo.clickedBtn = typeof obj != 'string' ? 'gateCd' : 'referrer';
        },
    },

    /**
     * 장바구니 cnt 태그를 반환한다.
     * @param {element} el - <button id="headerBasket" />
     * @returns {element} - <span class="cnt" />
     */
    getBasketCntEl: function(el) {
        return el.find('.cnt').length === 0 ?  el.append('<span class="cnt" style="display: block;"></span>').find('.cnt') : el.find('.cnt');
    },

    cartSelValid : function(goodsNo, itemNo, goodsSctCd) {
        var msg = "옵션을 선택해주시기 바랍니다.";

        if (goodsSctCd == "20") {
            msg = "상품을 선택해주시기 바랍니다.";
        }

        if ((goodsNo != undefined && goodsNo != "") || (itemNo != undefined && itemNo != "")) {
            return true;
        } else {
            alert(msg);
            return false;
        }
    },

    urlParams : function(){
        var params = {};
        window.location.search.replace(
        	/[?&]+([^=&]+)=([^&]*)/gi,
        	function(str, key, value) {params[key] = value;}
        );
        return params;
    },

    // jwkim 오늘드림 옵션상품 개편후 mbrDlvpSeq 값 추가
    regCart : function(cartSelGetInfoList, directYn, saveTp, listYn, optChgYn, cartYn, mbrDlvpSeq, pickupDirectYn) {

        var url = _baseUrl + "cart/v2/regCartJson.do";

        var callBackResult = "";

        var quickYn = "N";

        var dlvpSeq = ""; // 오늘드림 배송지 선택한 배송seq 번호 jwkim

        var callback = function(data) {
            var msgCode = data.msgCode;
            var result = data.result;
            callBackResult = data;

            if (result) {
                // 장바구니 수량 업데이트
            	//3310497 (Action Item) 중복호출 제거 - 장바구니 수량 카운트
            	var cookie = new Cookie('local', 1, 'D');
            	if(cookie.get('cartTotCnt') != undefined && cookie.get('cartTotCnt') != ""
            		&& cookie.get('cartTotCnt') != "null" && cookie.get('cartTotCnt') != null){
            		var cartTotCnt = cookie.get('cartTotCnt');
            		var $headerCartCountElements = common.cart.getBasketCntEl($('#headerBasket'));
                    $headerCartCountElements.hide()
                    $headerCartCountElements.removeClass('text_small')
                    if (data != 0) {
                        if (Number(cartTotCnt) >= 10) {
                            $headerCartCountElements.addClass('text_small')
                        }
                        $headerCartCountElements.html(cartTotCnt)
                        $headerCartCountElements.show()
                    }
            		common.app.syncCookie();//모바일 싱크 동기
            	}else{
            		$.ajax({
            			type : "POST",
            			url : _baseUrl + "common/getCartCntJson.do",
            			contentType : "application/json;charset=UTF-8",
            			dataType : 'json',
            			async : false,
            			cache : false,
            			success : function(data) {
                            var $headerCartCountElements = common.cart.getBasketCntEl($('#headerBasket'));
                            $headerCartCountElements.hide()
                            $headerCartCountElements.removeClass('text_small')
            				if (data != 0) {
                                if (Number(cartTotCnt) >= 10) {
                                    $headerCartCountElements.addClass('text_small')
                                }
                                $headerCartCountElements.html(data)
                                $headerCartCountElements.show()
            				}
            				common.app.syncCookie();//모바일 싱크 동기
            			}
            		});
            	}


                // 바로구매시 사용할 return cartNo
                if (directYn == 'Y') {
                    if (listYn == 'A' || listYn == 'S')
                        return false;

                    // 오늘드림 배송지 선택한 배송seq 번호 jwkim
                    if (mbrDlvpSeq != "" && mbrDlvpSeq != undefined) {
                        dlvpSeq = mbrDlvpSeq;
                    }

                    // 선물하기 여부
                    var presentYn = window['presentYn'] == 'Y' ? 'Y' : 'N';

                    //넷퍼넬 상품상세 바로구매 act_05
                    NetFunnel_Action({action_id:"act_05"},function(ev,ret){

                    	// 장바구니로 이동
	                    setTimeout(function() {
                            // jwkim 오늘드림배송에서 일반으로 배송하는 로직에서 사용하는 mbrDlvpSeq(배송지seq)
                            // 값추가
                            try {
                                const cUrl = location.href;
                                if (cUrl.indexOf("/goods/getGoodsDetail.do") > -1) {
                                    let goodsAmplitudeObj = {};
                                    let param = "?cartNo=" + data.rCartNo + "&quickYn=" + quickYn
                                        + "&mbrDlvpSeq=" + dlvpSeq + "&presentYn=" + presentYn + "&pickupDirectYn=" + pickupDirectYn;

                                    goodsAmplitudeObj.t_page = '상품상세';
                                    goodsAmplitudeObj.t_click = presentYn === 'Y' ? '선물하기' : '바로구매';
                                    param = param + "&" + getEventParameterString(goodsAmplitudeObj);

                                    location.href = _secureUrl + "cart/getCart.do" + param;
                                } else {
                                    location.href = _secureUrl + "cart/getCart.do?cartNo=" + data.rCartNo + "&quickYn=" + quickYn
                                        + "&mbrDlvpSeq=" + dlvpSeq + "&presentYn=" + presentYn + "&pickupDirectYn=" + pickupDirectYn;
                                    // location.href = _secureUrl +
                                    // "cart/getCart.do?cartNo=" + data.rCartNo +
                                    // "&quickYn=" + quickYn; // as-is 소스
                                }
                            } catch (e) {
                                void 0;
                                location.href = _secureUrl + "cart/getCart.do?cartNo=" + data.rCartNo + "&quickYn=" + quickYn
                                    + "&mbrDlvpSeq=" + dlvpSeq + "&presentYn=" + presentYn + "&pickupDirectYn=" + pickupDirectYn;
                                // location.href = _secureUrl +
                                // "cart/getCart.do?cartNo=" + data.rCartNo +
                                // "&quickYn=" + quickYn; // as-is 소스
                            }
                        }, 500);

                    }); // 넷퍼넬 End act_05

                } else {
                	//큐레이션
                	try {
            			if(data != null && data != undefined && data != "" && data.rStockQtyInfo != "") {
            				var lgcGoodsNo = data.rStockQtyInfo[0].split("@=@")[4];
            				var onlineItemId = data.goodsInfoList[0].goodsNo;

            				if(lgcGoodsNo != undefined && lgcGoodsNo != null && lgcGoodsNo != "") {
            					common.sendRecobell(lgcGoodsNo, 'cart', onlineItemId);
            				}
            			}
            		} catch(e) {

            		}

                    // GTM
                    var goodsInfoList = callBackResult.goodsInfoList;

                    if (!!goodsInfoList && goodsInfoList.length > 0) {
                    	// productid2 변수 추가 - [3388239] 페이스북 카달라고 Data Layer 수정 요청(CHY)
                    	// price, sale_price 데이터 추가 - [3451865] 페이스북 카달로그 DATA Layer 필드 값 수정 요청(CHY)
                        var goodsNos = [];
                        var goodsNos2 = [];
                        var goodsNms = "";
                        var salePrc = 0;
                        var price = 0;
                        var sale_price = 0;

                        for (var i = 0; i < goodsInfoList.length; i++) {
                            if (i > 0) {
                                goodsNms += "|";
                            }
                            goodsNos.push(goodsInfoList[i].goodsNo + goodsInfoList[i].itemNo);
                            goodsNos2.push(goodsInfoList[i].goodsNo);
                            goodsNms += goodsInfoList[i].goodsNm;
                            salePrc += (parseInt(goodsInfoList[i].salePrc) - parseInt(goodsInfoList[i].cpnRtAmtVal));
                            price += (parseInt(goodsInfoList[i].orgSalePrc));
                            sale_price += (parseInt(goodsInfoList[i].salePrc) - parseInt(goodsInfoList[i].cpnRtAmtVal));
                        }
                        dataLayer.push({
                            'productId' : goodsNos,							// 상품ID + 옵션번호
                            'productId2' : goodsNos2,						// 상품ID
                            'productName' : goodsNms,						// 상품명
                            'productAmt' : salePrc.toString(),				// 상품가격
                            'price' : price.toString() + ' KRW',			//상품원가격
                            'sale_price' : sale_price.toString() + ' KRW'	//상품세일가격
                        });
                    }

                    // [3551897] (GA) 전자상거래 태깅 - 매출
                    var gtmGoodsInfoList = callBackResult.gtmGoodsInfoList;
                    if(!!gtmGoodsInfoList && gtmGoodsInfoList.length > 0) {
                        var productArr = new Array();
                        for(var i = 0 ; i < gtmGoodsInfoList.length ; i++){
                            productArr.push({
                                'id':gtmGoodsInfoList[i].lgcGoodsNo, // 마스터 상품코드
                                'name':gtmGoodsInfoList[i].goodsNm, // 상품명
                                'price':(Number(gtmGoodsInfoList[i].salePrc) || 0), // 상품단가
                                'brand':gtmGoodsInfoList[i].onlBrndNm, // 브랜드
                                'category':(gtmGoodsInfoList[i].stdCatNm ? gtmGoodsInfoList[i].stdCatNm.replaceAll("/", "_").replaceAll(">", "/") : undefined), // 상품카테고리
                                'quantity':(Number(gtmGoodsInfoList[i].cartOrdQty) || 0),
                                'variant':gtmGoodsInfoList[i].itemNm,
                                'dimension43':gtmGoodsInfoList[i].goodsNo, // 온라인 상품코드
                                'dimension44':gtmGoodsInfoList[i].goodsNm, // 온라인 상품명
                                'dimension45':gtmGoodsInfoList[i].itemNm, // 온라인 상품옵션
                                'dimension46':gtmGoodsInfoList[i].prgsStatNm, // 판매상태
                                'dimension47':gtmGoodsInfoList[i].dermoYn, // 더모 여부
                                'dimension48':(gtmGoodsInfoList[i].premBrndYn ? gtmGoodsInfoList[i].premBrndYn : undefined), // 프리미엄 여부
                                'dimension49':(gtmGoodsInfoList[i].tradeShpCd == '1' ? 'N' : 'Y'), // 위수탁 구분
                                'dimension51':(gtmGoodsInfoList[i].malInfSctCd == '2' ? 'Y' : 'N'), // 남성상품 여부
                                'dimension52':(gtmGoodsInfoList[i].malInfSctCd == '3' ? 'Y' : 'N'), // 유아상품 여부
                                'dimension53':gtmGoodsInfoList[i].onlYn, // 온라인전용상품 여부
                                'dimension54':gtmGoodsInfoList[i].onlyoneSctNm, // ONLYONE상품 구분
                                'dimension55':gtmGoodsInfoList[i].quickYn, // 오늘드림 상품여부
                                'dimension56':((Number(gtmGoodsInfoList[i].oneLineGdasTotCnt)+Number(gtmGoodsInfoList[i].prmumGdasTotCnt)) || 0), // 고객 리뷰수
                                'dimension57':(gtmGoodsInfoList[i].dispCatNm ? gtmGoodsInfoList[i].dispCatNm.replaceAll("/", "_").replaceAll(">", "/") : undefined), // 전시 카테고리
                                'dimension58':gtm.goods.getBenefitInfo(gtmGoodsInfoList[i]), // 적용 혜택
                                'dimension60':Math.floor(Number(gtmGoodsInfoList[i].orgSalePrc) > Number(gtmGoodsInfoList[i].salePrc) ? ((Number(gtmGoodsInfoList[i].orgSalePrc) - Number(gtmGoodsInfoList[i].salePrc)) / Number(gtmGoodsInfoList[i].orgSalePrc) * 100) : 0), // 상품 할인율
                                'dimension61':quickYn, // 오늘드림이용 여부
                                'dimension62':presentYn // 선물하기이용 여부
                            });
                        }

                        var urlParams = common.cart.urlParams();
                        var gateCd = "";
                        var trackingCd = "";
                        /*
                        if(urlParams.gateCd != undefined){
                            gateCd = urlParams.gateCd;
                        }else{
                            gateCd = common.cart.trackingInfo.getGateCd();
                        }
                        if(urlParams.trackingCd != undefined){
                            trackingCd = urlParams.trackingCd;
                        }else{
                            trackingCd = common.cart.trackingInfo.getTrackingCd();
                        }
                        */

                        var presentYn = window['presentYn'] == 'Y' ? 'Y' : 'N';

                        window.dataLayer = window.dataLayer || [];
                        var gtmParam = {
                            "event":'ee-addToCart',
                            'dimension41':gtmGoodsInfoList[0].lgcGoodsNo, // 마스터 상품코드
                            'dimension42':gtmGoodsInfoList[0].goodsNm, // 마스터 상품명
                            'dimension50':gtmGoodsInfoList[0].onlBrndNm, // 브랜드명
                            'dimension75':(gateCd ? gateCd : undefined), // 게이트 코드
                            'dimension76':(trackingCd ? trackingCd : undefined), // 트래킹 코드
                            'ecommerce': {
                                'currencyCode': 'KRW',
                                'add': {
                                    'products': productArr
                                }
                            }
                        };
                        window.dataLayer.push(gtmParam);
                    }

                    if (optChgYn == 'Y') {
                        location.reload();
                        return false;
                    }

                    // 메인 목록에서 장바구니 담기 했을 시
                    // 2020-08-27 옴니채널 서비스 구축 - 큐레이션 : 장바구니 담기 후 토스트 팝업으로 전체 변경
                    if (listYn == 'Y') {
                        // 기존 화면 닫기
                        common.popLayerClose('basketOption');

                        // 장바구니 등록 완료 화면으로 이동
                        var url = _baseUrl + "common/getCartCompleteAjax.do";

                        common.Ajax.sendRequest("POST", url, data, common._callCartComplete);
                    } else if (listYn == 'A' || listYn == 'S') {
                        common.cart.regCartCnt += 1;
                    } else {
                        try {
                            //장바구니 ToastMessage 하단 버튼 곂쳐짐 증상으로 분리
                            if (cartYn == "Y") {
                                common.cart.showMessageForCart("나의 장바구니에 담았어요",
                                        mcart.base.toastParentsClass,
                                        mcart.base.toastMargin);
                            } else {
                                common.cart.showBasket();
                            }
                        } catch (e) {
                            common.cart.showBasket();
                        }
                    }
                }

            } else {
                if (listYn == 'A')
                    return false;

                if (msgCode == '100' && !common.loginChk()) {
                    return false;
                }

                // 임시회원 기능 제한 — 브릿지 페이지로 이동
                if (msgCode == 'TEMP_RESTRICTED') {
                    location.href = _secureUrl + 'login/tempMemberBridge.do';
                    return false;
                }

                // 임시회원 기능 제한 — 브릿지 페이지로 이동
                if (msgCode == 'TEMP_RESTRICTED') {
                    location.href = _secureUrl + 'login/tempMemberBridge.do?returnUrl=' + encodeURIComponent(location.href);
                    return false;
                }

                if (msgCode == '1002') {
                    return false;
                }

                if (msgCode == '1003' || msgCode == '1005' || msgCode == '1010') {
                    try {
                        if (cartYn == "Y") {
                            common.cart.showMessageForCart(data.message,
                                    mcart.base.toastParentsClass,
                                    mcart.base.toastMargin);
                        } else {
                            common.cart.showFailMessage(data.message, true);
                        }
                    } catch (e) {
                        common.cart.showFailMessage(data.message, true);
                    }
                } else {
                    try {
                        if (cartYn == "Y") {
                            common.cart.showMessageForCart(
                                    !!data.message ? data.message
                                            : "장바구니 등록에 실패하였습니다",
                                    mcart.base.toastParentsClass,
                                    mcart.base.toastMargin);
                        } else {
                            common.cart.showFailMessage(!!data.message ? data.message : "장바구니 등록에 실패하였습니다", false);
                        }
                    } catch (e) {
                        common.cart.showFailMessage("장바구니 등록에 실패하였습니다", false);
                    }
                }
            }
        };

        // 퀵배송변수 quickYn SET
        try {
            quickYn = cartSelGetInfoList[0].quickYn;
            if (quickYn != "Y" && quickYn != "N") {
                quickYn = "N";
            }
        } catch (e) {
            quickYn = "N";
        }

        // [CJOYITEM-356] 블랙프라이데이 색조 클리어런스 기획전 용 등급별 구매 가능 시간 분리 코드
        // var ajax_result = "";
        //
        // $.ajax({
        //     url: _baseUrl + "goods/checkBuyingGradeAjax.do",
        //     async: false,
        //     data: {'goodsNo': $("#goodsNo").val()},
        //     dataType: 'json',
        //     success: function (res) {
        //         if(res.result == false) {
        //             common.cart.showFailMessage(res.message, false);
        //         }
        //         ajax_result = res.result;
        //     },
        //     error: function (res) {
        //         // 구매 가능하지 않은 등급의 고객은 알림 창 표시 후 구매를 진행하지 못하도록 막는다.
        //         common.cart.showFailMessage(res.message, false)
        //         ajax_result = false;
        //     }
        // });
        //
        // if(ajax_result == false) return false;

        var isValid = this.validation(cartSelGetInfoList, directYn, saveTp, optChgYn, cartYn, pickupDirectYn);

        if (isValid) {
            $.ajax({
                type : "POST",
                url : url,
                data : JSON.stringify(this.jsonParam),
                contentType : "application/json;charset=UTF-8",
                dataType : 'json',
                async : false,
                cache : false,
                success : callback,
                error : function(e) {
                    void 0;
                    try {
                        if (cartYn == "Y") {
                            common.cart.showMessageForCart(
                                    "장바구니 등록에 실패하였습니다",
                                    mcart.base.toastParentsClass,
                                    mcart.base.toastMargin);
                        } else {
                            common.cart.showFailMessage("장바구니 등록에 실패하였습니다", false);
                        }
                    } catch (e) {
                        common.cart.showFailMessage("장바구니 등록에 실패하였습니다", false);
                    }
                }
            });
        }

        return callBackResult;
    },

    showFailMessage : function(message, isWarn){
        if ($('.toast').length) {
            return;
        }
        var className = $('.footerTab .noti_service').length ? 'toast live' : 'toast';
        var colorClass = isWarn ? 'warn' : '';

        var messages = message.split('\n');
        var html = "<div class='" + className + "'><p class='" + colorClass + "'>";
        for (var i = 0; i < messages.length; i++) {
            if (i === messages.length - 1) {
                html = html + messages[i];
            } else {
                html = html + messages[i] + "</br>";
            }
        }
        html = html + "</p></div>";

        $("body").append(html);

        setTimeout(function(){
            $(".toast").remove();
        }, 2800);
    },

    showMessageForCart : function (message, parent, spacer){
        var $toast = {target: null, h: 0};
        var $target = parent ? $(parent) : $('body');
        var messages = message.split('\n');
        var html = "<div class='toast-layer'><p class='inner'>";
        for (var i = 0; i < messages.length; i++) {
            if (i === messages.length - 1) {
                html = html + messages[i];
            } else {
                html = html + messages[i] + "</br>";
            }
        }
        html = html + "</p></div>";
        $target.append(html);
        $toast.target = $target.find('.toast-layer');
        $toast.h = -($toast.target.height() + spacer);
        $toast.target.animate({top: $toast.h, opacity: 1}, function(){
            var _this  = this;
            setTimeout(function(){
                $(_this).animate({top: 0, opacity: 0}, function(){
                    $(_this).remove();
                });
            }, 3000);
        });
    },

    validation : function(cartSelGetInfoList, directYn, saveTp, optChgYn, cartYn, pickupDirectYn) {
        // 파라메터의 validation 처리
        // console.log("ins.validation :: cartSelGetInfoList=" +
        // JSON.stringify(cartSelGetInfoList, null, 2));
        var isValid = true;
        if (cartSelGetInfoList == null) {
            var msg = "죄송합니다. 고객센터에 문의해 주세요.";

            this.jsonParam = false;
            isValid = false;
        }

        // 행사안내레이어 장바구니버튼 진입시사용
        if (location.href.indexOf("getCart.do?cartNo=") > 0) {
            directYn = "Y";
        }

        // 오늘드림 상품상세 장바구니 담기 추가.
        var prodView = cartSelGetInfoList.prodView;
        if(prodView == undefined || prodView == "") {
            prodView = "N";
        }

     // 오늘드림 상품상세 장바구니 담기 추가.
        var strNo = cartSelGetInfoList.strNo;
        if(strNo == undefined || strNo == null) {
        	strNo = "";
        }

        if (isValid) {

            var qDeliveVal = $("input[name=qDelive]:checked").val();

            if (qDeliveVal == undefined || qDeliveVal == null || qDeliveVal == "") {
                qDeliveVal = "N";
            }

            var urlParams = common.cart.urlParams();
            var gateCd = common.cart.trackingInfo.getGateCd();
            var trackingCd = common.cart.trackingInfo.getTrackingCd();
            if ((!trackingCd || trackingCd == 'null')) {
                if (urlParams.trackingCd != undefined)
                    trackingCd = urlParams.trackingCd;
                else if (!!$('#trackingCd').val())
                    trackingCd = $('#trackingCd').val();
            }
            if (!gateCd && !!$('#gateCd').val()) {
                gateCd = $('#gateCd').val();
            }

            this.jsonParam = {
                drtPurYn : directYn,
                saveTp : saveTp,
                optChgYn : optChgYn,
                cartYn : cartYn,
                quickYn : qDeliveVal,
                prodView : prodView,
                strNo : strNo,
                opCartBaseList : cartSelGetInfoList,
                presentYn : window['presentYn'] == 'Y' ? 'Y' : 'N',
                trackingCd : trackingCd,
                gateCd : gateCd,
                pickupDirectYn : pickupDirectYn
            };
        }
        return isValid;
    },

    showBasket : function() {
        // 장바구니 담기시 펑션 호출 (상품상세 장바구니, 추천영역 장바구니, 컬러칩 장바구니)
        common.header.goodsStackScreen('reloadPreviousGoodsDetailScreen');

        common.cart.regCartCnt += 1;

        let className;

        const path = window.location.pathname;
        const menuParam = new URLSearchParams(window.location.search).get('menu');

        if (path === "/m/mtn" && menuParam === "dynamicGnb" && common.isApp()) {
            // 앱이면서, mtn 에 노출되는 전략 GNB의 경우
            const isLiveNudgeSkip = Boolean(sessionStorage.getItem('liveNudgeSkip'));
            const isLiveNudgeVisible = Boolean(document.getElementById("mtn-live-nudge-wrapper"));

            className = isLiveNudgeVisible && !isLiveNudgeSkip ? 'toast live' : 'toast';
        } else {
            // 일반적인 경우
            className = $('.footerTab .noti_service').length ? 'toast live' : 'toast';
        }

        $("body").append("<div class='" + className + "'><p>나의 장바구니에 담았어요</p></div>");

        if(common.cart.scroll > 0) { //토스트 팝업 노출 후 기존 위치 이동을 위해..
     		$(window).scrollTop(common.cart.scroll);
    		common.cart.scroll = 0;
        }

        // mantis : 0000561 로 인한 class 제거 주석처리 필요
        setTimeout(function(){
            $(".toast").remove();
        }, 2800);
    },

    showBasket2 : function(goodsNo) {
        common.cart.regCartCnt += 1;
        common.cart.recoPopLayerOpen();
        common.cart.callRecoBellGoodsInCart(goodsNo);

    },

    //20200827 기프트관 장바구니 분기처리 CBLIM
    showBasket3 : function(goodsNo) {
        common.cart.regCartCnt += 1;
        common.cart.recoPopLayerOpen("giftMain");
        $("#curation_area_a003").html("");
    },
    callRecoBellGoodsInCart : function(goodsNo) {
        var goodsNos = [];
        goodsNos.push(goodsNo);

        var url = _baseUrl + "cart/getRecoBellGoodsInCartLayerAjax.do";
        var param = {
                goodsNos : goodsNos.toString(),
                quickYn : $("#quickYn").val() || null
        };

        var _callBackRecoBellGoodsInCartInfo = function(data) {
            $("#curation_area_a003").html("");
            $("#curation_area_a003").html(data);
            common.popLayerRecoOffset();
        };

        common.Ajax.sendRequest("POST",url,param,_callBackRecoBellGoodsInCartInfo);
    },


    recoPopLayerOpen : function(pageId){
		$("#cardBenefitInfo").show();
		/*
		if(giftPlusItemYn == 'Y'){
			$("#cardBenefitInfo .popLayerArea .popCont .txt_onbag").html("<p class='txt_onbag'>행사 상품입니다.<br>장바구니에서 상품을 선택해주세요.</p>");
		}
		*/
		var wHeight = $(window).height();
        var popLayer = $("#cardBenefitInfo");
        var popinner = popLayer.find('.popCont');
        var popHeight = $(popLayer).height();
        var popPos = popHeight/2;
        var popWid = $(popLayer).width()/2;
        if(popHeight>=wHeight){
            var inHeight = wHeight - 50;
            popinner.css({'max-height': inHeight});
            var popPos = $(popLayer).height()/2;
        }

        if (pageId == "giftMain") { // 기프트관만 별도 처리
            $(popLayer).css({'left':'50%', 'margin-left':-(popWid), 'top':'50%', 'margin-top':-(popPos)}).show();
        } else {
            $(popLayer).css({'left':'50%', 'margin-left':-(popWid), 'top':'50%', 'margin-top':-(popPos)}).show().parents('body').css({'overflow' : 'hidden'});
        }

		$('.dim').show();

        $('.dim').bind('click', function() {
            common.popLayerClose('cardBenefitInfo');
            return false;
        });
		common.cart.completeMsg();
	},

    updHeaderCartCnt : function() {
        if (common.isLogin()) {
            // 장바구니 수량 업데이트
        	//3310497 (Action Item) 중복호출 제거 - 장바구니 수량 카운트
        	var cookie = new Cookie('local', 1, 'D');
        	if(cookie.get('cartTotCnt') != undefined && cookie.get('cartTotCnt') != ""
        		&& cookie.get('cartTotCnt') != "null" && cookie.get('cartTotCnt') != null){
        		var cartTotCnt = cookie.get('cartTotCnt');
                var $headerCartCountElements = common.cart.getBasketCntEl($('#headerBasket'));
                $headerCartCountElements.hide()
                $headerCartCountElements.removeClass('text_small')
                if (Number(cartTotCnt) > 0) {
                    if (Number(cartTotCnt) >= 10) {
                        $headerCartCountElements.addClass('text_small')
                    }
                    $headerCartCountElements.html(cartTotCnt)
                    $headerCartCountElements.show()
                }
        	}else{
        		$.ajax({
        			type : "POST",
        			url : _baseUrl + "common/getCartCntJson.do",
        			contentType : "application/json;charset=UTF-8",
        			dataType : 'json',
        			async : false,
        			cache : false,
        			success : function(data) {
        				if (typeof data != 'undefined' && data != null) {
                            var $headerCartCountElements = common.cart.getBasketCntEl($('#headerBasket'));
                            $headerCartCountElements.hide()
                            $headerCartCountElements.removeClass('text_small')
                            if (data != 0) {
                                if (Number(cartTotCnt) >= 10) {
                                    $headerCartCountElements.addClass('text_small')
                                }
                                $headerCartCountElements.html(data)
                                $headerCartCountElements.show()
                            }
        				}
        			}
        		});
        		//common.app.syncCookie();//모바일 싱크 동기
        	}
        }
    },

    updStonArea : function() {
        var _footerLoginAreaHtml = "";
        if (common.isLogin()) {
            _footerLoginAreaHtml = "<a href=\"javascript:common.link.moveLogoutPage('장바구니헤더');\" id=\"logout\" title=\"페이지 이동\" fromAttr=\"common.js\">로그아웃</a>";
        } else {
            _footerLoginAreaHtml = "<a href=\"javascript:common.link.moveLoginPage('','','Y');\" id=\"login\" title=\"페이지 이동\" fromAttr=\"common.js\">로그인</a>";
        }
        $("#footerLoginArea").html(_footerLoginAreaHtml);

        try{
        	common.cart.sendRedirectDevice(); // device에 따라 redirect 처리
        }catch(e){
        	void 0;
        }


    },

    sendRedirectDevice : function() {

        var _parser = new UserAgentUtil(navigator.userAgent);
        var _appInfo = _parser.getAppInfo();
        var _isMobileApp = _appInfo.isapp;
        var _isMobile = _parser.isMobile(); // 계속 호출하면 return 값이 변해서 변수선언
        var _currUrl = window.location.href;
        var _toUrl = _baseUrl;

        // redirect url protocol 제거
        _redirectMoBaseUrl = _redirectMoBaseUrl.replace("https:", "").replace("http:", "");
        _redirectMaBaseUrl = _redirectMaBaseUrl.replace("https:", "").replace("http:", "");
        _redirectFoBaseUrl = _redirectFoBaseUrl.replace("https:", "").replace("http:", "");

        if (_isMobile) {
             // http 일경우 https로 redirect
            if(_currUrl.indexOf("http://") > -1) {
                _toUrl = _currUrl.replace("http://", "https://");
                window.location.href = _toUrl;
            }
        } else {
            // 모바일이 아닐때 PC Redirect
            if (_currUrl.indexOf(_redirectMoBaseUrl) > -1) {
                _toUrl = _currUrl.replace(_redirectMoBaseUrl, _redirectFoBaseUrl);
                window.location.href = _toUrl;
            }
        }
    },

    completeMsg : function(){
        var addMsg = "";
        if(common.cart.buyCnt >= 1){     // 프로모션 N+1 조건 중 N이 1일 경우
            if(common.cart.promKndCd == "P201"){
                addMsg = "<br>" + common.cart.buyCnt + "+1상품도 함께 추가되었습니다!";
            } if(common.cart.promKndCd == "P202"){
                    addMsg = "<br>" + common.cart.buyCnt + "+1행사상품이므로, 장바구니에서<br>추가상품을 선택해주세요!";
            } if(common.cart.promKndCd == "P203"){
                if(common.cart.getItemAutoAddYn == "Y")
                    addMsg = "<br>Gift상품도 함께 추가되었습니다!";
                else
                    addMsg = "<br>Gift행사상품이므로, 장바구니에서<br>추가상품을 선택해주세요!";
            }
        }

        if(common.cart.promNo != undefined && common.cart.promNo != ""){
            $("#cardBenefitInfo .popLayerArea .popCont .txt_onbag").html("<p class='txt_onbag'>"+addMsg+"</p>");
        }else{
        	$("#cardBenefitInfo .popLayerArea .popCont .txt_onbag").html("<p class='txt_onbag'>장바구니에 추가되었습니다.</p>");
        }
    },
};

/*--------------------------------------------------------------------------------*\
 * 최근 본 상품 공통
 \*--------------------------------------------------------------------------------*/
$.namespace("common.recentGoods");
common.recentGoods = {

    param : "",

    init : function() {
        common.recentGoods.getList('slide');

        // 더보기 버튼 이벤트 처리
        $('.late-conts > .btnMore').on('click', function() {
            common.link.moveRecentList();
        });
    },

    mergeRecentlyViewedItemList(oldList, newList) {
        // oldList, newList는 stringify json 형태
        var oldItems = oldList || '';
        var newItems = newList || '';

        if(oldItems && !newItems) {
            var cookie = new Cookie(30);
            localStorage.setItem('recentlyViewedItemList', oldItems);
            cookie.set('productHistory', '');
            return;
        }

        if(oldItems && newItems) {
            var newItemsJson = JSON.parse(newItems);
            var oldItemsJson = JSON.parse(oldItems);

            var mergeItems = JSON.parse(newItems);

            oldItemsJson.forEach(item => {
                var index = newItemsJson.findIndex(function(merged) {
                    return merged.goodsNo === item.goodsNo;
                });

                if(index < 0) {
                    mergeItems.push(item);
                }
            });

            localStorage.setItem('recentlyViewedItemList', JSON.stringify(mergeItems));
        }
    },

    getGoodsList : function(goodsCnt) {
        var goodsNo = "";
        // default : 최대 5개

        // BI Renewal. 20190918. nobbyjin. - 쿠키설정오류 수정
        // cookie = new Cookie('local', 1, 'M');

        var cookie = new Cookie(30);
        common.recentGoods.mergeRecentlyViewedItemList(
            cookie.get("productHistory"),
            localStorage.getItem("recentlyViewedItemList")
        );

        var recentlyViewedItemList = localStorage.getItem('recentlyViewedItemList');
        if (recentlyViewedItemList != undefined && recentlyViewedItemList != "") {

            var jsonStr = JSON.parse(recentlyViewedItemList);
            var cnt = jsonStr.length;

            if (goodsCnt != undefined && goodsCnt != null && goodsCnt != "") {
                cnt = goodsCnt
            }

            for (var i = 0; i < jsonStr.length && i < 10; i++) {
                if (i < cnt && jsonStr[i].goodsNo != null && jsonStr[i].goodsNo != "") {
                    if (i == jsonStr.length - 1 || i == 9) {
                        goodsNo += jsonStr[i].goodsNo;
                    } else {
                        goodsNo += jsonStr[i].goodsNo + ",";
                    }
                }

                if (i == cnt) {
                    break;
                }
            }
        }
        return goodsNo;
    },

    getList : function(type, callback, trackingCd) {

        // 메인 - drawer메뉴 하단 - 최근본상품 5개 제한
        var goodsNo;

        if (type == "slide") {
            goodsNo = common.recentGoods.getGoodsList(5);
        //[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10
        } else if (type == "search") {
        	goodsNo = common.recentGoods.getGoodsList(10);
       	//[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10 - end
        } else {
            goodsNo = common.recentGoods.getGoodsList();
        }

        if (goodsNo != null && goodsNo != "") {
            param = {
                goodsInfo : goodsNo,
                type : type,
                pagingFlag : "N",
                trackingCd: trackingCd
            };

            common.Ajax.sendRequest("get", _baseUrl + "mypage/getRecentListAjax.do", param, function(res) {
                common.recentGoods.getRecentListAjaxCallback(res, type, callback);
            });
        } else {
            if (type == "slide") {
                // BI Renewal. 20190918. nobbyjin. - nodata 영역 수정
                // $(".nodataTxt").show();
                if ($(".nodataTxt").length > 0) {
                    $(".nodataTxt").show();
                } else {
                    $(".late-conts .mlist3v-goods").append("<li class='nodataTxt'>최근 본 상품이 없어요</li>");
                }
            //[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10
            } else if ( type == "search") {
            	$("#recentgoods .list_wrap").hide();
            	$("#recentgoods .btn_clear_wrap").hide();
            	$("#recentgoods .info_none").show();
       	    //[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10 - end
            } else {
                $(".sch_no_data2").show();
            }
        }

    },

    /**
     * 최근 본 상품 정보조회
     */
    getRecentListAjaxCallback : function(res, type, callback) {

    	if (res.trim() == "") {
        	//[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10
        	if (type == "slide") {
        		$(".sch_no_data2").show();
        	} else if (type == "search") {
        		$("#recentgoods .list_wrap").hide();
            	$("#recentgoods .btn_clear_wrap").hide();
            	$("#recentgoods .info_none").show();
        	}
        	//[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10 - end
        } else {
            if (type == "slide") {
                $(".late-conts .mlist3v-goods").append(res);

                /** 이미지 속성 교체 (LazyLoad 사용 안함) * */
                $(".late-conts .mlist3v-goods > li img").each(function() {
                    $(this).attr("src", $(this).attr("data-original"));
                });

                common.wish.init();

                $(document).resize();
            //[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10
            } else if (type == "search") {
            	$("#recentgoods .list_wrap").html(res);
            	$("#recentgoods .info_none").hide();
            	$("#recentgoods .list_wrap").show();
            	$("#recentgoods .btn_clear_wrap").show();
            	common.setLazyLoad();
           	//[상세검색개선] 최근본 상품 10개 가져오기 2020-09-10 - end
            } else {
                $("#mContents div.totalBox").show();
                $("#mContents").append(res);
                $(".totalBox > .cnt strong").text($(".prod-list .prod").length);
                common.setLazyLoad();
            }

            var jsonStr = JSON.parse(localStorage.getItem('recentlyViewedItemList') || '');
            var chkChg = false;

            // 쿠키 30개 넘어가는 상품번호 삭제처리
            for (var j = 0; j < jsonStr.length; j++) {
                if (j >= 30) {
                    delete jsonStr.splice(j, 1);
                    chkChg = true;
                }
            }
            // 쿠키에 값 셋팅
            // cookie.set('productHistory', JSON.stringify(jsonStr));
            if (chkChg) {
                localStorage.setItem('recentlyViewedItemList', JSON.stringify(jsonStr));
            }

            setTimeout(function() {
                // 링크 처리
                common.bindGoodsListLink(".late-conts .mlist3v-goods");

                //[상세검색개선] 최근본상품 링크 연결 2020-09-10
                common.bindGoodsListLink("#recentgoods .list_wrap");
                //[상세검색개선] 최근본상품 링크 연결 2020-09-10 - end

                common.recentGoods.bindWebLog();
            }, 100);
        }

        if (callback != undefined) {
            callback();
        }
    },

    // 웹로그 바인드
    bindWebLog : function() {

    	// 공지사항
        $(".late-conts .mlist3v-goods li").each(function(idx) {
            $(this).find(".goodsList").bind("click", function() {
                common.wlog("home_drawer_recent_goods" + (idx + 1));
            });
        });

        //[상세검색개선] 최근본 상품 DS추가 2020-09-17
        $("#recentgoods > div.list_wrap > a").each(function(idx) {
            $(this).bind("click", function() {
            	var num = $(this).attr("data-ref-num");
                common.wlog("home_header_search_recentgoods" + num);
            });
        });
        //[상세검색개선] 최근본 상품 DS추가 2020-09-17 - end

    },

    // BI Renewal. 20190918. nobbyjin. - 유틸바 최근본 상품 셋팅.
    getLast : function() {
        $("#footerTabRecentGoods .thum").hide();
    },

    curationMove : function(obj, lgcGoodsNo, goodsNo, dispCatNo, smlDispName){

    	// 한번이라도 오픈한 경우 다시 닫았다가 오픈했을때 레코벨을 호출하지 않기 위해서 사용
    	if($("#recobell_area_"+goodsNo).hasClass("recobellOpenChk")){
    		return false;
    	}

        var rccode = "";
        if(common.isLogin()){
        	rccode = "mc_recency_01_a";
        } else {
        	rccode = "mc_recency_01_c";
        }

        var url = _baseUrl + "goods/getRecoBellGoodsDetailAjax.do";

        var param = {
                recType : "a002",
                repLgcGoodsNo : lgcGoodsNo,
                goodsNo : goodsNo,
                recoBellDispCatNo : dispCatNo,
                smlDispName : smlDispName,
                viewType : "recent"
        };

        var _callBackGetRecoBellContsInfo = function(data) {

        	// 큐레이션이 없는경우
        	if(data.trim() == ""){
        		//alert("아무것도 조회되지 않은경우");
        		//$(obj).removeClass("on");
        		//$(obj).remove();

        		var itemNone = "<div class='itemNone'><p class='txt'>고객님에게 꼭 맞는<br>추천 상품을 준비 중이에요.</p></div>";

        		$("#recobell_area_"+goodsNo).html("");
                $("#recobell_area_"+goodsNo).html(itemNone);


        		return false;
        	}

        	// 한번이라도 오픈한 경우 다시 닫았다가 오픈했을때 레코벨을 호출하지 않기 위해서 사용
        	$("#recobell_area_"+goodsNo).addClass("recobellOpenChk");
            $("#recobell_area_"+goodsNo).html("");
            $("#recobell_area_"+goodsNo).html(data);

            $("#recobell_area_"+goodsNo+" ul li a.item").each(function(i){
	            var _item = $(this);
	    		var _data_goodsno = _item.attr('data-ref-goodsno');
	    		var _data_dispCatNo = _item.attr('data-ref-dispCatNo');
	    		var egcode = _item.attr("data-egcode");
	    		var egrank = _item.attr("data-egrank");
                var trackingCd = "Common_Recent_Curation";
                var _nm = $(this).find('.text').text();

                _item.attr('href','javascript:common.link.moveGoodsDetailCuration("'+_data_goodsno+'", "'+_data_dispCatNo+'","goods_detail_a002","'+rccode+'","'+egcode+'", "'+egrank+'", "", "", "", "","'+trackingCd+'");');
                _item.attr('data-attr','공통^최근본상품_큐레이션영역^'+_nm+'^'+(i+1)+'');
                _item.attr('data-trk', "<%= _gtmTrk %>");
                _item.attr('onclick', 'javascript: gtm.goods.callGoodsGtmInfo("'+_data_goodsno+'", "", "ee-productClick", "공통_최근본상품_큐레이션영역", "'+(i+1)+'");');
            });

            $(document).on("click","#recobell_area_"+goodsNo+" ul li a.item", function(){
                var _item = $(this);
                var _data_goodsno = _item.attr('data-ref-goodsno');
                var _data_dispCatNo = _item.attr('data-ref-dispCatNo');
                var egcode = _item.attr("data-egcode");
                var egrank = _item.attr("data-egrank");
                var trackingCd = "Common_Recent_Curation";

                common.link.moveGoodsDetailCuration(_data_goodsno,_data_dispCatNo,"goods_detail_a002",rccode,egcode,egrank,"","","","",trackingCd);
            });

            //큐레이션 더보기 팝업 이벤트 추가
            var recType = "a002";
        	var revobellParam = {
        		size : 40, //큐레이션 api 호출용, 더보기 팝업 노출갯수
        		cps : true, //큐레이션 api 호출용
        		cpt : "c001",
        		viewType : 'HorzPop', // 가로형
        		styleNo : 26, // 템플릿 번호
        		popupYn : "Y",
        		titlRp : smlDispName, // 타이틀 replace 텍스트
        		viewArea : 'goods_curation_pop_' + recType,
        		recType : recType, // 큐레이션 url 정보
        		iids : lgcGoodsNo,
        		goodsNo : goodsNo,
        		cpcids : dispCatNo,
        		rccode : rccode,
                trackingCd : "Common_Recent_Curation_More"
            };

        	// 더보기 버튼에 아이디를 상품단위로 주기위해서 사용
        	$("#recobell_area_"+goodsNo+" .moreBtn").attr("id", "crt_more_"+goodsNo);

        	$("#recobell_area_" + goodsNo).find(".btnbag").each(function() {
        		$(this).attr("data-rccode", rccode);
        	});


        	// 기존 영역이기 때문에 이벤트 추가만 한다.
        	//curation.btnMoreEvent(revobellParam);
        	// 기본 more이벤트 공통을 사용하기에는 아이디 값을 같이 사용할 수 없기 때문에 완료후에 이벤트바인딩함
        	// [START]더보기 이벤트 바인딩
        	$("#crt_more_"+goodsNo).unbind("click").click(function(event) {
    			event.preventDefault();

    			//[curation.js 더보기 버튼이벤트 바인딩에서 필요한 제어 추가]
    			try {
    				if(localStorage.getItem("curationPopLoad") == "Y") {
    					return;
    				}

    				localStorage.setItem("curationPopLoad", "Y");

    				if(!common.isLogin()) {
    					var redirectUrl = document.location.href;

    					localStorage.setItem("loginRedirect", redirectUrl);
    					localStorage.setItem("curationPopInfo", JSON.stringify(revobellParam));
    				}

    				if(revobellParam.goodsNos != undefined && revobellParam.goodsNos != "") {
    					var requestUrl = _baseUrl + "curation/getLgcGoodsNoListAjax.do"
    					common.Ajax.sendRequest("POST", requestUrl, {goodsNos : revobellParam.goodsNos}, function(res) {
    						revobellParam.iids = res.data;
    						curation.popLoadEvent(revobellParam);
    					});
    				} else {
    					curation.popLoadEvent(revobellParam);
    				}
    			} catch(e) {
    				localStorage.removeItem("curationPopLoad");
    			}
    		});
        	// [END]더보기 이벤트 바인딩
        };

        common.Ajax.sendRequest("POST",url,param,_callBackGetRecoBellContsInfo);

    }
};

/*--------------------------------------------------------------------------------*\
 * 찜 클릭 공통
 \*--------------------------------------------------------------------------------*/
$.namespace("common.wish");
common.wish = {

    init : function() {
        // 체크 처리.
        common.wish.checkWishList();
    },

    bindEvent : function() {

        $('.jeem').unbind("click");

        // 찜 클릭 이벤트
        $('.jeem').bind('click', function() {
            if ($(this).attr("data-rccode") == 'mc_detail_soldout_ac') {
                common.wlog('goods_soldout_popup_prod_like');
            }
            if ($(this).attr("data-rccode") == 'mc_detail_cart_a') {
                common.wlog('goods_cart_curation_popup_prod_like');
            }

            newGoods.event.bindButtonWebLog($(this),'like');

            // 로그인 체크
            // if(common.loginChk()){
            var param = {
                goodsNo : $(this).attr("data-ref-goodsNo")
            };

            if ($(this).hasClass("mClick")) {
                // off
            	if($(this)[0].tagName == "BUTTON"){
            		$(this).text("찜하기전");
            	}
                common.wish.delWishLst(param, $(this));
            } else {
                // on
            	if($(this)[0].tagName == "BUTTON"){
            		$(this).text("찜하기후");
            	}
                common.wish.regWishLst(param, $(this));
            }


            // }
        });

        //브랜드 좋아요 클릭
        $('.brand_like > a').unbind("click");

        //브랜드 좋아요 클릭 이벤트
        $('.brand_like > a').bind('click', function(event){
        	event.preventDefault();
            //로그인 체크
//            if(common.loginChk()){
                var param = {
                		onlBrndCd : $(this).attr("data-ref-onlBrndCd")
                };

                if($(this).hasClass("on")){
                    common.wish.delBrndWishLst(param, $(this));
                }else{
                    common.wish.regBrndWishLst(param, $(this));
                }
//            }
        });

    },

    loadData : function() {
        // 로그인 여부에 따라 찜목록 저장.
        if (common.isLogin()) {
            var wishListJson = sessionStorage.getItem("wishList");

            // 없으면 조회
            if (wishListJson == null || wishListJson.trim() == "") {

                common.wish.isLoading = false;

                // 저장된 화면이 없을 경우 html 조회
                $.ajax({
                    type : "POST",
                    url : _baseUrl + "mypage/getWishListJson.do",
                    data : null,
                    dataType : 'text',
                    async : false,
                    cache : false,
                    success : function(data) {

                        try {
                            var jsonObject = $.parseJSON(data);
                            sessionStorage.setItem("wishList", data);

                        } catch (e) {
                        }

                        common.wish.isLoading = true;
                    },
                    error : function() {
                        common.wish.isLoading = true;
                    }
                });
            }

        } else {
            // 제거
            sessionStorage.removeItem("wishList");
        }
    },


    loadBrndData : function(brndCds) {
    	var data = {};
    	data.onlBrndCdList = brndCds;
    	jQuery.ajaxSettings.traditional = true;
        // 로그인 여부에 따라 찜목록 저장.
        if(brndCds){
        	$.ajax({
        		type : "POST",
        		url : _baseUrl + "mypage/getBrndWishListJson.do",
        		data : data,
        		dataType : 'json',
        		async : false,
        		cache : false,
        		success : function(data) {
        			try {
        				var brndsList = data;
        				for (var i = 0; i < brndsList.length; i++) {
        					var brndJJimEle = $(".brand_like.searchpage a[data-ref-onlBrndCd='" + brndsList[i].onlBrndCd + "']");
        					if (brndJJimEle.length > 0) {
        						if (brndsList[i].likeYn == 'Y') {
        							brndJJimEle.addClass("on");
        						}
        						if (brndsList[i].likeCnt == 0) {
        							brndJJimEle.find(".icon").html("브랜드의 상품 안내 및 추천을 받으실 수 있습니다.");
        						} else {
                                    var paticle = common.checkTxtParticle($(".brand_like a").attr("data-ref-onlBrndNm"), "을", "를");
        							brndJJimEle.find(".icon").html("<span class='fw400'>"+(brndsList[i].likeCnt).numberFormat()+"</span>명이 "+$(".brand_like a").attr("data-ref-onlBrndNm") + paticle + " 좋아합니다.");
        						}
        					}
        				}
        			}catch (e) {
        			}

        		}
        	});
        }


    },

    checkWishList : function() {

        common.wish.bindEvent();

        setTimeout(function() {
            // 정보 조회
            common.wish.loadData();

            var wishListJson = sessionStorage.getItem("wishList");

            $('.jeem').removeClass("mClick");
            $('.jeem').text("찜하기전");
            $(".like.new").removeClass("active");

            if (wishListJson != null && wishListJson.trim() != "") {
                try {
                    var jsonObject = $.parseJSON(wishListJson);

                    var goodsList = jsonObject.goodsList;

                    for (var i = 0; i < goodsList.length; i++) {
                        $(".jeem[data-ref-goodsNo='" + goodsList[i] + "']").addClass("mClick");
                        $(".jeem[data-ref-goodsNo='" + goodsList[i] + "']").text("찜하기후");
                        $(".like.new[data-ref-goodsNo='" + goodsList[i] + "']").addClass("active");
                    }
                } catch (e) {
                }
            }

        }, 100);
    },

    regWishLst : function(param, obj) {
        if (param.goodsNo == undefined || param.goodsNo == "") {
            alert("등록이 실패하였습니다.\n상품정보가 없습니다.");
            return;
        }

        var callBackResult = "";

        common.Ajax.sendRequest("POST", _baseUrl + "mypage/regWishLstAjax.do", param, function(res) {
            callBackResult = res;
            common.wish.regWishLstAjaxCallback(res.message, obj);

            try {
            	var lgcGoodsNo = res.data.lgcGoodsNo;
            	if(lgcGoodsNo != undefined && lgcGoodsNo != null && lgcGoodsNo != "") {
            		common.sendRecobell(lgcGoodsNo, 'like');
            	}
            } catch(e) {

            }
        }, false);

        // 좋아요 등록시 펑선 호출 (상품상세 좋아요, 추천영역 좋아요)
        common.header.goodsStackScreen('reloadPreviousGoodsDetailScreen');
        return callBackResult;
    },

    regWishLstAjaxCallback : function(res, obj) {

        setTimeout(function() {
            // 목록 갱신을 위해 제거
            sessionStorage.removeItem("wishList");
            common.wish.checkWishList();
        }, 100);

        var result = res.trim();
        if (result != '000') {
            if (result == '100' && !common.loginChk()) {
                return;
            }

            if (result == '500') {
                common.wish.showFailMessage('좋아요 상품은 200개까지 담을 수 있어요');
                return;
            }

            return;
        }

        if (obj != undefined) {
            obj.addClass("mClick");
        }
        // 찜 알림레이어 On
        $(".layerAlim").removeClass("Basket");
        $(".layerAlim").removeClass("zzimOff");
        $(".layerAlim").removeClass("zzimOn");
        $(".layerAlim").removeClass("brand");

        $(".layerAlim").addClass("zzimOn").show();
        // $(".layerAlim > p").addClass("one");
        $(".layerAlim > p").html("");
        // $(".layerAlim").fadeIn(500);

        // setTimeout(function() {
        //     $(".layerAlim").fadeOut(800);
        // }, 1200);

        // var timer = setInterval(function() {
        //     console.log('asdf')
        // }, 207)

        setTimeout(function(){
            // clearInterval(timer);
            $(".layerAlim").removeClass("zzimOn").hide();
        }, 1070);
    },

    showFailMessage : function(message){
        if ($('.toast').length) {
            return;
        }
        var className = $('.footerTab .noti_service').length ? 'toast live' : 'toast';
        $("body").append("<div class='" + className + "'><p>"+message+"</p></div>");

        setTimeout(function(){
            $(".toast").remove();
        }, 2800);
    },

    delWishLst : function(param, obj) {
        if (param.goodsNo == undefined || param.goodsNo == "") {
            alert("삭제가 실패하였습니다.\n상품정보가 없습니다.");
            return;
        }

        var callBackResult = "";

        common.Ajax.sendRequest("POST", _baseUrl + "mypage/delWishLstAjax.do", param, function(res) {
            callBackResult = res;
            common.wish.delWishLstAjaxCallback(res, obj)
        }, false);

        // 좋아요 삭제시 펑선 호출 (상품상세 좋아요, 추천영역 좋아요)
        common.header.goodsStackScreen('reloadPreviousGoodsDetailScreen');
        return callBackResult;
    },

	//[3392125] MC '좋아요(상품)' 전체삭제 기능 오류 수정 요청의 건 param 재정의
    delWishLstAjaxCallback : function(res, obj, param) {
        // 목록 갱신을 위해 제거
        sessionStorage.removeItem("wishList");
        common.wish.checkWishList();

        var result = res.trim();
        if (result != '000') {
            if (result == '100') {
                // 로그인 실패
                if (!common.loginChk()) {
                    return;
                }
            }
        }

        if (obj != undefined) {
            obj.removeClass("mClick");
        }
        // 찜 알림레이어 Off
        // $(".layerAlim").removeClass("Basket");
        // $(".layerAlim").removeClass("zzimOff");
        // $(".layerAlim").removeClass("zzimOn");
        // $(".layerAlim").removeClass("brand");

        //$(".layerAlim").addClass("zzimOff");
        //$(".layerAlim > p").addClass("one");
        //$(".layerAlim > p").html("<strong>좋아요</strong>");

        //param.gubun은 좋아요 전체 삭제시에만 들어옴
        if(param == undefined || param == null ){
        	//개별삭제만 좋아요 해제 딱지 띄움
        	// $(".layerAlim").fadeIn(500);

            // setTimeout(function() {
            //     $(".layerAlim").fadeOut(800);
            // }, 1200);
        }else if(param.gubun == "delAllWishLst"){
        	//param이 있을때 전체삭제는 좋아요 해제 딱지 띄우지 않고 fadeIn,Out 제거
        }

        // setTimeout(function(){
        // $(".layerAlim").removeClass("zzimOff");
        // }, 2000);
    },

    regBrndWishLst : function(param, obj){
        if (param.onlBrndCd == undefined || param.onlBrndCd == "" ) {
            alert("등록이 실패하였습니다.\n브랜드정보가 없습니다.");
            return;
        }

        var callBackResult = "";

        common.Ajax.sendRequest(
                  "POST"
                , _baseUrl + "mypage/regBrndWishLstAjax.do"
                , param
                , function(res) {
                    callBackResult = res;
                    common.wish.regBrndWishLstAjaxCallback(res, obj, param);

                    if(res.resultCd == '000') {
                    	try {
                    		common.wish.sendBrdLikeRecobell(param.onlBrndCd);
                    	} catch(e) {
                    	}
                    }
                }
                , false
        );

        return callBackResult;
    },
    regBrndWishLstAjaxCallback : function(res, obj, param){

        var result = res.resultCd;
        if (result != '000') {
            if (result == '100') {
                //로그인 실패
                if (!common.loginChk()) {
                    return;
                }
            }else if (result == '600') {
                //이미 찜
                //alert("이미 찜한 상품입니다.");
                alert("이미 좋아요에 저장된 브랜드입니다.");
                return;
            }
        }

        if (obj != undefined) {
            if (obj.parent().hasClass('brand_like')) {
                obj.addClass("on");
            }

            var brndcd = $(".swiper-slide-active .brand_like a").attr("data-ref-onlBrndCd");
            if($(".swiper-slide-active .a_brnd").filter("[data-brndcd="+brndcd+"]").length > 0) {
            	$(".swiper-slide-active .a_brnd").filter("[data-brndcd="+brndcd+"]").attr("data-usrlikeyn", "Y");
            	$(".swiper-slide-active .a_brnd").filter("[data-brndcd="+brndcd+"]").attr("data-likecnt", res.brndCnt);
            }
        }

        var paticle = common.checkTxtParticle($(".brand_like a").attr("data-ref-onlBrndNm"), "을", "를");

        if(res.brndCnt > 0){
			$(".brand_like span.icon").not("#brnd_prd").html("<span class='fw400' id='brndCnt'>"+(res.brndCnt).numberFormat()+"</span>명이 <span class='bdName'>"+$(".brand_like a").attr("data-ref-onlBrndNm")+"</span><span id='span_ptc'>"+paticle+"</span> 좋아합니다.");
		}else{
			$(".brand_like span.icon").not("#brnd_prd").html("브랜드의 상품 안내 및 추천을 받으실 수 있습니다.");
		}


        // 찜 알림레이어 On
        if(param.layerYn != 'N'){
            common.setBrandZzimOn('on');
        	// $(".layerAlim").removeClass("Basket");
        	// $(".layerAlim").removeClass("zzimOff");
        	// $(".layerAlim").removeClass("zzimOn");
        	// $(".layerAlim").removeClass("brand");
        	//
        	// $(".layerAlim").addClass("brand");
        	// $(".layerAlim").addClass("zzimOn");
        	// $(".layerAlim > p").html("브랜드<strong>좋아요</strong>");
        	// $(".layerAlim").fadeIn(500);
        	//
        	// setTimeout(function() {
        	// 	$(".layerAlim").fadeOut(800);
        	// }, 1200);
        }
    },

    delBrndWishLst : function(param, obj){
        if (param.onlBrndCd == undefined || param.onlBrndCd == "" ) {
            alert("삭제가 실패하였습니다.\n브랜드정보가 없습니다.");
            return;
        }
        var callBackResult = "";

        common.Ajax.sendRequest(
                "POST"
              , _baseUrl + "mypage/delBrndWishLstAjax.do"
              , param
              , function(res) {
                  callBackResult = res;
                  common.wish.delBrndWishLstAjaxCallback(res, obj, param);
              }
              , false
        );

        return callBackResult;

    },

    delBrndWishLstAjaxCallback : function(res, obj, param){
        //목록 갱신을 위해 제거
//        common.wish.checkWishList();

        var result = res.resultCd;
        if (result != '000') {
            if (result == '100') {
                //로그인 실패
                if (!common.loginChk()) {
                    return ;
                }
            }
        }

        if (obj != undefined) {
            if (obj.parent().hasClass('brand_like')) {
                obj.removeClass("on");
            }

            var brndcd = $(".swiper-slide-active .brand_like a").attr("data-ref-onlBrndCd");
            if($(".swiper-slide-active .a_brnd").filter("[data-brndcd="+brndcd+"]").length > 0) {
            	$(".swiper-slide-active .a_brnd").filter("[data-brndcd="+brndcd+"]").attr("data-usrlikeyn", "N");
            	$(".swiper-slide-active .a_brnd").filter("[data-brndcd="+brndcd+"]").attr("data-likecnt", res.brndCnt);
            }
        }

        var paticle = common.checkTxtParticle($(".brand_like a").attr("data-ref-onlBrndNm"), "을", "를");

        if(res.brndCnt > 0){
        	$(".brand_like span.icon").not("#brnd_prd").html("<span class='fw400' id='brndCnt'>"+(res.brndCnt).numberFormat()+"</span>명이 <span class='bdName'>"+$(".brand_like a").attr("data-ref-onlBrndNm")+"</span><span id='span_ptc'>"+paticle+"</span> 좋아합니다.");
		}else{
			$(".brand_like span.icon").not("#brnd_prd").html("브랜드의 상품 안내 및 추천을 받으실 수 있습니다.");
		}

     // 찜 알림레이어 Off
        if(param !== undefined && param !== null && param.layerYn != 'N'){
            common.setBrandZzimOn('off');
        	// $(".layerAlim").removeClass("Basket");
        	// $(".layerAlim").removeClass("zzimOff");
        	// $(".layerAlim").removeClass("zzimOn");
        	// $(".layerAlim").removeClass("brand");
        	//
        	// $(".layerAlim").addClass("brand");
        	// $(".layerAlim").addClass("zzimOff");
        	// $(".layerAlim > p").html("브랜드<strong>좋아요</strong>");
        	// $(".layerAlim").fadeIn(500);
        	//
        	// setTimeout(function() {
        	// 	$(".layerAlim").fadeOut(800);
        	// }, 1200);
        }

    },

    delAllBrndWishLst : function(param){
        common.Ajax.sendRequest(
                "POST"
              , _baseUrl + "mypage/delBrndWishLstAjax.do"
              , param
              , common.wish.delBrndWishLstAjaxCallback
        );
    },

    delAllWishLst : function(param) {
    	//[3392125] MC '좋아요(상품)' 전체삭제 기능 오류 수정 요청의 건 param 재정의
    	var param = {	gubun : "delAllWishLst"	};
    	var obj = undefined;
    	var callBackResult = "";

    	common.Ajax.sendRequest(
    				"POST"
    			 , _baseUrl + "mypage/delWishLstAjax.do"
    			 , param
    			 , function(res) {
    				 callBackResult = res;
    				 common.wish.delWishLstAjaxCallback(res, obj, param)
    			 }
    			 , false
    	);

    	return callBackResult;
    },
    sendBrdLikeRecobell : function(brand_id) {
	    var src = (('https:'==document.location.protocol)?'https':'http')+'://logger.ai.oliveyoung.co.kr/js/logger.min.js';
	    var scriptLen = $("script").filter("[src='"+src+"']").length;

	    if(scriptLen == 0) {
	    	(function(s,x){s=document.createElement('script');s.type='text/javascript';
		    s.async=true;s.defer=true;s.src=(('https:'==document.location.protocol)?'https':'http')+
		    '://logger.ai.oliveyoung.co.kr/js/logger.min.js';
		    x=document.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);})();
	    }

	    eglc.op('setVar', 'cuid', recoCuid);
	    eglc.op('setVar', 'brandId', brand_id);
	    eglc.op('setVar', 'userId', hashedRecoSsoMbrNo);
	    eglc.op('track', 'like');
    }
};

$.namespace("common.coupon");
common.coupon = {
    regCpnNo:'',
    /**
     * **** 쿠폰 등록 레이어 팝업 *****
     *
     * 팝업 호출 및 쿠폰 등록
     *
     * getRegCouponForm : arg = true 이면 화면 갱신 arg 없으면 화면 갱신하지 않음
     */
    reload : false,
    getRegCouponForm : function(reload) {
        if (typeof reload != "undefined") {
            if (reload) {
                common.coupon.reload = true;
            }
        } else {
            common.coupon.reload = false;
        }
        common.Ajax.sendRequest("POST", _baseUrl + "common/popup/getRegCouponFormPop.do", null, function(res) {
            $("#pop-full-contents").html(res);
            localStorage.setItem('lyScrollSet',$(document).scrollTop());
            common.popFullOpen("쿠폰 등록");
        });
    },
    regCouponAjax : function() {
        if (!common.isLogin() && confirm("로그인 후 신청하실 수 있습니다.\r\n로그인 페이지로 이동하시겠습니까?")) {
            common.link.moveLoginPage("", location.href);
        } else {
            var rndmVal = $("#rndmVal").val();

            if (rndmVal.length <= 0) {
                alert("쿠폰번호를 입력해주세요.");
                return false;
            }
            common.Ajax.sendRequest("POST", _baseUrl + "common/regCouponJson.do", {
                rndmVal : rndmVal
            }, common.coupon.regCouponAjaxCallback);
            common.coupon.regCpnNo = rndmVal;
        }
    },
    regCouponAjaxCallback : function(res) {
        if (typeof res != "undefined") {
            if (res == '000') {
                callLogEvent('쿠폰 등록 완료',getParameterFromObject({
                    't_page':'쿠폰등록',
                    't_click':'등록하기',
                    't_coupon_number':common.coupon.regCpnNo
                }));
                alert("쿠폰이 등록되었습니다. 등록된 쿠폰은 'MY>쿠폰'에서 확인 가능합니다.");

                if (common.coupon.reload) {
                    document.location.reload();
                } else {
                    common.popFullClose();
                }
            } else {
                alert(res);
            }
        }
    }
};

$.namespace("common.zipcode.pop");
common.zipcode.pop = {
    daumApiYn : 'Y', //DAUM 주소팝업 사용여부 Y:사용, Y가 아닌경우 구 주소팝업 호출

    fnCallback : '',

    defaultId : "search-zipcode-pop",

    init : function(popCallback, id) {
        common.zipcode.pop.fnCallback = popCallback;

        if (arguments.length == 1 || !id) {
            id = common.zipcode.pop.defaultId;
        }
        if(common.zipcode.pop.daumApiYn == 'Y'){
            $('#' + id).click(function() {
                common.setScrollPos2();// 클릭 시, 스크롤 위치값 localstorage 저장
                $('#pop-full-contents').html('');
                $('#pop-full-contents').load(_baseUrl + 'common/popup/searchZipcodePopApi.do', function() {
                    common.popFullOpen('우편번호 찾기');
                    mcommon.popup.zipcodeApi.init(common.zipcode.pop.fnCallback);
                });
            });
        } else {
            $('#' + id).click(function() {
                common.setScrollPos2();// 클릭 시, 스크롤 위치값 localstorage 저장
                $('#pop-full-contents').html('');

                $('#pop-full-contents').load(_baseUrl + 'common/popup/searchZipcodePop.do', function() {

                    common.popFullOpen('우편번호 찾기');

                    mcommon.popup.zipcode.init(common.zipcode.pop.fnCallback);
                });
            });
        }

    }
};

$.namespace("common.zipcodequick.pop");
common.zipcodequick.pop = {
    fnCallback : '',

    defaultId : "search-zipcode-pop",

    init : function(popCallback, id) {
        common.zipcodequick.pop.fnCallback = popCallback;
        common.zipcodequick.pop.quickYn = 'Y'; // 당인배송에서 호출하는 경우 추가

        if (arguments.length == 1 || !id) {
            id = common.zipcodequick.pop.defaultId;
        }

        if(common.zipcode.pop.daumApiYn == 'Y'){
            $('#' + id).click(
                function() {

                common.setScrollPos();
                $('#searchZipcode').find('#LAYERPOP01-contents-quick').html('');
                $('#searchZipcode').find('#LAYERPOP01-title').html('우편번호 찾기');

                $('#searchZipcode').find('#LAYERPOP01-contents-quick').load(
                        _baseUrl + 'common/popup/searchZipcodePopApi.do?popYn=N', function() {
                            common.setScrollPos();
                            common.popLayerOpenFullScreen("searchZipcode");

                            // 다음 주소찾기 스크립트에서는 해당Div의 css를 height: 100vh 로 설정합니다.
                            // 여기서는 우편번호 찾기라는 제목공간을 따로 추가하여 불필요한 스크롤이 생기므로 해당 높이 설정을 다른설정으로 덮어씌움니다.
                            $('#searchZipcode').find('#LAYERPOP01-contents-quick').css({
                                height: "100%"
                            });
                            mcommon.popup.zipcodeApi.init(common.zipcodequick.pop.fnCallback);
                        });
                });
        } else {
            $('#' + id).click(
                function() {

                common.setScrollPos();
                $('#searchZipcode').find('#LAYERPOP01-contents-quick').html('');
                $('#searchZipcode').find('#LAYERPOP01-title').html('우편번호 찾기');

                $('#searchZipcode').find('#LAYERPOP01-contents-quick').load(
                        _baseUrl + 'common/popup/searchZipcodePop.do', function() {
                            common.setScrollPos();
                            common.popLayerOpenFullScreen("searchZipcode");

                            mcommon.popup.zipcode.init(common.zipcodequick.pop.fnCallback);
                        });
                });
        }


    },

    /** 배송지 등록 폼 * */
    deliveryRegistForm : function() {
        var url = _baseUrl + "goods/getDeliveryRegistFormAjax.do";
        var data = {};
        common.Ajax.sendRequest("POST", url, data, common.zipcodequick.pop._callBackDeliveryRegistForm);
    },

    /** 배송지 등록(장바구니) 폼 * */
    deliveryRegistCartForm : function() {
        common.zipcodequick.pop.cartYn = 'Y';
        var url = _baseUrl + "cart/getDeliveryRegistFormCartAjax.do";
        var data = {};
        common.Ajax.sendRequest("POST", url, data, common.zipcodequick.pop._callBackDeliveryRegistForm);
    },

    /** 배송지 등록 폼 콜백 * */
    _callBackDeliveryRegistForm : function(res) {
        common.setScrollPos();
        var cDiv = $(res.trim());
        $("#pop-full-wrap").html(cDiv);
        $('#rmitCellSctNo').css({
            'width' : '30.6%'
        });
        $('#rmitTelRgnNo').css({
            'width' : '30.6%'
        });

        common.popFullOpen("배송지 추가");
        common.zipcodequick.pop.init(mmypage.deliveryForm.selectedZipcodeCallback);
    },

    /** 배송지 등록 닫기 * */
    deliveryRegistFormClose : function() {
        common.popFullClose();
        common.zipcodequick.pop.quickYn = '';

        mgoods.detail.todayDelivery.todayDeliveryList();
    },

    /** 배송지 등록 후 닫기 * */
    deliveryRegistFormAfterClose : function() {
        common.popFullClose();
        common.zipcodequick.pop.quickYn = '';

        // 2020.12.09 상품값이 있을 경우에만 조회하도록 한다. (crt.허민)
        if(typeof mgoods != 'undefined') {
            mgoods.detail.todayDelivery.registTodayDeliverySelect();
        }
    },

    /** 배송지 등록 닫기 * */
    deliveryRegistFormCartClose : function() {
        common.popFullClose();
        common.zipcodequick.pop.quickYn = '';
        common.zipcodequick.pop.cartYn = '';
        window.location.reload();
        // mgoods.detail.todayDelivery.todayDeliveryList();
    }

};

$.namespace("common.bann");
common.bann = {

    getPopInfo : function(popType) {
        // var cookie = new Cookie('local', 1, 'D');
        var cookie = new Cookie(1);

        if (cookie.get('popBannHistory') != undefined && cookie.get('popBannHistory') != "") {
            var popBannHistoryStr = cookie.get('popBannHistory');
            var jsonStr = JSON.parse(popBannHistoryStr);

            for (var i = 0; i < jsonStr.length; i++) {
                if (jsonStr[i].popType == popType) {
                    return jsonStr[i];
                }
            }
        }
        return null;
    },

    setPopInfo : function(popType, compareKey) {
        // var cookie = new Cookie('local', 1, 'D');
        var cookie = new Cookie(1);
        var bannArr = new Array();

        if (cookie.get('popBannHistory') != undefined && cookie.get('popBannHistory') != "") {
            var popBannHistoryStr = cookie.get('popBannHistory');

            // 신규
            if (popBannHistoryStr == "") {
                var bannInfo = new Object();

                bannInfo.popType = popType;
                bannInfo.compareKey = compareKey;
                bannInfo.regDtime = new Date();

                bannArr.push(bannInfo);

            } else {
                var jsonStr = JSON.parse(popBannHistoryStr);

                var hasInfo = false;

                for (var i = 0; i < jsonStr.length; i++) {
                    if (jsonStr[i].popType == popType) {
                        jsonStr[i].compareKey = compareKey;
                        jsonStr[i].regDtime = new Date();
                        hasInfo = true;
                    }

                    bannArr.push(jsonStr[i]);
                }

                if (!hasInfo) {
                    var bannInfo = new Object();

                    bannInfo.popType = popType;
                    bannInfo.compareKey = compareKey;
                    bannInfo.regDtime = new Date();

                    bannArr.push(bannInfo);

                }
            }

        } else {
            var bannInfo = new Object();

            bannInfo.popType = popType;
            bannInfo.compareKey = compareKey;
            bannInfo.regDtime = new Date();

            bannArr.push(bannInfo);
        }
        cookie.set('popBannHistory', JSON.stringify(bannArr));
    },
}

$.namespace("common.push");
common.push = {
    // TMS 앱푸시수신동의값 변경 송신
    sendTmsPush : function(push){
        var url = _secureUrl + 'customer/getUserSsoMbrNo.do';
        var data = {"push" : push};

        common.Ajax.sendRequest("POST",url,data,common.push._callbackSendTmsPush);
    },
    // TMS 앱푸시수신동의값 변경 송신 콜백
    _callbackSendTmsPush : function(res){
        $.ajax({
            type: "POST" ,
            url: _tmsPushUrl,
            dataType : "json",
            data: res,
            contentType: "application/json",
            error: function (request, status, error) {
//              console.log(error);
            }, success: function (res) {
//              console.log(res);
            }
        });

        return false;
    },
    // 푸시 수신 미동의상태의 회원에게는 앱푸시수신동의 팝업을 노출한다.
    pushMsgAgrPopupOpen : function() {
        var param = {pageNm : "appPushRcvAgrPop"};

        common.Ajax.sendRequest("POST"
                                ,_baseUrl + "store/getPushMsgAgrPop.do"
                                ,param
                                ,common.push._callbackPushMsgAgrPopupOpen
                               );
    },
    // 앱푸시수신동의팝업 노출 콜백
    _callbackPushMsgAgrPopupOpen : function(data){
        $("#pushMsgRcvAgrPop").empty();
        $("#pushMsgRcvAgrPop").html(data);

        if($('#popPushMsgRcvYn').val() == 'N'){
            $("#pushMsgRcvAgrPop").show();
            var popLayer = $("#pushMsgRcvAgrPop");
            var popPos = $(popLayer).height()/2;
            var popWid = $(popLayer).width()/2;
            $(popLayer).css({'left':'50%' , 'margin-left':-(popWid) , 'top':'50%' , 'margin-top':-(popPos)}).show();
            $('.dim').show();
        }
//        $("#footerTab").hide();
    },
    // 앱푸시수신동의팝업 생성(메인 하단 매장상세-앱에서 새창으로 열고 있는 경우 footer 영역이 없으므로 따로 생성해줘야함)
    appendAppPushDiv : function(){
        if(common.app.appInfo.isapp){
            var appPushDivTemp = "<div class='popLayerWrap' id='pushMsgRcvAgrPop'></div>"
                +"<input type='hidden' id='popSvcEvtAgrYn' name='popSvcEvtAgrYn' value=''/>"
                +"<input type='hidden' id='popPushMsgRcvYn' name='popPushMsgRcvYn' value=''/>";
            $("#pushMsgRcvAgrPop").empty();
            $("body").append(appPushDivTemp);
        }
    }
}

/*
 * 행사사은품선택팝업띄우기
 */
$.namespace('common.popLayer.promGift');
common.popLayer.promGift = {
    jsonParam : false,

    openPromGiftPop : function(vGoodsNo, vItemNo, vPromNo) {
        var url = _baseUrl + "cart/promGiftPopAjax.do";

        var callback = function(res) {
            $("#layerPop").html(res);
            common.popLayerOpen("LAYERPOP01");

            // mcart.base.setLazyLoad('seq');
            var popPos = $('#LAYERPOP01').height() / 2;
            $('#LAYERPOP01').css('margin-top', -(popPos));

            // cart/freeGiftPopAjax.jsp 의 '닫기'버튼 클릭 이벤트에 'CARTLAYER'로 되어있어 팝업창이 닫히지 않는 현상 해결하기 위해 선언.
            $('#LAYERPOP01').find(".btnGreen").off("click");
            $('#LAYERPOP01').find(".btnGreen").on("click", function(){
            	common.popLayerClose('LAYERPOP01');
            });

            // GET레이어의 상품 수가 1인경우 자동실행
            if ($('li[name=selPopInfo]').length == 1) {
                var stockQty = parseInt($('li[name=selPopInfo]').eq(0).attr('stockQty'));

                if (stockQty > 0) {
                    var setItemCnt = 0;
                    if (stockQty > getItemCnt)
                        setItemCnt = getItemCnt;
                    else
                        setItemCnt = stockQty;

                    $('li[name=selPopInfo]').eq(0).find('input[name=promGiftAmount]').val(setItemCnt);
                    $('li[name=selPopInfo]').eq(0).attr("class", "on");

                    // 기 선택한 추가상품 수량
                    $("p.choiceTxt span i").text(setItemCnt);
                }
            } else {
                // buy상품군의 수량정보를 가져와 품절체크추가
                // 레이어창의 상품군
                var totalCnt = 0;
                $('li[name=selPopInfo]').each(function() {
                    var layerPopObj = $(this);

                    // $("div.prd_item_box").each(function(){
                    $("p.item_number").each(function() {
                        var buyObj = $(this);
                        var buyGoodsNo = buyObj.find("input[name=sGoodsNo]").val();
                        var buyItemNo = buyObj.find("input[name=itemNo]").val();

                        buyGoodsNo = (buyGoodsNo == undefined) ? $("#goodsNo").val() : buyGoodsNo;
                        buyItemNo = (buyItemNo == undefined) ? $("#itemNo").val() : buyItemNo;

                        // buy상품군의 상품정보와 레이어창의 상품정보가 같으면
                        if (layerPopObj.attr('goodsNo') == buyGoodsNo && layerPopObj.attr('itemNo') == buyItemNo) {
                            var buyGoodsCnt = parseInt(buyObj.find('input[type=tel].num').val());
                            var getGoodsCnt = parseInt(layerPopObj.attr('stockQty'));

                            // 상품상세에서 오늘드림 여부가 선택된 경우 오늘드림 재고를 보고 판단해야함 jwkim -> 오늘 드림 재고 stockQty에 담겨져 옴 2020.12.21 주석처리
                            /*if ($("#deliveDay").prop("checked") == true) {
                                getGoodsCnt = $("#quickAvalInvQty").val();
                            }*/

                            // buy상품군의 수량이 실재고 수량보다 크거나 같으면
                            if (buyGoodsCnt >= getGoodsCnt) {
                                // 조건만족시 수량0으로 셋팅하고 품절처리
                                layerPopObj.find('input[name=promGiftAmount]').val(0);
                                layerPopObj.attr('class', 'soldout');
                                layerPopObj.find('div.img').append("<span>일시품절</span>");
                                layerPopObj.find('input[name=promGiftAmount]').attr('disabled', 'disabled');
                                layerPopObj.find('input[name=promGiftAmount]').siblings().attr('disabled', 'disabled');
                                layerPopObj.removeClass("on");
                            } else {
                                layerPopObj.attr('stockQty', getGoodsCnt - buyGoodsCnt);
                            }
                        }
                    });

                    totalCnt += parseInt(layerPopObj.find("input[name=promGiftAmount]").val());
                });

                // 현재 선택된 수량 갱신
                $("p.choiceTxt span i").text(totalCnt); // 기 선택한 추가상품 수량

                // 일시품절 상품 하단 정렬 시작
                var getItemList = [];
                var getItemSoldOutList = [];

                $("ul.listPlusPrd li[name=selPopInfo]").each(function() {
                    if ($(this).hasClass("soldout")) {
                        getItemSoldOutList.push($(this));
                    } else {
                        getItemList.push($(this));
                    }
                });

                $("ul.listPlusPrd").html();

                $(getItemList).each(function() {
                    $("ul.listPlusPrd").append($(this));
                });

                $(getItemSoldOutList).each(function() {
                    $("ul.listPlusPrd").append($(this));
                });
                // 일시품절 상품 하단 정렬 끝
            }
        };

        var isValid = this.validation(vGoodsNo, vItemNo, vPromNo);

        if (isValid) {
            _ajax.sendRequest("GET", url, this.jsonParam, callback);
        }
    },
    /**
     * 파라메터의 validation 처리
     */
    validation : function(vGoodsNo, vItemNo, vPromNo) {
        var isValid = true;
        if (vGoodsNo == null || vGoodsNo == '' || vItemNo == null || vItemNo == '' || vPromNo == null || vPromNo == '') {
            var msg = "죄송합니다. 고객센터(1577-4887)로 문의해 주세요.";

            this.jsonParam = false;
            isValid = false;
            return isValid;
        }

        var buyItemCnt = 0;
        $("div.prd_cnt_box[promNo=" + vPromNo + "]").each(function() {
            buyItemCnt += parseInt($(this).find("input.num").val());
        });

        var buyCondStrtQtyAmt = parseInt($("div.event_info.item_" + vGoodsNo + vItemNo).attr("buyCondStrtQtyAmt"));
        var getItemCnt = parseInt(buyItemCnt / buyCondStrtQtyAmt);

        var quickYn = $(":input:radio[name=qDelive]:checked").val();
        var qDeliveYn = $(":input:checkbox[name=qDelive]:checked").val(); //오늘드림 여부 체크 2020.12.03

        if (typeof (quickYn) == "undefined") {
            quickYn = $("#quickYn").val();
        }

        if(typeof(qDeliveYn) == "undefined") {
        	qDeliveYn = "N";
        }

        if (isValid) {
            this.jsonParam = {
                "goodsNo" : vGoodsNo,
                "itemNo" : vItemNo,
                "promNo" : vPromNo,
                "buyItemCnt" : buyItemCnt,
                "getItemCnt" : getItemCnt,
                "quickYn" : quickYn,
                "qDeliveYn" : qDeliveYn
            };
        }
        return isValid;
    },
    /**
     * 추가상품의 수량 조절
     */
    calcQty : function(optionKey, operator) {
        if (mcart.popLayer.promGift.focusOutFlag) {
            mcart.popLayer.promGift.focusOutFlag = false;
            return false;
        }

        var oldVal = parseInt($("input[name=promGiftAmount]#cartCnt_" + optionKey).val());
        $("input[name=promGiftAmount]#cartCnt_" + optionKey).data('old', oldVal);

        if (operator == "plus") {
            if (oldVal >= getItemCnt) {
                alert('선택하실 수 있는 추가 상품은 최대 ' + getItemCnt + '개 입니다.');
                return false;
            }

            $("input[name=promGiftAmount]#cartCnt_" + optionKey).val(++oldVal).trigger("focusout");
        } else if (operator == "minus") {
            if (oldVal <= 0)
                return false;

            $("input[name=promGiftAmount]#cartCnt_" + optionKey).val(--oldVal).trigger("focusout");
        } else {
            return false;
        }
    }
};

/*
 * 3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건
 * 모듈화 작업 진행
 * 표현하고자 하는 화면 내에 DIV "todayDeliveryNotice" 선언 필요.
 */
$.namespace('common.popLayer.todayDelivery');
common.popLayer.todayDelivery = {

    // 특정 시간 대 장바구니, 구매하기에 팝업 설정 (하단의 명절 팝업 노출)
    deliveryStopDate : {
          "startYear" : 2023, "startMonth" : 0, "startDate" : 20, "startHours" : 20, "startMinutes" : 0,
          "endYear" : 2023, "endMonth" : 0, "endDate" : 23, "endHours" : 20, "endMinutes" : 0
    },

	  openTodayDeliveryNotice : function(str, obj) {//팝업 호출 선행 기능

		common.popLayer.todayDelivery.setStrAndObj(str, obj);

		var urlParams = common.cart.urlParams();
		if (!!urlParams.trackingCd) { // trackingCd 저장
		    common.cart.trackingInfo.setTrackingCd(urlParams.trackingCd);
    }

		//IOS RangeError: Invalid Date toISOString 오류로 예외 처리
		try {
        var deliveryStopDate = common.popLayer.todayDelivery.deliveryStopDate;
        var stDateParse = new Date(deliveryStopDate.startYear, deliveryStopDate.startMonth,
            deliveryStopDate.startDate, deliveryStopDate.startHours, deliveryStopDate.startMinutes); //추후 제한 조건을 설정할 부분(날짜)
	    	var endDateParse =  new Date(deliveryStopDate.endYear, deliveryStopDate.endMonth,
            deliveryStopDate.endDate, deliveryStopDate.endHours, deliveryStopDate.endMinutes); //추후 제한 조건을 설정할 부분(날짜)
        var todayParse = new Date();
		} catch(e){

		}

		var quickYn = 'N';
		if (rcvStr == 'goodsdetail.cart' || rcvStr == 'goodsdetail.order') {
        quickYn = $("#qDeliveCheck").val();
        if (quickYn == "" || quickYn === undefined) {
            if ($('input:checkbox[name="qDelive"]').is(":checked") == true) {
                quickYn = 'Y';
            }
        }
		} else {
        quickYn = $("#quickYn").val();
		}

    if (quickYn != 'Y') {//오늘드림이 아닌 경우
    		common.popLayer.todayDelivery.continueAction(); //호출위치에 따른 기능 재게
    } else {
        var html = '';
        var possibleO2oStore = $('.dt_dlvp').attr('id'); // 오늘드림 가능 여부
        	// 시스템 점검 시작
//        	html += '	<!-- popLayerArea -->';
//        	html += '	<div class="popLayerArea">';
//        	html += '		<!-- popInner -->';
//        	html += '		<div class="popInner">';
//        	html += '			<div class="popHeader">';
//        	html += '				<h1 class="popTitle">오늘드림 서비스 안내</h1>';
//        	html += '				<a href="#" class="btnClose" onclick="common.popLayer.todayDelivery.popLayerCloseWithoutSend();">닫기</a>';
//        	html += '			</div>';
//        	html += '			<!-- popContainer -->';
//        	html += '			<div class="popContainer">';
//        	html += '				<!-- popCont 스크롤 영역 -->';
//        	html += '				<div align="center" class="popCont">';
//        	html += '					<p class="infotext_wrap" style="font-size:14px;"><b>시스템 점검으로 인해 오늘드림 서비스 주문이</b></p>';
//        	html += '					<p class="infotext_wrap" style="color:red;font-size:14px;"><b>11시 ~ 15시까지 일시적으로 중단됩니다.</b></p>';
//        	html += '					<p class="infotext_wrap" style="color:grey;font-size:14px;">(15시 이후 부터 주문 가능합니다)</b></p>';
//        	html += '					<div class="btnBigArea twoSet giftNew">';
//        	html += '						<button class="btnLineGreen" onclick="common.popLayer.todayDelivery.openQuickPopToday();">오늘 하루 안보기</button>';
//        	html += '						<button class="btnGreen" onclick="common.popLayer.todayDelivery.popLayerClose();">확인</button>';
//        	html += '					</div>';
//        	html += '				</div>';
//        	html += '			</div>';
//        	html += '			<!-- //popContainer -->';
//        	html += '				<!-- //popCont 스크롤 영역 -->';
//        	html += '					<div class="layer_full_area mgT5" align="left" style="margin: 10px;background-color:f5f5f5;">';
//        	html += '						<ul class="info_dash_list" style="font-size:11px;">';
//        	html += '							<li>주문 확인 시 재고가 부족한 경우, 부득이하게 주문이 취소될 수 있습니다.</li>';
//        	html += '						    <li>배송센터 사정에 따라 부득이하게 주문이 취소될 수 있습니다.</li>';
//        	html += '						</ul>';
//        	html += '					</div>';
//        	html += '		</div>';
//        	html += '		<!-- //popInner -->';
//        	html += '	</div>';
//        	html += '	<!-- //popLayerArea -->';
        	// 시스템 점검 끝

        // 명절 안내 시작
        html += '	<!-- popLayerArea -->';
        html += '	<div class="popLayerArea">';
        html += '		<!-- popInner -->';
        html += '		<div class="popInner">';
        html += '			<div class="popHeader">';
        html += '				<h1 class="popTitle">오늘드림 서비스 안내</h1>';
        if (rcvStr == 'goodsdetail.cart' && possibleO2oStore && possibleO2oStore != 'NM') {
            html += '				<a href="#" class="btnClose" onclick="common.popLayer.todayDelivery.popLayerClose();">닫기</a>';
        } else {
            html += '				<a href="#" class="btnClose" onclick="common.popLayer.todayDelivery.popLayerCloseWithoutSend();">닫기</a>';
        }
        html += '			</div>';
        html += '			<!-- popContainer -->';
        html += '			<div class="popContainer">';
        html += '				<!-- popCont 스크롤 영역 -->';
        html += '				<div align="center" class="popCont">';
        html += '					<p class="infotext_wrap" style="font-size:14px;"><b>배송업체 휴무로 인해 <span style="color:blue;">1/20 20시~1/23 19시 59분까지</span></b></p>';
        html += '					<p class="infotext_wrap" style="font-size:14px;"><b>오늘드림 서비스가 일시 중지됩니다.</b></p>';
        html += '					<p class="infotext_wrap" style="font-size:14px;"><b>* 픽업 주문 포함</b></p>';
        html += '					<p class="infotext_wrap" style="font-size:14px;"><b>기존 주문하신 픽업은 매장에서 수령 가능하니,</b></p>';
        html += '					<p class="infotext_wrap" style="font-size:14px;"><b>방문 전 매장 영업 시간 확인 부탁드립니다.</b></p>';
//        	html += '					<p class="infotext_wrap" style="font-size:14px;"><b>(일부 지역의 경우 주문 불가할 수 있는 점 양해 부탁드립니다)</b></p>';
        html += '					<div class="btnBigArea giftNew">';

        if (rcvStr == 'goodsdetail.cart') {
            if (possibleO2oStore && possibleO2oStore == 'NM' && (todayParse >= stDateParse && todayParse <= endDateParse)) {//게시기간에 해당되는 경우
                html += '						<button class="btnGreen" style="width: 129px !important;" onclick="common.popLayer.todayDelivery.popLayerCloseWithoutSend();">확인</button>';
            } else {
                html += '						<button class="btnGreen" style="width: 129px !important;" onclick="common.popLayer.todayDelivery.popLayerClose();">확인</button>';
            }
        } else {
            html += '						<button class="btnGreen" style="width: 129px !important;" onclick="common.popLayer.todayDelivery.popLayerCloseWithoutSend();">확인</button>';
        }

        html += '					</div>';
        html += '				</div>';
        html += '			</div>';
        html += '			<!-- //popContainer -->';
        html += '		</div>';
        html += '		<!-- //popInner -->';
        html += '	</div>';
        html += '	<!-- //popLayerArea -->';
        // 명절 안내 끝
        $("#todayDeliveryNotice").html(''); //팝업 정보 초기화
        $("#todayDeliveryNotice").html(html); //내용 반영

        if (todayParse >= stDateParse && todayParse <= endDateParse) {//게시기간에 해당되는 경우
            //202109명절 팝업 노출 예외(장바구니 오늘드림 탭 클릭시 as-is : 레이어 노출, to-be : 레이어 미노출) start
            if (quickYn == 'Y' && rcvStr == 'cart.todayTab') {
        			common.popLayer.todayDelivery.continueAction();
        			return;
            }
            //202109명절 팝업 노출 예외(장바구니 오늘드림 탭 클릭시 as-is : 레이어 노출, to-be : 레이어 미노출) end
            var bannInfo = common.bann.getPopInfo("todayDeliveryNotice"); //팝업 차단 등록 시간 확인
            if (bannInfo != null) {
                if (new Date() - bannInfo.regDtime >= (1000 * 60 * 60 * 24)) {
                    common.popLayer.todayDelivery.popLayerOpen();
                    // $("#todayDeliveryNotice").css('z-index', '999');
                    // 	fnLayerSet("todayDeliveryNotice", "open");
                } else {
                    $("#quickInfoYn").val("Y");
                    common.popLayer.todayDelivery.continueAction(); //호출위치에 따른 기능 재게
                    return;
                }
            } else {
                    //  $("#todayDeliveryNotice").css('z-index', '999');
                    //  fnLayerSet("todayDeliveryNotice", "open");
                common.popLayer.todayDelivery.popLayerOpen();
            }
        } else {
            common.popLayer.todayDelivery.continueAction(); //호출위치에 따른 기능 재게
        }
    	}
    },

    setStrAndObj : function(str, obj){
    	rcvStr = str;
    	rcvObj = obj;
    },

    //3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건 - 팝업 오픈(x표 닫기)
    popLayerOpen : function(){

    	common.setScrollPos();
    	$("#layerPop").html($("#todayDeliveryNotice").html());
    	common.popLayerOpen2("LAYERPOP01");

    },
    //3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건 - 서비스 안내 닫기 후 프로세스 호출 없음(x표 닫기)
    popLayerCloseWithoutSend : function(){
		var popLayer = $("#LAYERPOP01");
		$(popLayer).hide().parents('body').css({'overflow-y' : 'auto'});
		$('.dim').hide();

    },
    //3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건 - 서비스 안내 닫기 후 프로세스 호출
    popLayerClose : function(){

		var popLayer = $("#LAYERPOP01");
		$(popLayer).hide().parents('body').css({'overflow-y' : 'auto'});
		$('.dim').hide();

		setTimeout(function(){
			common.popLayer.todayDelivery.continueAction(); //호출위치에 따른 기능 재게
		}, 300);
    },
    //3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건 - 하루동안 보지 않기
    openQuickPopToday : function(){

    	common.bann.setPopInfo("todayDeliveryNotice", $("#todayDeliveryNotice").attr("data-ref-compareKey"));
    	$("#quickInfoYn").val("Y");

		var popLayer = $("#LAYERPOP01");
		$(popLayer).hide().parents('body').css({'overflow-y' : 'auto'});
		$('.dim').hide();

		setTimeout(function(){
			common.popLayer.todayDelivery.continueAction(); //호출위치에 따른 기능 재게
		}, 300);

    },

    /** 주문서 당일 배송지 닫기 * */
    todayDeliveryOrderClose : function(str){
        common.popFullClose();
        $("#quickInfoYn").val("Y");
//        $("button[name=btnPay]").click();
        morder.orderForm.onClickSubmit();              //주문 결재
    },
    /** 주문서 당일배송 오늘 하루 안보기 * */
    openQuickPopTodayOrder : function(){
        common.bann.setPopInfo("infoTodayDeliveryOrder", $("#infoTodayDeliveryOrder").attr("data-ref-compareKey"));
        setTimeout(function() {
            $("body").css("overflow", "visible");
        }, 100);
        $("#quickInfoYn").val("Y");
        $(document).scrollTop(0);
        common.popLayerClose('LAYERPOP02');
//        $("button[name=btnPay]").click();
        morder.orderForm.onClickSubmit();              //주문 결재
    },

    //3440969_PM작업시 오늘드림 레이어 팝업 노출 요청 건 - 팝업 이후에 처리할 프로세스
    continueAction : function(){//

    	if(rcvStr == 'order'){
			morder.orderForm.onClickSubmit();              //주문 결재
    	}else if(rcvStr == 'cart.orderPart'){
    		mcart.base.clickPartOrderBtn();                //장바구니 - 선택구매
    	}else if(rcvStr == 'goodsdetail.cart'){
    		mgoods.detail.clickBtnBasket();               //상품상세 - 장바구니 담기
    	}else if(rcvStr == 'goodsdetail.order'){
            mgoods.detail.clickBtnBuy();                  //상품상세 - 바로구매
     	}else if(rcvStr == 'cart.todayTab'){                 //장바구니, 오늘드립 탭 클릭
    		mcart.base.quick.clickUlDelivGbLi();
    	}//이외의 정보는 호출 URL이 없으므로, 팝업만 출력하고 끝나게 됨
    }
};

$.namespace('common.chatbot');
common.chatbot = {
    apiUrl : "",
    bSId : "",
    encMbrNo : "",
    maskMbrNm : "",
    initFlag : false,
    init : function(apiUrl, bSId, encMbrNo, maskMbrNm)  {
        common.chatbot.apiUrl = apiUrl;
        common.chatbot.bSId = bSId;
        common.chatbot.encMbrNo = encMbrNo;
        common.chatbot.maskMbrNm = maskMbrNm;
        common.chatbot.initFlag = true;
    },
    sendAwesomeBotApi : function(data) {
        if(!common.chatbot.initFlag) return;
        if(!common.isEmpty(data)) {
            if(!common.isEmpty(data.maskMbrNm)) common.chatbot.maskMbrNm = data.maskMbrNm;
            if(!common.isEmpty(data.encMbrNo)) common.chatbot.encMbrNo = data.encMbrNo;
        }
        if(common.isEmpty(common.chatbot.bSId)) return;
        if(common.isEmpty(common.chatbot.maskMbrNm)) return;
        if(common.isEmpty(common.chatbot.encMbrNo)) return;

        $.ajax({
            url: common.chatbot.apiUrl,
            type: 'POST',
            data: {
                "bSId": common.chatbot.bSId,
                "uId": common.chatbot.encMbrNo,
                "uName": this.maskingName(common.chatbot.maskMbrNm)
            },
            async: false,
            success: function(data){
                try {
                    void 0;
                    location.href = "kakaotalk://inappbrowser/close";
                    window.close();
                }
                catch(e){
                    void 0;
                }
            },
            error : function(e) {
                location.href = "kakaotalk://inappbrowser/close";
            }
        });
    },
    maskingName : function (strName) {
        if (strName.length > 2) {
            var originName = strName.split('');
            originName.forEach(function(name, i) {
                if (i === 0 || i === originName.length - 1) return;
                originName[i] = '*';
            });
            var joinName = originName.join();
            return joinName.replace(/,/g, '');
        } else {
            var pattern = /.$/; // 정규식
            return strName.replace(pattern, '*');
        }
    }
};


/*
 * 공통 타이머
 */
$.namespace('common.timer');
common.timer = {
    commonTimer : function() {
        if(!commonTimerInterval) {
            common.timer.setCommonTimer();
            commonTimerInterval = setInterval(common.timer.setCommonTimer, 1000);
        }
    },

    setCommonTimer : function() {
        var date = new Date();
        var now = date.getTime();
        var tomorrow = date;
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0);

        var distance = tomorrow - now
        commonTimer = common.timer.getTimerInfo(distance);
    },

    getTimerInfo : function (distance) {
        var time = {
            hours : '',
            minutes : '',
            seconds : ''
        }

        time.hours = common.timer.getTimerText(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        time.minutes = common.timer.getTimerText(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
        time.seconds = common.timer.getTimerText(Math.floor((distance % (1000 * 60)) / 1000));

        return time;
    },

    getTimerText : function (time) {
        return time < 10 && String(time).length <= 1 ? "0" + time : String(time);
    },
}

/****************************************
 * 드로워 브랜드 A/B test
 ****************************************/
$.namespace("common.drawerBrandAB");
common.drawerBrandAB = {
    BRAND_TAB_AB_TEST: "btabt",
    removeABTestData: function() {
        // http://cjics.cj.net/jira/browse/CJOYCOMM-1352
        // 추후 삭제 필요
        localStorage.removeItem(common.drawerBrandAB.BRAND_TAB_AB_TEST);
    }
};


/*--------------------------------------------------------------------------------*\
 * String Object Prototype
 \*--------------------------------------------------------------------------------*/
String.prototype.isEmpty = function() {
    return (this == null || this == '' || this == 'undefined' || this == 'null');
};
// alert("isEmpty="+"".isEmpty());

/**
 *
 * 숫자여부 체크 함. 사용 예)
 *
 * "100".isNumber() "-100,000".isNumber(1)
 *
 * @param opt
 *            1 : (Default)모든 10진수 2 : 부호 없음 3 : 부호/자릿수구분(",") 없음 4 :
 *            부호/자릿수구분(",")/소숫점
 *
 * @return true(정상) or false(오류-숫자아님)
 *
 */
String.prototype.isNumber = function(opt) {
    // 좌우 trim(공백제거)을 해준다.
    value = String(this).replace(/^\s+|\s+$/g, "");

    if (typeof opt == "undefined" || opt == "1") {
        // 모든 10진수 (부호 선택, 자릿수구분기호 선택, 소수점 선택)
        var regex = /^[+\-]?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+){1}(\.[0-9]+)?$/g;
    } else if (opt == "2") {
        // 부호 미사용, 자릿수구분기호 선택, 소수점 선택
        var regex = /^(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+){1}(\.[0-9]+)?$/g;
    } else if (opt == "3") {
        // 부호 미사용, 자릿수구분기호 미사용, 소수점 선택
        var regex = /^[0-9]+(\.[0-9]+)?$/g;
    } else {
        // only 숫자만(부호 미사용, 자릿수구분기호 미사용, 소수점 미사용)
        var regex = /^[0-9]$/g;
    }

    if (regex.test(value)) {
        value = value.replace(/,/g, "");
        return isNaN(value) ? false : true;
    } else {
        return false;
    }
};
// alert("isNumber="+("1-00".isNumber()));

String.prototype.nvl = function(s) {
    return this.isEmpty() ? (s ? s : '') : this + '';
};
String.prototype.startWith = function(str) {
    if (this === str)
        return true;

    if (str.length > 0)
        return str === this.substr(0, str.length);
    else
        return false;
};
String.prototype.endWith = function(str) {
    if (this == str)
        return true;

    if (String(str).length > 0)
        return str === this.substr(this.length - str.length, str.length);
    else
        return false;
};
String.prototype.bytes = function() { // 바이트 계산.
    var b = 0;
    for (var i = 0; i < this.length; i++)
        b += (this.charCodeAt(i) > 128) ? 2 : 1;
    return b;
};
String.prototype.nl2br = function() {
    return this.replace(/\n/g, "<br />");
};
String.prototype.toMoney = function() {
    var s = (this.nvl('0')).trim();
    if (isFinite(s)) {
        while ((/(-?[0-9]+)([0-9]{3})/).test(s)) {
            s = s.replace((/(-?[0-9]+)([0-9]{3})/), "$1,$2");
        }
        return s;
    } else {
        return this;
    }
};
String.prototype.toNegative = function() {
    return this == '0' ? this : "- " + this;
};

/**
 * val 문자열을 len 길이만큼 왼쪽에 char 문자를 붙여서 반환 한다.
 *
 * 사용 예) "A".lpad(5, "0") => "0000A"
 *
 * @param val
 *            문자열
 * @param len
 *            생성할 문자열 길이
 * @param char
 *            해당 길이만큼 왼쪽에 추가할 문자
 */
String.prototype.lpad = function(len, char) {
    var val = String(this);
    if (typeof (char) != "string" && typeof (len) != "number") {
        return val;
    }
    char = String(char);
    while (val.length + char.length <= len) {
        val = char + val;
    }

    return val;
};
// alert("A".lpad(5, "0"));

/**
 * val 문자열을 len 길이만큼 오른쪽에 char 문자를 붙여서 반환 한다.
 *
 * 사용 예) "A".rpad(5, "0") => "A0000"
 *
 * @param val
 *            문자열
 * @param len
 *            생성할 문자열 길이
 * @param char
 *            해당 길이만큼 오른쪽에 추가할 문자
 */
String.prototype.rpad = function(len, char) {
    var val = String(this);
    if (typeof (char) != "string" && typeof (len) != "number") {
        return val;
    }
    char = String(char);
    while (val.length + char.length <= len) {
        val = val + char;
    }

    return val;
};
// alert("A".rpad(5, "0"))

String.prototype.numberFormat = function() {
    // return this;
    // return $.number(this);
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

String.prototype.getBytesLength = function() {
    var s = this;
    for (b = i = 0; c = s.charCodeAt(i++); b += c >> 11 ? 3 : c >> 7 ? 2 : 1)
        ;
    return b;
};

String.prototype.getTransSpace = function() {
    return this.split(" ").join("&nbsp;");
};
/*--------------------------------------------------------------------------------*\
 * Number Object Prototype
 \*--------------------------------------------------------------------------------*/
Number.prototype.toMoney = function() {
    return String(this).toMoney();
};

Number.prototype.numberFormat = function() {
    // return this
    // return $.number(this);
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/**
 * val 문자열을 len 길이만큼 왼쪽에 char 문자를 붙여서 반환 한다.
 *
 * 사용 예) (123).lpad(5,"0") => "00123"
 *
 * @param val
 *            문자열
 * @param len
 *            생성할 문자열 길이
 * @param char
 *            해당 길이만큼 왼쪽에 추가할 문자
 */
Number.prototype.lpad = function(len, char) {
    return String(this).lpad(len, char);
};
// alert((123).lpad(5,"0"));

/**
 * val 문자열을 len 길이만큼 오른쪽에 char 문자를 붙여서 반환 한다.
 *
 * 사용 예) (123).rpad(5,"0") => "12300"
 *
 * @param val
 *            문자열
 * @param len
 *            생성할 문자열 길이
 * @param char
 *            해당 길이만큼 오른쪽에 추가할 문자
 */
Number.prototype.rpad = function(len, char) {
    return String(this).rpad(len, char);
}
// alert((123).rpad(5,"0"));

/*--------------------------------------------------------------------------------*\
 * Date Object Prototype
 \*--------------------------------------------------------------------------------*/
/**
 *
 * 포멧에 맞는 날짜 문자열을 꺼낸다.
 *
 * 사용 예) > new Date().format("yyyy-MM-dd hh:mm:ss E a/p") > => 2016-11-24
 * 11:00:31 목요일 오전
 *
 *
 *
 */
Date.prototype.format = function(format) {
    var weekName = [ "일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일" ];
    var d = this;

    if (!d.valueOf())
        return " ";
    if (format == undefined)
        return " ";
    format = String(format);

    return format.replace(/(yyyy|yy|MM|dd|E|hh|mm|ss|a\/p)/gi, function($1) {
        switch ($1) {
        case "yyyy":
            return d.getFullYear();
        case "yy":
            return (d.getFullYear() % 1000).lpad(2, "0");
        case "MM":
            return (d.getMonth() + 1).lpad(2, "0");
        case "dd":
            return d.getDate().lpad(2, "0");
        case "E":
            return weekName[d.getDay()];
        case "HH":
            return d.getHours().lpad(2, "0");
        case "hh":
            return ((h = d.getHours() % 12) ? h : 12).lpad(2, "0");
        case "mm":
            return d.getMinutes().lpad(2, "0");
        case "ss":
            return d.getSeconds().lpad(2, "0");
        case "a/p":
            return d.getHours() < 12 ? "오전" : "오후";
        default:
            return $1;
        }
    });
};
// alert(new Date().format("yyyy-MM-dd hh:mm:ss E a/p"));

/**
 * 일수를 계산한 날짜를 반환 한다.
 *
 * 사용 예) new Date().addDate(1); : 내일날짜 반환 new Date().addDate(0); : 오늘날짜 반환 new
 * Date().addDate(-1); : 어제날짜 반환
 *
 * @param dateCount
 *            더할 일수
 *
 * @return 계산되어 생성된 Date Object
 *
 */
Date.prototype.addDate = function(dateCount) {
    return new Date(this.valueOf() + (dateCount * (24 * 60 * 60 * 1000)));
};
// alert(new Date().addDate(1).addDate(1));

/*--------------------------------------------------------------------------------------*\
 * Cookie object
 * 2019.08.13_신종민_(SR : 3033094)_cName 분기처리 추가
 *  요구사항 : 모바일 홈 팝업배너 '하루동안 보지않기' 당일 23시 59분까지 보이지 않게 수정
 \*--------------------------------------------------------------------------------------*/
var Cookie = function(expiresDay) {
    var expdate = (typeof expiresDay == 'number') ? expiresDay : 1;
    return {
        get : function(cName) {
            cName = cName + '=';
            var cookieData = document.cookie;
            var start = cookieData.indexOf(cName);
            var cValue = '';
            if (start != -1) {
                start += cName.length;
                var end = cookieData.indexOf(';', start);
                if (end == -1)
                    end = cookieData.length;
                cValue = cookieData.substring(start, end);
            }
            return unescape(cValue);
        },
        set : function(cName, cValue, expireDays) {

            if (cName == 'popBannHistory') {

                // 현재일의 23시 59분을 파라미터로 던지기
                var d = new Date();
                var dY = d.getFullYear();
                var dM = (d.getMonth()).lpad(2, "0");
                var dD = d.getDate().lpad(2, "0");
                var hExpr = (((23 * 60) + 59) * 60 * 1000);

                var dt = new Date(dY, dM, dD);
                var param = dt.getTime() + hExpr;

                this.setOwner(cName, cValue, param)

            } else {
                this.setOwner(cName, cValue,
                        ((typeof expireDays == 'number' ? expireDays : expdate) * 24 * 60 * 60 * 1000))
            }
            return this;
        },
        setOwner : function(cName, cValue, expire) {
            var expdate = new Date();

            if (cName == 'popBannHistory') {
                expdate.setTime(expire);
                /* 3201008 안드로이드 앱, 모바일 팝업배너 '하루보지 않기' 동작 오류 */
                common.app.syncCookie(); //앱-웹간 Cookie등 동기화 수행
            } else {
                expdate.setTime(expdate.getTime()
                        + (typeof expire == 'number' ? expire : (expdate * 24 * 60 * 60 * 1000)));
            }

            document.cookie = cName + "=" + cValue + "; path=/; domain=" + document.domain + "; expires="
                    + expdate.toGMTString();
        },
        remove : function(name) {
            return this.set(name, '', -1);
        },
        getItem : function(name) {
            return this.get(name);
        },
        setItem : function(name, value) {
            this.set(name, value);
        },
        removeItem : function(name) {
            this.remove(name);
        },
        clear : function() {
            return;
        }
    };
};

/*--------------------------------------------------------------------------------*\
 * Cache object
 \*--------------------------------------------------------------------------------*/
var Cache = function(type, span/* integer */, format/* s, m, h, d, M, y, w */) {
    var _cacheType = (typeof type != 'string' || type == '') ? 'cache' : type; // cache
    // ||
    // local
    // ||
    // session
    var _span = (typeof span == 'number') ? span : 0;
    var _format = (typeof format == 'string') ? format : '';
    var _storage = null;
    var _expires = getCacheExpires(_span, _format);
    var _default = {
        set : function() {
            return;
        },
        get : function() {
            return '';
        },
        isStatus : function() {
            return false;
        },
        remove : function() {
            return;
        },
        clear : function() {
            return;
        }
    };

    if (_cacheType == 'session') {
        if (!window.sessionStorage)
            return _default;
        _storage = window.sessionStorage;
        _expires = (_span != 0) ? _expires : getCacheExpires(12, 'h'); // 12
        // hours
    } else if (_cacheType == 'cache') {
        if (!window.localStorage)
            return _default;
        _storage = window.sessionStorage;
        _expires = (_span != 0) ? _expires : getCacheExpires(5, 'm'); // 5
        // minutes
    } else if (_cacheType == 'local') {
        if (!window.localStorage)
            return _default;
        _storage = window.localStorage;
        _expires = (_span != 0) ? _expires : getCacheExpires(7, 'd'); // 7
        // days
    } else if (_cacheType == 'cookie') {
        _storage = com.lotte.smp.Cookie(1);
        _expires = (_span != 0) ? _expires : getCacheExpires(1, 'd'); // 1
        // days
    } else {
        return _default;
    }

    function getCacheExpires(s, f) {
        var exp = 0;
        switch (f) {
        case 's':
            exp = 1;
            break;
        case 'm':
            exp = 60;
            break;
        case 'h':
            exp = 3600;
            break; // 60 * 60
        case 'd':
            exp = 86400;
            break; // 60 * 60 * 24
        case 'w':
            exp = 604800;
            break; // 60 * 60 * 24 * 7
        case 'M':
            exp = 2592000;
            break; // 60 * 60 * 24 * 30
        case 'y':
            exp = 31536000;
            break; // 60 * 60 * 24 * 365
        }
        return s * exp;
    }

    return {
        type : _cacheType,
        storage : _storage,
        expires : _expires,
        set : function(name, value, expires) {
            if (typeof name != 'string' || name == '')
                return;
            if (value == 'undefined')
                return;
            if (expires == 'undefined' || typeof expires != 'number') {
                expires = this.expires;
            }

            var date = new Date();
            var schedule = Math.round((date.setSeconds(date.getSeconds() + expires)) / 1000);

            this.storage.setItem(this.type + '@' + name, value);
            this.storage.setItem(this.type + '@time_' + name, schedule);

            return this;
        },
        get : function(name) {
            if (this.isStatus(name)) {
                return this.storage.getItem(this.type + '@' + name);
            } else {
                return '';
            }
        },
        isStatus : function(name) {
            if (this.storage.getItem(this.type + '@' + name) == null
                    || this.storage.getItem(this.type + '@' + name) == '')
                return false;

            var date = new Date();
            var current = Math.round(+date / 1000);

            // Get Schedule
            var stored_time = this.storage.getItem(this.type + '@time_' + name);
            if (stored_time == 'undefined' || stored_time == 'null') {
                stored_time = 0;
            }

            // Expired
            if (stored_time < current) {
                this.remove(name);
                return false;
            } else {
                return true;
            }
        },
        remove : function(name) {
            this.storage.removeItem(this.type + '@' + name);
            this.storage.removeItem(this.type + '@time_' + name);
        },
        clear : function() {
            for ( var item in this.storage) {
                if (String(item).startWith(this.type)) {
                    this.storage.removeItem(item);
                }
            }
            // this.storage.clear();
        }
    };
};

jQuery.fn.serializeObject = function() {
    var obj = null;
    try {
        if (this[0].tagName && this[0].tagName.toUpperCase() == "FORM") {
            var arr = this.serializeArray();
            if (arr) {
                obj = {};
                jQuery.each(arr, function() {
                    obj[this.name] = this.value;
                });
            }
        }
    } catch (e) {
    } finally {
    }

    return obj;
};

var lazyloadSeq = {
    data_attribute : "original",
    selector : "",
    replaceClassNm : "",

    load : function(selector, classNm) {
        lazyloadSeq.selector = selector;
        lazyloadSeq.replaceClassNm = classNm;

        var imgList = $(lazyloadSeq.selector);
        var imgCnt = imgList.length;

        lazyloadSeq.loadRecursive(0, imgCnt, imgList);
    },

    loadRecursive : function(curImgIdx, imgCnt, list) {
        if (curImgIdx == undefined || curImgIdx == null) {
            curImgIdx = 0;
        }

        var targetImgCnt = imgCnt;

        if (targetImgCnt > curImgIdx) {
            var dstImg = list.eq(curImgIdx);
            var imgSrc = dstImg.attr("data-" + lazyloadSeq.data_attribute);

            if (dstImg.is("img")) {
                dstImg.attr("src", imgSrc);
            } else {
                dstImg.css("background-image", "url('" + imgSrc + "')");
            }

            dstImg.removeClass(lazyloadSeq.replaceClassNm).addClass("completed-" + lazyloadSeq.replaceClassNm);
            // console.log("img load : " + imgSrc);
            // setTimeout(function() {
            lazyloadSeq.loadRecursive(++curImgIdx, targetImgCnt, list);
            // }, 10);
        }
    }

};

var scrollTrigger = {
    scrollStarted : false,
    scrollLooper : null,

    init : function() {
        document.addEventListener('touchmove', function() {

            if (scrollTrigger.scrollLooper != null) {
                clearInterval(scrollTrigger.scrollLooper);
            }

            scrollTrigger.scrollStarted = true;
            scrollTrigger.scrollLooper = setInterval(function() {
                $(window).trigger("scroll");
                // console.log("trigger scroll");
            }, 200)
        });
        document.addEventListener('touchend', function() {
            scrollTrigger.scrollStarted = false;
            $(window).trigger("scroll");
            setTimeout(function() {
                if (scrollTrigger.scrollStarted == false) {
                    clearInterval(scrollTrigger.scrollLooper);
                    void 0;

                    scrollTrigger.scrollLooper = null;
                }
            }, 1000);
        });
    }
};

$(function() {
    common.cart.trackingInfo.setGateCd();
});
